import * as i0 from '@angular/core';
import { inject, DestroyRef, input, output, signal, computed, Component, ChangeDetectionStrategy } from '@angular/core';
import { convertNonEnglishDigits } from '@digipay/strings';
import { NgClass } from '@angular/common';
import * as i1 from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { AnimationLoader, provideLottieOptions, LottieComponent } from 'ngx-lottie';
import player from 'lottie-web/build/player/lottie_light';
import { NgxHybridService } from '@digipay/ngx-hybrid-service';
import { toObservable, takeUntilDestroyed } from '@angular/core/rxjs-interop';
const _c0 = a0 => ({
  animationData: a0
});
const _c1 = (a0, a1) => ({
  "no-content": a0,
  "text-onback-brand": a1
});
const _c2 = a0 => ({
  "text-onback-error": a0
});
function NgxPin_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵelement(1, "div", 11)(2, "ng-lottie", 12);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("options", i0.ɵɵpureFunction1(1, _c0, ctx_r0.pinAnimation()));
  }
}
function NgxPin_For_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8)(1, "span", 13);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const pin_r2 = ctx.$implicit;
    const $index_r3 = ctx.$index;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(2, _c1, pin_r2 === "-", $index_r3 === ctx_r0.hiddenInputValue().length && ctx_r0.isFocus()));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(pin_r2 === "-" ? "-" : "\u25CF");
  }
}
function NgxPin_Conditional_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 9);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c2, ctx_r0.enterPasswordState() === ctx_r0.EnterPasswordEnum.WRONG));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.hint(), " ");
  }
}
function NgxPin_Conditional_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵlistener("click", function NgxPin_Conditional_12_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r0 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r0.enterPinWithBiometric());
    });
    i0.ɵɵelement(1, "span", 15);
    i0.ɵɵelementStart(2, "p", 16);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.biometricText());
  }
}
var PinComponentStateEnum = /*#__PURE__*/function (PinComponentStateEnum) {
  PinComponentStateEnum[PinComponentStateEnum["OLD"] = 0] = "OLD";
  PinComponentStateEnum[PinComponentStateEnum["NEW"] = 1] = "NEW";
  PinComponentStateEnum[PinComponentStateEnum["CONFIRM"] = 2] = "CONFIRM";
  PinComponentStateEnum[PinComponentStateEnum["PAY"] = 3] = "PAY";
  return PinComponentStateEnum;
}(PinComponentStateEnum || {});
var EnterPasswordEnum = /*#__PURE__*/function (EnterPasswordEnum) {
  EnterPasswordEnum[EnterPasswordEnum["ENTER"] = 0] = "ENTER";
  EnterPasswordEnum[EnterPasswordEnum["CORRECT"] = 1] = "CORRECT";
  EnterPasswordEnum[EnterPasswordEnum["WRONG"] = 2] = "WRONG";
  return EnterPasswordEnum;
}(EnterPasswordEnum || {});
const BiometricStorageKey = 'hasBiometric';
const SetPasswordStorageKey = 'isSetPassword';
const EnterPasswordAnimationConst = {
  "v": "5.7.5",
  "fr": 100,
  "ip": 0,
  "op": 120,
  "w": 171,
  "h": 171,
  "nm": "Comp 1",
  "ddd": 0,
  "metadata": {
    "lottielabInteractivity": {
      "__version": "v1",
      "initialState": "Typing",
      "states": {
        "Typing": {
          "segment": [0, 1.2],
          "speed": 1,
          "direction": "forward",
          "loop": true
        },
        "Wrong": {
          "segment": [1.57, 3.22],
          "speed": 1,
          "direction": "forward",
          "loop": false
        },
        "Correct": {
          "segment": [3.22, 4.5],
          "speed": 1,
          "direction": "forward",
          "loop": false
        }
      }
    }
  },
  "assets": [{
    "id": "0",
    "layers": [{
      "ddd": 0,
      "ind": 1,
      "ty": 4,
      "nm": "Blur",
      "sr": 1,
      "ks": {
        "p": {
          "a": 0,
          "k": [4, 4],
          "ix": 2
        },
        "a": {
          "a": 0,
          "k": [0, 0],
          "ix": 2
        },
        "s": {
          "a": 0,
          "k": [100, 100],
          "ix": 2
        },
        "r": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "o": {
          "a": 0,
          "k": 100,
          "ix": 2
        },
        "sk": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "sa": {
          "a": 0,
          "k": 0,
          "ix": 2
        }
      },
      "ao": 0,
      "shapes": [{
        "ty": "gr",
        "it": [{
          "ty": "gr",
          "nm": "Blur",
          "it": [{
            "ty": "gr",
            "nm": "Path",
            "it": [{
              "ty": "sh",
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "v": [[43.43000030517578, 21.71500015258789], [21.71500015258789, 43.43000030517578], [0, 21.71500015258789], [21.71500015258789, 0], [43.43000030517578, 21.71500015258789]],
                  "i": [[43.43000030517578, 21.71500015258789], [33.7078630647702, 43.43000030517578], [0, 33.7078630647702], [9.722137240405582, 0], [43.43000030517578, 9.722137240405582]],
                  "o": [[43.43000030517578, 33.7078630647702], [9.722137240405582, 43.43000030517578], [0, 9.722137240405582], [33.7078630647702, 0], [43.43000030517578, 21.71500015258789]]
                }
              },
              "_render": true
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [21.71500015258789, 21.71500015258789],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [21.71500015258789, 21.71500015258789],
                "ix": 2
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 2
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 2
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "_render": true
            }],
            "_render": true
          }, {
            "ty": "gr",
            "nm": "Path",
            "it": [{
              "ty": "sh",
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "v": [[1.0617037320242593, 21.234059169880997], [21.234059169880997, 41.40641460773774], [41.40641460773774, 21.234059169880997], [21.234059169880997, 1.0617037320242593], [1.0617037320242593, 21.234059169880997]],
                  "i": [[1.0617037320242593, 21.234059169880997], [10.093174299672262, 41.40641460773774], [41.40641460773774, 32.37494404008973], [32.37494404008973, 1.0617037320242593], [1.0617037320242593, 10.093174299672262]],
                  "o": [[1.0617037320242593, 32.37494404008973], [32.37494404008973, 41.40641460773774], [41.40641460773774, 10.093174299672262], [10.093174299672262, 1.0617037320242593], [1.0617037320242593, 21.234059169880997]]
                }
              },
              "_render": true
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [21.714996337890625, 21.714996337890625],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [21.234059169881, 21.234059169881],
                "ix": 2
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 2
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 2
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "_render": true
            }],
            "_render": true
          }, {
            "ty": "fl",
            "c": {
              "a": 0,
              "k": [0, 0, 0],
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "r": 1,
            "bm": 0,
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [0, 0],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [0, 0],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "tr",
          "p": {
            "a": 0,
            "k": [21.715782165527344, 21.715003967285156],
            "ix": 2
          },
          "a": {
            "a": 0,
            "k": [21.71500015258789, 21.71500015258789],
            "ix": 2
          },
          "s": {
            "a": 0,
            "k": [100, 100],
            "ix": 2
          },
          "r": {
            "a": 0,
            "k": 1.8762201477034328e-7,
            "ix": 2
          },
          "o": {
            "a": 0,
            "k": 100,
            "ix": 2
          },
          "sk": {
            "a": 0,
            "k": 0,
            "ix": 2
          },
          "sa": {
            "a": 0,
            "k": 0,
            "ix": 2
          },
          "_render": true
        }],
        "_render": true
      }],
      "ip": 0,
      "op": 121,
      "st": 0,
      "bm": 0,
      "completed": true
    }, {
      "ddd": 0,
      "ind": 2,
      "ty": 4,
      "nm": "Blur Overscan",
      "sr": 1,
      "ks": {
        "p": {
          "a": 0,
          "k": [0, 0],
          "ix": 2
        },
        "a": {
          "a": 0,
          "k": [0, 0],
          "ix": 2
        },
        "s": {
          "a": 0,
          "k": [100, 100],
          "ix": 2
        },
        "r": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "o": {
          "a": 0,
          "k": 100,
          "ix": 2
        },
        "sk": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "sa": {
          "a": 0,
          "k": 0,
          "ix": 2
        }
      },
      "ao": 0,
      "shapes": [{
        "ty": "rc",
        "d": 1,
        "s": {
          "a": 0,
          "k": [52, 52],
          "ix": 2
        },
        "p": {
          "a": 0,
          "k": [26, 26],
          "ix": 2
        },
        "r": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "_render": true
      }, {
        "ty": "fl",
        "c": {
          "a": 0,
          "k": [0, 0, 0],
          "ix": 2
        },
        "o": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "r": 1,
        "bm": 0,
        "_render": true
      }],
      "ip": 0,
      "op": 121,
      "st": 0,
      "bm": 0,
      "completed": true
    }]
  }, {
    "id": "1",
    "layers": [{
      "ddd": 0,
      "ind": 3,
      "ty": 4,
      "nm": "Blur",
      "sr": 1,
      "ks": {
        "p": {
          "a": 0,
          "k": [-161, -161],
          "ix": 2
        },
        "a": {
          "a": 0,
          "k": [0, 0],
          "ix": 2
        },
        "s": {
          "a": 0,
          "k": [100, 100],
          "ix": 2
        },
        "r": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "o": {
          "a": 0,
          "k": 100,
          "ix": 2
        },
        "sk": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "sa": {
          "a": 0,
          "k": 0,
          "ix": 2
        }
      },
      "ao": 0,
      "shapes": [{
        "ty": "gr",
        "it": [{
          "ty": "gr",
          "nm": "Blur",
          "it": [{
            "ty": "gr",
            "nm": "Path",
            "it": [{
              "ty": "sh",
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "v": [[62.83000183105469, 31.415000915527344], [31.415000915527344, 62.83000183105469], [0, 31.415000915527344], [31.415000915527344, 0], [62.83000183105469, 31.415000915527344]],
                  "i": [[62.83000183105469, 31.415000915527344], [48.7650260925293, 62.83000183105469], [0, 48.7650260925293], [14.06497573852539, 0], [62.83000183105469, 14.06497573852539]],
                  "o": [[62.83000183105469, 48.7650260925293], [14.06497573852539, 62.83000183105469], [0, 14.06497573852539], [48.7650260925293, 0], [62.83000183105469, 31.415000915527344]]
                }
              },
              "_render": true
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [31.415000915527344, 31.415000915527344],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [31.415000915527344, 31.415000915527344],
                "ix": 2
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 2
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 2
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "_render": true
            }],
            "_render": true
          }, {
            "ty": "gr",
            "nm": "Path",
            "it": [{
              "ty": "sh",
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "v": [[1.5707511901855469, 31.415000915527344], [31.415000915527344, 61.25925064086914], [61.25925064086914, 31.415000915527344], [31.415000915527344, 1.5707511901855469], [1.5707511901855469, 31.415000915527344]],
                  "i": [[1.5707511901855469, 31.415000915527344], [14.932476043701172, 61.25925064086914], [61.25925064086914, 47.897525787353516], [47.897525787353516, 1.5707511901855469], [1.5707511901855469, 14.932476043701172]],
                  "o": [[1.5707511901855469, 47.897525787353516], [47.897525787353516, 61.25925064086914], [61.25925064086914, 14.932476043701172], [14.932476043701172, 1.5707511901855469], [1.5707511901855469, 31.415000915527344]]
                }
              },
              "_render": true
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [31.415000915527344, 31.415000915527344],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [31.415000915527344, 31.415000915527344],
                "ix": 2
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 2
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 2
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "_render": true
            }],
            "_render": true
          }, {
            "ty": "fl",
            "c": {
              "a": 0,
              "k": [0.7098039215686275, 0.7019607843137254, 0.9490196078431372],
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 80,
              "ix": 2
            },
            "r": 1,
            "bm": 0,
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [0, 0],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [0, 0],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "tr",
          "p": {
            "a": 0,
            "k": [197.81288146972656, 197.81520080566406],
            "ix": 2
          },
          "a": {
            "a": 0,
            "k": [31.415000915527344, 31.415000915527344],
            "ix": 2
          },
          "s": {
            "a": 0,
            "k": [100, 100],
            "ix": 2
          },
          "r": {
            "a": 0,
            "k": 1.8762198932590582e-7,
            "ix": 2
          },
          "o": {
            "a": 0,
            "k": 100,
            "ix": 2
          },
          "sk": {
            "a": 0,
            "k": 0,
            "ix": 2
          },
          "sa": {
            "a": 0,
            "k": 0,
            "ix": 2
          },
          "_render": true
        }],
        "_render": true
      }],
      "ip": 0,
      "op": 121,
      "st": 0,
      "bm": 0,
      "completed": true
    }, {
      "ddd": 0,
      "ind": 4,
      "ty": 4,
      "nm": "Blur Overscan",
      "sr": 1,
      "ks": {
        "p": {
          "a": 0,
          "k": [0, 0],
          "ix": 2
        },
        "a": {
          "a": 0,
          "k": [0, 0],
          "ix": 2
        },
        "s": {
          "a": 0,
          "k": [100, 100],
          "ix": 2
        },
        "r": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "o": {
          "a": 0,
          "k": 100,
          "ix": 2
        },
        "sk": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "sa": {
          "a": 0,
          "k": 0,
          "ix": 2
        }
      },
      "ao": 0,
      "shapes": [{
        "ty": "rc",
        "d": 1,
        "s": {
          "a": 0,
          "k": [74, 74],
          "ix": 2
        },
        "p": {
          "a": 0,
          "k": [37, 37],
          "ix": 2
        },
        "r": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "_render": true
      }, {
        "ty": "fl",
        "c": {
          "a": 0,
          "k": [0, 0, 0],
          "ix": 2
        },
        "o": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "r": 1,
        "bm": 0,
        "_render": true
      }],
      "ip": 0,
      "op": 121,
      "st": 0,
      "bm": 0,
      "completed": true
    }]
  }, {
    "id": "2",
    "u": "",
    "p": "data:image/png;base64,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",
    "w": 249,
    "h": 271,
    "e": 1
  }],
  "layers": [{
    "ddd": 0,
    "ind": 5,
    "ty": 3,
    "nm": "Lock",
    "sr": 1,
    "ks": {
      "p": {
        "a": 0,
        "k": [85.10450744628906, 83.90176391601562],
        "ix": 2
      },
      "a": {
        "a": 0,
        "k": [0, 0],
        "ix": 2
      },
      "s": {
        "a": 1,
        "k": [{
          "t": 160,
          "s": [100, 100],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          }
        }, {
          "t": 175,
          "s": [90, 90],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          }
        }, {
          "t": 185,
          "s": [100, 100],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          }
        }, {
          "t": 330,
          "s": [100, 100],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          }
        }, {
          "t": 350,
          "s": [80, 80],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          }
        }, {
          "t": 370,
          "s": [100, 100],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          }
        }],
        "ix": 2
      },
      "r": {
        "a": 1,
        "k": [{
          "t": 175,
          "s": [0],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          }
        }, {
          "t": 185,
          "s": [10],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          }
        }, {
          "t": 195,
          "s": [-10],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          }
        }, {
          "t": 202,
          "s": [8],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          }
        }, {
          "t": 209,
          "s": [-8],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          }
        }, {
          "t": 214,
          "s": [6],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          }
        }, {
          "t": 219,
          "s": [-6],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          }
        }, {
          "t": 223,
          "s": [3],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          }
        }, {
          "t": 227,
          "s": [-3],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          }
        }, {
          "t": 229,
          "s": [1],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          }
        }, {
          "t": 233,
          "s": [-1],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          }
        }, {
          "t": 235,
          "s": [0],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          }
        }, {
          "t": 330,
          "s": [0],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          }
        }, {
          "t": 350,
          "s": [0],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          }
        }, {
          "t": 370,
          "s": [-4],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          }
        }],
        "ix": 2
      },
      "o": {
        "a": 0,
        "k": 100,
        "ix": 2
      },
      "sk": {
        "a": 0,
        "k": 0,
        "ix": 2
      },
      "sa": {
        "a": 0,
        "k": 0,
        "ix": 2
      }
    },
    "ao": 0,
    "ip": 0,
    "op": 121,
    "st": 0,
    "bm": 0,
    "completed": true
  }, {
    "ddd": 0,
    "ind": 6,
    "ty": 3,
    "nm": "Badane",
    "sr": 1,
    "ks": {
      "p": {
        "a": 1,
        "k": [{
          "t": 350,
          "s": [1.6947784423828125, 18.566986083984375],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          }
        }, {
          "t": 370,
          "s": [3.689906597137451, 18.706499099731445],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          }
        }],
        "ix": 2
      },
      "a": {
        "a": 0,
        "k": [0, 0],
        "ix": 2
      },
      "s": {
        "a": 0,
        "k": [99.99999668543774, 99.99999668543774],
        "ix": 2
      },
      "r": {
        "a": 1,
        "k": [{
          "t": 350,
          "s": [3.999999525469073],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          }
        }, {
          "t": 370,
          "s": [-11],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          }
        }],
        "ix": 2
      },
      "o": {
        "a": 0,
        "k": 100,
        "ix": 2
      },
      "sk": {
        "a": 0,
        "k": 0,
        "ix": 2
      },
      "sa": {
        "a": 0,
        "k": 0,
        "ix": 2
      }
    },
    "ao": 0,
    "ip": 0,
    "op": 121,
    "st": 0,
    "bm": 0,
    "parent": 5,
    "completed": true
  }, {
    "ddd": 0,
    "ind": 7,
    "ty": 4,
    "nm": "Middle Circle",
    "sr": 1,
    "ks": {
      "p": {
        "a": 0,
        "k": [0, 0],
        "ix": 2
      },
      "a": {
        "a": 0,
        "k": [0, 0],
        "ix": 2
      },
      "s": {
        "a": 0,
        "k": [100, 100],
        "ix": 2
      },
      "r": {
        "a": 0,
        "k": 0,
        "ix": 2
      },
      "o": {
        "a": 0,
        "k": 100,
        "ix": 2
      },
      "sk": {
        "a": 0,
        "k": 0,
        "ix": 2
      },
      "sa": {
        "a": 0,
        "k": 0,
        "ix": 2
      }
    },
    "ao": 0,
    "parent": 6,
    "shapes": [{
      "ty": "gr",
      "it": [{
        "ty": "gr",
        "nm": "Circle A",
        "it": [{
          "ty": "sh",
          "d": 1,
          "ks": {
            "a": 0,
            "k": {
              "c": true,
              "v": [[13.647854804992676, 6.823927402496338], [6.823927402496338, 13.647854804992676], [0, 6.823927402496338], [6.823927402496338, 0], [13.647854804992676, 6.823927402496338]],
              "i": [[13.647854804992676, 6.823927402496338], [10.592678620604888, 13.647854804992676], [0, 10.592678620604888], [3.0551761843877885, 0], [13.647854804992676, 3.0551761843877885]],
              "o": [[13.647854804992676, 10.592678620604888], [3.0551761843877885, 13.647854804992676], [0, 3.0551761843877885], [10.592678620604888, 0], [13.647854804992676, 6.823927402496338]]
            }
          },
          "_render": true
        }, {
          "ty": "st",
          "c": {
            "a": 0,
            "k": [0.49411764705882355, 0.49411764705882355, 0.49411764705882355],
            "ix": 2
          },
          "o": {
            "a": 0,
            "k": 100,
            "ix": 2
          },
          "w": {
            "a": 0,
            "k": 0.20000000298023224,
            "ix": 2
          },
          "lc": 2,
          "lj": 1,
          "ml": 4,
          "_render": true
        }, {
          "ty": "tr",
          "p": {
            "a": 0,
            "k": [-0.0008451848407275975, 0.1417044699192047],
            "ix": 2
          },
          "a": {
            "a": 0,
            "k": [6.823927402496338, 6.823927402496338],
            "ix": 2
          },
          "s": {
            "a": 0,
            "k": [100, -100],
            "ix": 2
          },
          "r": {
            "a": 0,
            "k": 180,
            "ix": 2
          },
          "o": {
            "a": 0,
            "k": 40.00000059604645,
            "ix": 2
          },
          "sk": {
            "a": 0,
            "k": 0,
            "ix": 2
          },
          "sa": {
            "a": 0,
            "k": 0,
            "ix": 2
          },
          "_render": true
        }],
        "_render": true
      }, {
        "ty": "gr",
        "nm": "Cicle B",
        "it": [{
          "ty": "sh",
          "d": 1,
          "ks": {
            "a": 0,
            "k": {
              "c": true,
              "v": [[8.86856460571289, 0], [17.73712921142578, 8.869507040676757], [8.86856460571289, 17.73807144165039], [0, 8.869507040676757], [8.86856460571289, 0]],
              "i": [[8.86856460571289, 0], [17.73712921142578, 3.971604110622632], [13.766467648839768, 17.73807144165039], [0, 13.767409970730881], [3.9697202694893052, 0]],
              "o": [[13.766467648839768, 0], [17.73712921142578, 13.767409970730881], [3.9697202694893052, 17.73807144165039], [0, 3.971604110622632], [8.86856460571289, 0]]
            }
          },
          "_render": true
        }, {
          "ty": "gf",
          "o": {
            "a": 0,
            "k": 100,
            "ix": 2
          },
          "r": 1,
          "bm": 0,
          "g": {
            "p": 2,
            "k": {
              "a": 0,
              "k": [0, 0.10980392156862745, 0.10980392156862745, 0.10980392156862745, 1, 0.35294117647058826, 0.35294117647058826, 0.35294117647058826, 0, 1, 1, 1],
              "ix": 2
            }
          },
          "s": {
            "a": 0,
            "k": [13.157401572815616, 16.89004670104441],
            "ix": 2
          },
          "e": {
            "a": 0,
            "k": [5.555846583042921, 0.016679778670152245],
            "ix": 2
          },
          "t": 1,
          "_render": true
        }, {
          "ty": "tr",
          "p": {
            "a": 0,
            "k": [-0.0025287296157330275, -0.0019147867569699883],
            "ix": 2
          },
          "a": {
            "a": 0,
            "k": [8.86856460571289, 8.869035720825195],
            "ix": 2
          },
          "s": {
            "a": 0,
            "k": [100, -100],
            "ix": 2
          },
          "r": {
            "a": 0,
            "k": 180,
            "ix": 2
          },
          "o": {
            "a": 0,
            "k": 100,
            "ix": 2
          },
          "sk": {
            "a": 0,
            "k": 0,
            "ix": 2
          },
          "sa": {
            "a": 0,
            "k": 0,
            "ix": 2
          },
          "_render": true
        }],
        "_render": true
      }, {
        "ty": "gr",
        "nm": "Citcle 3",
        "it": [{
          "ty": "sh",
          "d": 1,
          "ks": {
            "a": 0,
            "k": {
              "c": true,
              "v": [[12.03059693778647, 0], [24.060251235961914, 12.029655195927457], [12.03059693778647, 24.060251235961914], [0, 12.029655195927457], [12.03059693778647, 0]],
              "i": [[12.03059693778647, 0], [24.060251235961914, 5.386468970891877], [18.674724455805055, 24.060251235961914], [0, 18.673782713946046], [5.386469419767883, 0]],
              "o": [[18.674724455805055, 0], [24.060251235961914, 18.673782713946046], [5.386469419767883, 24.060251235961914], [0, 5.386468970891877], [12.03059693778647, 0]]
            }
          },
          "_render": true
        }, {
          "ty": "gf",
          "o": {
            "a": 0,
            "k": 100,
            "ix": 2
          },
          "r": 1,
          "bm": 0,
          "g": {
            "p": 2,
            "k": {
              "a": 0,
              "k": [0, 0, 0, 0, 1, 0.12941176470588237, 0.10588235294117647, 0.19607843137254902, 0, 1, 1, 1],
              "ix": 2
            }
          },
          "s": {
            "a": 0,
            "k": [17.847893178252207, 22.909974646964656],
            "ix": 2
          },
          "e": {
            "a": 0,
            "k": [7.536454350818133, 0.02262476316460038],
            "ix": 2
          },
          "t": 1,
          "_render": true
        }, {
          "ty": "tr",
          "p": {
            "a": 0,
            "k": [-9.894472441374091e-7, 1.9125218386761844e-7],
            "ix": 2
          },
          "a": {
            "a": 0,
            "k": [12.030125617980957, 12.030125617980957],
            "ix": 2
          },
          "s": {
            "a": 0,
            "k": [100, -100],
            "ix": 2
          },
          "r": {
            "a": 0,
            "k": 180,
            "ix": 2
          },
          "o": {
            "a": 0,
            "k": 100,
            "ix": 2
          },
          "sk": {
            "a": 0,
            "k": 0,
            "ix": 2
          },
          "sa": {
            "a": 0,
            "k": 0,
            "ix": 2
          },
          "_render": true
        }],
        "_render": true
      }, {
        "ty": "tr",
        "p": {
          "a": 0,
          "k": [-1.2999141216278076, 0.036949798464775085],
          "ix": 2
        },
        "a": {
          "a": 0,
          "k": [-9.5367431640625e-7, 0],
          "ix": 2
        },
        "s": {
          "a": 0,
          "k": [100.00000268335543, 100.00000268335545],
          "ix": 2
        },
        "r": {
          "a": 0,
          "k": -3.999999525469093,
          "ix": 2
        },
        "o": {
          "a": 0,
          "k": 100,
          "ix": 2
        },
        "sk": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "sa": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "_render": true
      }],
      "_render": true
    }],
    "ip": 0,
    "op": 121,
    "st": 0,
    "bm": 0,
    "completed": true
  }, {
    "ddd": 0,
    "ind": 8,
    "ty": 4,
    "nm": "Pointer",
    "sr": 1,
    "ks": {
      "p": {
        "a": 0,
        "k": [0, 0],
        "ix": 2
      },
      "a": {
        "a": 0,
        "k": [0, 0],
        "ix": 2
      },
      "s": {
        "a": 0,
        "k": [100, 100],
        "ix": 2
      },
      "r": {
        "a": 0,
        "k": 0,
        "ix": 2
      },
      "o": {
        "a": 0,
        "k": 100,
        "ix": 2
      },
      "sk": {
        "a": 0,
        "k": 0,
        "ix": 2
      },
      "sa": {
        "a": 0,
        "k": 0,
        "ix": 2
      }
    },
    "ao": 0,
    "parent": 6,
    "shapes": [{
      "ty": "gr",
      "nm": "Pointer",
      "it": [{
        "ty": "sh",
        "d": 1,
        "ks": {
          "a": 0,
          "k": {
            "c": true,
            "v": [[0, 0.003765621092503116], [2.823142290115356, 0], [1.463816607853733, 3.077310085296631], [0, 0.003765621092503116]],
            "i": [[0, 0.003765621092503116], [2.823142290115356, 0], [1.463816607853733, 3.077310085296631], [0, 0.003765621092503116]],
            "o": [[0, 0.003765621092503116], [2.823142290115356, 0], [1.463816607853733, 3.077310085296631], [0, 0.003765621092503116]]
          }
        },
        "_render": true
      }, {
        "ty": "fl",
        "c": {
          "a": 0,
          "k": [1, 0.2235294117647059, 0],
          "ix": 2
        },
        "o": {
          "a": 0,
          "k": 100,
          "ix": 2
        },
        "r": 1,
        "bm": 0,
        "_render": true
      }, {
        "ty": "tr",
        "p": {
          "a": 1,
          "k": [{
            "t": 350,
            "s": [-3.042144775390625, -24.878170013427734],
            "i": {
              "x": [0.75],
              "y": [0.75]
            },
            "o": {
              "x": [0.25],
              "y": [0.25]
            }
          }, {
            "t": 370,
            "s": [-3.122174147516489, -25.249699592590332],
            "i": {
              "x": [0.75],
              "y": [0.75]
            },
            "o": {
              "x": [0.25],
              "y": [0.25]
            }
          }],
          "ix": 2
        },
        "a": {
          "a": 0,
          "k": [1.411571145057678, 1.538655042648315],
          "ix": 2
        },
        "s": {
          "a": 0,
          "k": [100.00000268335543, 100.00000268335545],
          "ix": 2
        },
        "r": {
          "a": 1,
          "k": [{
            "t": 330,
            "s": [-3.999999713091089],
            "i": {
              "x": [0.75],
              "y": [0.75]
            },
            "o": {
              "x": [0.25],
              "y": [0.25]
            }
          }, {
            "t": 350,
            "s": [-3.999999713091089],
            "i": {
              "x": [0.75],
              "y": [0.75]
            },
            "o": {
              "x": [0.25],
              "y": [0.25]
            }
          }, {
            "t": 370,
            "s": [-8.999999525469075],
            "i": {
              "x": [0.75],
              "y": [0.75]
            },
            "o": {
              "x": [0.25],
              "y": [0.25]
            }
          }],
          "ix": 2
        },
        "o": {
          "a": 0,
          "k": 100,
          "ix": 2
        },
        "sk": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "sa": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "_render": true
      }],
      "_render": true
    }],
    "ip": 0,
    "op": 121,
    "st": 0,
    "bm": 0,
    "completed": true
  }, {
    "ddd": 0,
    "ind": 9,
    "ty": 3,
    "nm": "whole lock",
    "sr": 1,
    "ks": {
      "p": {
        "a": 0,
        "k": [-1.2999215126037598, 0.036954134702682495],
        "ix": 2
      },
      "a": {
        "a": 0,
        "k": [0.3954734802246094, 0.814178466796875],
        "ix": 2
      },
      "s": {
        "a": 0,
        "k": [100.00000263138283, 100.00000263138283],
        "ix": 2
      },
      "r": {
        "a": 1,
        "k": [{
          "t": 0,
          "s": [-3.999999287244152],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          },
          "__fnct": [null]
        }, {
          "t": 60,
          "s": [41.00000047453092],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          },
          "__fnct": [null]
        }, {
          "t": 120,
          "s": [-3.9999995254690717],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          }
        }, {
          "t": 160,
          "s": [-3.9999994914369403],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          }
        }, {
          "t": 185,
          "s": [-3.999999457404809],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          }
        }, {
          "t": 195,
          "s": [-3.9999994233726777],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          }
        }, {
          "t": 209,
          "s": [-3.999999393121894],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          }
        }, {
          "t": 214,
          "s": [-3.9999993772402327],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          }
        }, {
          "t": 223,
          "s": [-3.9999993477457187],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          }
        }, {
          "t": 227,
          "s": [-3.9999993461430283],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          }
        }, {
          "t": 233,
          "s": [-3.9999993425122757],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          }
        }, {
          "t": 235,
          "s": [-3.9999993413020247],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          }
        }, {
          "t": 330,
          "s": [-3.999999287244152],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          }
        }, {
          "t": 350,
          "s": [176.0000004745309],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          }
        }, {
          "t": 370,
          "s": [357],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          }
        }],
        "ix": 2
      },
      "o": {
        "a": 0,
        "k": 100,
        "ix": 2
      },
      "sk": {
        "a": 0,
        "k": 0,
        "ix": 2
      },
      "sa": {
        "a": 0,
        "k": 0,
        "ix": 2
      }
    },
    "ao": 0,
    "ip": 0,
    "op": 121,
    "st": 0,
    "bm": 0,
    "parent": 6,
    "completed": true
  }, {
    "ddd": 0,
    "ind": 10,
    "ty": 4,
    "nm": "Code",
    "sr": 1,
    "ks": {
      "p": {
        "a": 0,
        "k": [0, 0],
        "ix": 2
      },
      "a": {
        "a": 0,
        "k": [0, 0],
        "ix": 2
      },
      "s": {
        "a": 0,
        "k": [100, 100],
        "ix": 2
      },
      "r": {
        "a": 0,
        "k": 0,
        "ix": 2
      },
      "o": {
        "a": 0,
        "k": 100,
        "ix": 2
      },
      "sk": {
        "a": 0,
        "k": 0,
        "ix": 2
      },
      "sa": {
        "a": 0,
        "k": 0,
        "ix": 2
      }
    },
    "ao": 0,
    "parent": 9,
    "shapes": [{
      "ty": "gr",
      "it": [{
        "ty": "gr",
        "it": [{
          "ty": "gr",
          "it": [{
            "ty": "gr",
            "nm": "Filled region",
            "it": [{
              "ty": "gr",
              "nm": "Path",
              "it": [{
                "ty": "sh",
                "d": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "c": true,
                    "v": [[8.028193473815918, 6.246461391448975], [7.862060546875, 4.69136381149292], [7.846455097198486, 4.69199275970459], [7.815189361572266, 4.811079978942871], [7.732646465301514, 4.940651893615723], [7.599154949188232, 5.05905294418335], [7.138891220092773, 5.24353551864624], [6.678439140319824, 5.155101299285889], [6.288485527038574, 4.8173508644104], [6.077907562255859, 4.3064470291137695], [6.157443046569824, 3.804280996322632], [6.508584976196289, 3.388547420501709], [7.019496440887451, 3.17797589302063], [7.519125461578369, 3.254009246826172], [7.932322025299072, 3.6016430854797363], [8.12130069732666, 3.994389772415161], [8.216922760009766, 4.487086296081543], [8.396142959594727, 5.9791364669799805], [8.028193473815918, 6.246461391448975]],
                    "i": [[8.028193473815918, 6.246461391448975], [7.862060546875, 4.69136381149292], [7.846455097198486, 4.69199275970459], [7.836653403937817, 4.766931224614382], [7.7685473673045635, 4.896722313016653], [7.650551043450832, 5.0217122957110405], [7.298553958535194, 5.2274774089455605], [6.826383501291275, 5.226082004606724], [6.400510340929031, 4.97153727710247], [6.0977812968194485, 4.481182560324669], [6.0845455303788185, 3.964322865009308], [6.347387984395027, 3.5056613832712173], [6.844758167862892, 3.1978483237326145], [7.359080389142036, 3.181111976504326], [7.8152051866054535, 3.440448224544525], [8.07678747922182, 3.844694286584854], [8.195990545675159, 4.305981248617172], [8.396142959594727, 5.9791364669799805], [8.028193473815918, 6.246461391448975]],
                    "o": [[8.028193473815918, 6.246461391448975], [7.862060546875, 4.69136381149292], [7.847075273224618, 4.7272355034947395], [7.7960615288466215, 4.8535315208137035], [7.695048309862614, 4.982245296239853], [7.451975107192993, 5.165983065962791], [6.979867413640022, 5.255560245364904], [6.530494824051857, 5.0841206684708595], [6.167974039912224, 4.651483744382858], [6.058033933863044, 4.131711646914482], [6.2303406894207, 3.6442392617464066], [6.674454241991043, 3.268038921058178], [7.192537382245064, 3.155767334625125], [7.677472963929176, 3.3245703503489494], [8.013794615864754, 3.7137786597013474], [8.164116598665714, 4.141749143600464], [8.216922760009766, 4.487086296081543], [8.396142959594727, 5.9791364669799805], [8.028193473815918, 6.246461391448975]]
                  }
                },
                "_render": true
              }, {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [7.233832359313965, 4.708329200744629],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [7.233832212784639, 4.708329152215088],
                  "ix": 2
                },
                "s": {
                  "a": 0,
                  "k": [100, 100],
                  "ix": 2
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 2
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "_render": true
              }],
              "_render": true
            }, {
              "ty": "gr",
              "nm": "Path",
              "it": [{
                "ty": "sh",
                "d": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "c": true,
                    "v": [[7.505036354064941, 4.7526535987854], [7.76350736618042, 4.334646224975586], [7.622028827667236, 3.837787628173828], [7.349219799041748, 3.6023175716400146], [7.033016681671143, 3.5429322719573975], [6.715770721435547, 3.6663403511047363], [6.500365734100342, 3.929917573928833], [6.455627918243408, 4.251535892486572], [6.59877872467041, 4.581206321716309], [6.8680830001831055, 4.819222450256348], [7.19033670425415, 4.879565715789795], [7.505036354064941, 4.7526535987854]],
                    "i": [[7.505036354064941, 4.7526535987854], [7.743045633658767, 4.502993121743202], [7.7391456216573715, 3.9989824295043945], [7.453014478087425, 3.6518343836069107], [7.142360411584377, 3.531308245845139], [6.818562984466553, 3.591659002006054], [6.543513037264347, 3.8271834701299667], [6.4406083738431334, 4.1375215500593185], [6.5207008346915245, 4.4737430810928345], [6.766624554991722, 4.768008399754763], [7.079295597970486, 4.88885354436934], [7.404580257833004, 4.82563766092062]],
                    "o": [[7.656888544559479, 4.642328880727291], [7.786305136978626, 4.164602026343346], [7.543950937688351, 3.730324387550354], [7.247761279344559, 3.551103476434946], [6.92431178689003, 3.5505228880792856], [6.6153146252036095, 3.739324413239956], [6.455521106719971, 4.030315548181534], [6.472983689978719, 4.36385290324688], [6.676856569945812, 4.688669502735138], [6.971877671778202, 4.868739169090986], [7.299680434167385, 4.8679416896775365], [7.505036354064941, 4.7526535987854]]
                  }
                },
                "_render": true
              }, {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [7.109527587890625, 4.2107367515563965],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [7.109527437944722, 4.2107365317717225],
                  "ix": 2
                },
                "s": {
                  "a": 0,
                  "k": [100, 100],
                  "ix": 2
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 2
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "_render": true
              }],
              "_render": true
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [1, 1, 1],
                "ix": 2
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 2
              },
              "r": 1,
              "bm": 0,
              "_render": true
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [0, 0],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 2
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 2
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 2
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "_render": true
            }],
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [7.233832359313965, 4.708329200744629],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [7.233832212784639, 4.708329152215088],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "gr",
          "it": [{
            "ty": "gr",
            "nm": "Filled region",
            "it": [{
              "ty": "gr",
              "nm": "Path",
              "it": [{
                "ty": "sh",
                "d": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "c": true,
                    "v": [[3.148048162460327, 13.447731018066406], [2.8735177516937256, 13.914169311523438], [2.4534549713134766, 14.155698776245117], [1.9532523155212402, 14.125252723693848], [1.6313081979751587, 13.938668251037598], [1.4387072324752808, 13.648368835449219], [1.405832290649414, 13.28699779510498], [1.393473744392395, 13.282981872558594], [1.0368534326553345, 13.581561088562012], [0.5670338273048401, 13.583758354187012], [0.19122456014156342, 13.338682174682617], [0.011489860713481903, 12.938702583312988], [0.058420613408088684, 12.44385814666748], [0.311326265335083, 12.015938758850098], [0.6918442249298096, 11.797994613647461], [1.1399354934692383, 11.820618629455566], [1.5187333822250366, 12.098546028137207], [1.6317367553710938, 12.549714088439941], [1.6440951824188232, 12.553729057312012], [1.8817691802978516, 12.284818649291992], [2.209564208984375, 12.159049987792969], [2.5796961784362793, 12.197333335876465], [3.0009241104125977, 12.470829963684082], [3.200125217437744, 12.909014701843262], [3.148048162460327, 13.447731018066406]],
                    "i": [[3.148048162460327, 13.447731018066406], [2.994964435696602, 13.79270713031292], [2.6120501905679703, 14.116141021251678], [2.1262714862823486, 14.18146963045001], [1.7196063324809074, 14.022010706365108], [1.4788097962737083, 13.758559465408325], [1.385792352259159, 13.414082333445549], [1.393473744392395, 13.282981872558594], [1.188032865524292, 13.527448695152998], [0.7263213694095612, 13.635513618588448], [0.28522294759750366, 13.451203152537346], [0.03456810675561428, 13.091942071914673], [0.002201296389102936, 12.616876482963562], [0.1998341679573059, 12.125454023480415], [0.5469113737344742, 11.83288274332881], [0.9833944141864777, 11.769755735993385], [1.4254888817667961, 11.965016186237335], [1.6468995288014412, 12.381573423743248], [1.6440951824188232, 12.553729057312012], [1.7818086221814156, 12.349500387907028], [2.089140824973583, 12.174575229175389], [2.45336477458477, 12.156286086887121], [2.8931248039007187, 12.344715937972069], [3.1732697747647762, 12.739366605877876], [3.2105140686035156, 13.25548841059208]],
                    "o": [[3.0864746160805225, 13.637227326631546], [2.7520710676908493, 14.035631492733955], [2.293005794286728, 14.191617917269468], [1.8269209116697311, 14.084205474704504], [1.5430101454257965, 13.85532584041357], [1.3967507481575012, 13.53453952819109], [1.405832290649414, 13.28699779510498], [1.306906335055828, 13.427921995520592], [0.8829277753829956, 13.634781166911125], [0.41049274802207947, 13.53289546072483], [0.09447970986366272, 13.225268840789795], [-0.01344231516122818, 12.781824454665184], [0.11553231254220009, 12.268093436956406], [0.4200720340013504, 11.905531257390976], [0.8340305835008621, 11.762214187532663], [1.2992230355739594, 11.872373893857002], [1.6092316284775734, 12.231183663010597], [1.6317367553710938, 12.549714088439941], [1.7025838159024715, 12.439137168228626], [1.9798757955431938, 12.21649830788374], [2.3299876749515533, 12.143524774350226], [2.7527153491973877, 12.253550242632627], [3.1068695038557053, 12.593305215239525], [3.2278730161488056, 13.075916513800621], [3.148048162460327, 13.447731018066406]]
                  }
                },
                "_render": true
              }, {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [1.6064635515213013, 12.976266860961914],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [1.6064635910960534, 12.976267157506904],
                  "ix": 2
                },
                "s": {
                  "a": 0,
                  "k": [100, 100],
                  "ix": 2
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 2
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "_render": true
              }],
              "_render": true
            }, {
              "ty": "gr",
              "nm": "Path",
              "it": [{
                "ty": "sh",
                "d": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "c": true,
                    "v": [[2.81436824798584, 13.339313507080078], [2.801156520843506, 12.86136245727539], [2.4509875774383545, 12.565410614013672], [1.9937338829040527, 12.599017143249512], [1.697982907295227, 12.976580619812012], [1.715314269065857, 13.455869674682617], [2.065483570098877, 13.751821517944336], [2.5227370262145996, 13.718214988708496], [2.81436824798584, 13.339313507080078]],
                    "i": [[2.81436824798584, 13.339313507080078], [2.867076136171818, 13.004231631755829], [2.61576771736145, 12.61895051971078], [2.1310431212186813, 12.522180430591106], [1.7550946064293385, 12.800815910100937], [1.646648369729519, 13.312108129262924], [1.8979570865631104, 13.697389278560877], [2.382681429386139, 13.794159322977066], [2.7572565637528896, 13.51507817208767]],
                    "o": [[2.8714799471199512, 13.163548797369003], [2.7324905693531036, 12.717600852251053], [2.283461093902588, 12.510978374630213], [1.853678360581398, 12.67496145516634], [1.6408712230622768, 13.152345284819603], [1.7812338694930077, 13.598738893866539], [2.2302637100219727, 13.805361423641443], [2.660046249628067, 13.641378313302994], [2.81436824798584, 13.339313507080078]]
                  }
                },
                "_render": true
              }, {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [2.2566096782684326, 13.15829086303711],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [2.2566097748708063, 13.15829131606122],
                  "ix": 2
                },
                "s": {
                  "a": 0,
                  "k": [100, 100],
                  "ix": 2
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 2
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "_render": true
              }],
              "_render": true
            }, {
              "ty": "gr",
              "nm": "Path",
              "it": [{
                "ty": "sh",
                "d": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "c": true,
                    "v": [[1.3684226274490356, 12.869500160217285], [1.3529490232467651, 12.45457649230957], [1.0441826581954956, 12.199402809143066], [0.6443943381309509, 12.22435474395752], [0.3879809081554413, 12.55093765258789], [0.40345439314842224, 12.965862274169922], [0.7122208476066589, 13.22103500366211], [1.1120091676712036, 13.196084022521973], [1.3684226274490356, 12.869500160217285]],
                    "i": [[1.3684226274490356, 12.869500160217285], [1.4132374785840511, 12.57739844918251], [1.1897383630275726, 12.24669636413455], [0.765363983809948, 12.160426668822765], [0.437953632324934, 12.397143572568893], [0.3440582938492298, 12.840294033288956], [0.5666649639606476, 13.173741392791271], [0.9910394474864006, 13.260012030601501], [1.3193422593176365, 13.020547956228256]],
                    "o": [[1.4183953516185284, 12.715706080198288], [1.2926604822278023, 12.331754513084888], [0.8986267745494843, 12.152109198272228], [0.5234246924519539, 12.288282819092274], [0.33890054002404213, 12.701985448598862], [0.46374286338686943, 13.088684186339378], [0.857776552438736, 13.268328558653593], [1.2338711693882942, 13.129409655928612], [1.3684226274490356, 12.869500160217285]]
                  }
                },
                "_render": true
              }, {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [0.8785334229469299, 12.710219383239746],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [0.8785333985257092, 12.710219069505115],
                  "ix": 2
                },
                "s": {
                  "a": 0,
                  "k": [100, 100],
                  "ix": 2
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 2
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "_render": true
              }],
              "_render": true
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [1, 1, 1],
                "ix": 2
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 2
              },
              "r": 1,
              "bm": 0,
              "_render": true
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [0, 0],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 2
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 2
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 2
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "_render": true
            }],
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [1.6064635515213013, 12.976266860961914],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [1.6064635910960534, 12.976267157506904],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "gr",
          "nm": "Filled region",
          "it": [{
            "ty": "sh",
            "d": 1,
            "ks": {
              "a": 0,
              "k": {
                "c": true,
                "v": [[3.518833637237549, 22.259477615356445], [0.5013845562934875, 22.055774688720703], [0.8734949231147766, 23.200992584228516], [1.3595950603485107, 23.043046951293945], [1.480062484741211, 23.413801193237305], [0.6561636328697205, 23.681507110595703], [0.03508734330534935, 21.770061492919922], [0.3811247646808624, 21.657625198364258], [3.387657880783081, 21.85576629638672], [3.518833637237549, 22.259477615356445]],
                "i": [[3.518833637237549, 22.259477615356445], [0.5013845562934875, 22.055774688720703], [0.8734949231147766, 23.200992584228516], [1.3595950603485107, 23.043046951293945], [1.480062484741211, 23.413801193237305], [0.6561636328697205, 23.681507110595703], [0.03508734330534935, 21.770061492919922], [0.3811247646808624, 21.657625198364258], [3.387657880783081, 21.85576629638672], [3.518833637237549, 22.259477615356445]],
                "o": [[3.518833637237549, 22.259477615356445], [0.5013845562934875, 22.055774688720703], [0.8734949231147766, 23.200992584228516], [1.3595950603485107, 23.043046951293945], [1.480062484741211, 23.413801193237305], [0.6561636328697205, 23.681507110595703], [0.03508734330534935, 21.770061492919922], [0.3811247646808624, 21.657625198364258], [3.387657880783081, 21.85576629638672], [3.518833637237549, 22.259477615356445]]
              }
            },
            "_render": true
          }, {
            "ty": "fl",
            "c": {
              "a": 0,
              "k": [1, 1, 1],
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "r": 1,
            "bm": 0,
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [1.7769604921340942, 22.669567108154297],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [1.776960490271449, 22.66956615447998],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "gr",
          "it": [{
            "ty": "gr",
            "nm": "Filled region",
            "it": [{
              "ty": "gr",
              "nm": "Path",
              "it": [{
                "ty": "sh",
                "d": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "c": true,
                    "v": [[8.584076881408691, 29.142776489257812], [8.94477367401123, 29.560096740722656], [9.026854515075684, 30.058759689331055], [8.821369171142578, 30.562654495239258], [8.508782386779785, 30.86024284362793], [8.067194938659668, 31.1069393157959], [6.703527450561523, 31.73845672607422], [6.353099346160889, 31.483861923217773], [7.780773639678955, 30.845306396484375], [7.775352954864502, 30.83066177368164], [7.572489261627197, 30.822479248046875], [7.349831581115723, 30.70889663696289], [7.027681827545166, 30.319581985473633], [6.959946155548096, 29.852758407592773], [7.157164096832275, 29.374980926513672], [7.577999114990234, 29.016834259033203], [8.08017349243164, 28.93729591369629], [8.584076881408691, 29.142776489257812]],
                    "i": [[8.584076881408691, 29.142776489257812], [8.867842547595501, 29.400693774223328], [9.045030841603875, 29.88636040687561], [8.938485987484455, 30.401459649205208], [8.63570100069046, 30.773986473679543], [8.232970789074898, 31.031067073345184], [6.703527450561523, 31.73845672607422], [6.353099346160889, 31.483861923217773], [7.780773639678955, 30.845306396484375], [7.775352954864502, 30.83066177368164], [7.64850626885891, 30.845583723858], [7.422253370285034, 30.761513020843267], [7.090595863759518, 30.468801096081734], [6.938155934214592, 30.015393391251564], [7.04513930529356, 29.52916730940342], [7.416256904602051, 29.092067703604698], [7.905435174703598, 28.91742355003953], [8.420543760061264, 29.023965261876583]],
                    "o": [[8.747610077261925, 29.261587768793106], [9.0176712423563, 29.720138534903526], [9.006980825215578, 30.233495146036148], [8.739896550774574, 30.674790106713772], [8.38016639649868, 30.948835402727127], [8.067194938659668, 31.1069393157959], [6.703527450561523, 31.73845672607422], [6.353099346160889, 31.483861923217773], [7.780773639678955, 30.845306396484375], [7.716127637773752, 30.84831145964563], [7.496472284197807, 30.799374792724848], [7.197979390621185, 30.59857191890478], [6.9607342928647995, 30.171001613140106], [6.97940019890666, 29.68842601776123], [7.275978289544582, 29.21144989132881], [7.738044127821922, 28.943937063217163], [8.25257559120655, 28.95547094196081], [8.584076881408691, 29.142776489257812]]
                  }
                },
                "_render": true
              }, {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [7.692697525024414, 30.334684371948242],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [7.6926976768271995, 30.33468370880862],
                  "ix": 2
                },
                "s": {
                  "a": 0,
                  "k": [100, 100],
                  "ix": 2
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 2
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "_render": true
              }],
              "_render": true
            }, {
              "ty": "gr",
              "nm": "Path",
              "it": [{
                "ty": "sh",
                "d": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "c": true,
                    "v": [[8.383899688720703, 29.425661087036133], [8.069199562072754, 29.298748016357422], [7.750450611114502, 29.36163902282715], [7.477641582489014, 29.59710693359375], [7.337995529174805, 29.929325103759766], [7.3792290687561035, 30.248395919799805], [7.594634056091309, 30.511974334716797], [7.911879539489746, 30.6353816986084], [8.231587409973145, 30.578542709350586], [8.50089168548584, 30.340526580810547], [8.644042015075684, 30.01085662841797], [8.601850509643555, 29.685733795166016], [8.383899688720703, 29.425661087036133]],
                    "i": [[8.383899688720703, 29.425661087036133], [8.176207147538662, 29.3086747424677], [7.851909101009369, 29.310424976050854], [7.555719472467899, 29.489643692970276], [7.353015061467886, 29.81531085073948], [7.334384441375732, 30.147997945547104], [7.491841793060303, 30.437292985618114], [7.800838433206081, 30.626093870028853], [8.127792738378048, 30.628059428185225], [8.422813765704632, 30.447989858686924], [8.626686291769147, 30.12317357212305], [8.644997775554657, 29.788467951118946], [8.48435578495264, 29.498645149171352]],
                    "o": [[8.281107425689697, 29.35097973793745], [7.95815847069025, 29.289460169151425], [7.646655976772308, 29.41115576773882], [7.399563662707806, 29.704570211470127], [7.320639839395881, 30.04164207726717], [7.420040164142847, 30.349432811141014], [7.695090152323246, 30.584958396852016], [8.02122326940298, 30.647005724720657], [8.333045855164528, 30.527328658849], [8.578969575464725, 30.233063340187073], [8.6590615240857, 29.8968423306942], [8.557005897164345, 29.585335798561573], [8.383899688720703, 29.425661087036133]]
                  }
                },
                "_render": true
              }, {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [7.99029541015625, 29.967653274536133],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [7.990295432587681, 29.967653020169138],
                  "ix": 2
                },
                "s": {
                  "a": 0,
                  "k": [100, 100],
                  "ix": 2
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 2
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "_render": true
              }],
              "_render": true
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [1, 1, 1],
                "ix": 2
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 2
              },
              "r": 1,
              "bm": 0,
              "_render": true
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [0, 0],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 2
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 2
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 2
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "_render": true
            }],
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [7.692697525024414, 30.334684371948242],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [7.6926976768271995, 30.33468370880862],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "gr",
          "it": [{
            "ty": "gr",
            "nm": "Filled region",
            "it": [{
              "ty": "gr",
              "nm": "Path",
              "it": [{
                "ty": "sh",
                "d": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "c": true,
                    "v": [[17.3137264251709, 3.2486236095428467], [16.80693817138672, 3.136004686355591], [16.477739334106445, 2.8111422061920166], [16.36077880859375, 2.3173515796661377], [16.360754013061523, 0.931272029876709], [16.477697372436523, 0.437481164932251], [16.806884765625, 0.11695027351379395], [17.31366729736328, 0], [17.82045555114746, 0.11695027351379395], [18.149654388427734, 0.437481164932251], [18.26661491394043, 0.931272029876709], [18.266639709472656, 2.3173515796661377], [18.14969825744629, 2.8111422061920166], [17.816177368164062, 3.136004686355591], [17.3137264251709, 3.2486236095428467]],
                    "i": [[17.3137264251709, 3.2486236095428467], [16.95132277905941, 3.2110839933156967], [16.555708773434162, 2.949750155210495], [16.360782174414453, 2.5050498694181442], [16.360754013061523, 0.931272029876709], [16.399732887744904, 0.5760892182588577], [16.665390476584435, 0.19202964007854462], [17.12019370496273, 2.0372983685509466e-17], [17.67895856499672, 0.03898344933986664], [18.071684904396534, 0.29887329041957855], [18.266611496339237, 0.7406861484050751], [18.266639709472656, 2.3173515796661377], [18.227662712335587, 2.6696466207504272], [17.960559278726578, 3.058037720620632], [17.50720001757145, 3.2486236095428467]],
                    "o": [[17.120252832770348, 3.2486236095428467], [16.665441140532494, 3.058037720620632], [16.399769820272923, 2.6696466207504272], [16.36077880859375, 2.3173515796661377], [16.36075059546033, 0.7406861484050751], [16.5556618347764, 0.29887329041957855], [16.95126663148403, 0.03898344933986664], [17.51002860069275, -2.067706189612886e-17], [17.961952477693558, 0.19202964007854462], [18.227623872458935, 0.5760892182588577], [18.26661491394043, 0.931272029876709], [18.26664307529336, 2.5050498694181442], [18.071733750402927, 2.949750155210495], [17.67468312382698, 3.2110839933156967], [17.3137264251709, 3.2486236095428467]]
                  }
                },
                "_render": true
              }, {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [17.313695907592773, 1.6243118047714233],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [17.313696861263722, 1.6243118047714233],
                  "ix": 2
                },
                "s": {
                  "a": 0,
                  "k": [100, 100],
                  "ix": 2
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 2
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "_render": true
              }],
              "_render": true
            }, {
              "ty": "gr",
              "nm": "Path",
              "it": [{
                "ty": "sh",
                "d": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "c": true,
                    "v": [[17.313720703125, 2.9150984287261963], [17.729541778564453, 2.7505013942718506], [17.889799118041992, 2.3173515796661377], [17.889774322509766, 0.931272029876709], [17.72949981689453, 0.5024538040161133], [17.31367301940918, 0.3335251808166504], [16.893522262573242, 0.5024538040161133], [16.737594604492188, 0.931272029876709], [16.737619400024414, 2.3173515796661377], [16.89356231689453, 2.7505013942718506], [17.313720703125, 2.9150984287261963]],
                    "i": [[17.313720703125, 2.9150984287261963], [17.62558775395155, 2.860232688486576], [17.889802276735054, 2.4934991896152496], [17.889774322509766, 0.931272029876709], [17.83634540438652, 0.6121850535273552], [17.486932948231697, 0.3335251808166504], [17.000363864004612, 0.3898347541689873], [16.737591445800035, 0.7551244646310806], [16.737619400024414, 2.3173515796661377], [16.78960434347391, 2.637882426381111], [17.140460774302483, 2.9150984287261963]],
                    "o": [[17.486980631947517, 2.9150984287261963], [17.836383379995823, 2.637882426381111], [17.889799118041992, 2.3173515796661377], [17.889771163817613, 0.7551244646310806], [17.62554180622101, 0.3898347541689873], [17.140413090586662, 0.3335251808166504], [16.78956827521324, 0.6121850535273552], [16.737594604492188, 0.931272029876709], [16.737622558717476, 2.4934991896152496], [17.00040790438652, 2.860232688486576], [17.313720703125, 2.9150984287261963]]
                  }
                },
                "_render": true
              }, {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [17.313695907592773, 1.6243118047714233],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [17.313696861265147, 1.6243118047714233],
                  "ix": 2
                },
                "s": {
                  "a": 0,
                  "k": [100, 100],
                  "ix": 2
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 2
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "_render": true
              }],
              "_render": true
            }, {
              "ty": "gr",
              "nm": "Path",
              "it": [{
                "ty": "sh",
                "d": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "c": true,
                    "v": [[17.313701629638672, 1.862544298171997], [17.12311363220215, 1.7975716590881348], [17.05380630493164, 1.6113171577453613], [17.12310791015625, 1.4337258338928223], [17.313692092895508, 1.368753433227539], [17.499948501586914, 1.4337258338928223], [17.57358741760254, 1.6113171577453613], [17.499954223632812, 1.7975716590881348], [17.313701629638672, 1.862544298171997]],
                    "i": [[17.313701629638672, 1.862544298171997], [17.172204691916704, 1.8408866859972477], [17.053807754824675, 1.6921718642115593], [17.076905980706215, 1.474153146147728], [17.235725097358227, 1.368753433227539], [17.4537450671196, 1.3904108069837093], [17.573586019493746, 1.5333502516150475], [17.549043726176023, 1.7542567178606987], [17.391668625175953, 1.862544298171997]],
                    "o": [[17.23573463410139, 1.862544298171997], [17.076910197734833, 1.7542567178606987], [17.053804906822847, 1.5333502516150475], [17.17219741269946, 1.3904108069837093], [17.39165908843279, 1.368753433227539], [17.549039509147406, 1.474153146147728], [17.573588867495573, 1.6921718642115593], [17.45375234633684, 1.8408866859972477], [17.313701629638672, 1.862544298171997]]
                  }
                },
                "_render": true
              }, {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [17.313697814941406, 1.615648865699768],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [17.313696861267477, 1.615648865699768],
                  "ix": 2
                },
                "s": {
                  "a": 0,
                  "k": [100, 100],
                  "ix": 2
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 2
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "_render": true
              }],
              "_render": true
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [1, 1, 1],
                "ix": 2
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 2
              },
              "r": 1,
              "bm": 0,
              "_render": true
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [0, 0],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 2
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 2
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 2
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "_render": true
            }],
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [17.313695907592773, 1.6243118047714233],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [17.313696861263722, 1.6243118047714233],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "gr",
          "nm": "Filled region",
          "it": [{
            "ty": "sh",
            "d": 1,
            "ks": {
              "a": 0,
              "k": {
                "c": true,
                "v": [[17.55527114868164, 31.836397171020508], [18.248315811157227, 32.07896041870117], [18.50388526916504, 32.74601364135742], [18.114049911499023, 32.74601364135742], [17.962440490722656, 32.33451843261719], [17.550945281982422, 32.182918548583984], [17.139455795288086, 32.33451843261719], [16.98786163330078, 32.74601364135742], [16.987865447998047, 32.9409294128418], [17.135143280029297, 33.352420806884766], [17.53364372253418, 33.504024505615234], [18.395610809326172, 33.504024505615234], [18.395639419555664, 35.04170608520508], [16.71068572998047, 35.04170608520508], [16.71068000793457, 34.6865234375], [18.031787872314453, 34.6865234375], [18.023109436035156, 33.85920715332031], [17.511991500854492, 33.85920715332031], [16.836275100708008, 33.616641998291016], [16.59803009033203, 32.9409294128418], [16.598026275634766, 32.74601364135742], [16.8579044342041, 32.07896041870117], [17.55527114868164, 31.836397171020508]],
                "i": [[17.55527114868164, 31.836397171020508], [18.07794064283371, 31.917251139879227], [18.50388024632639, 32.465910106897354], [18.114049911499023, 32.74601364135742], [18.063510581851006, 32.43558671325445], [17.72420521080494, 32.182918548583984], [17.240522265434265, 32.23345012962818], [16.987858526390028, 32.572753712534904], [16.987865447998047, 32.9409294128418], [17.036960907280445, 33.2513525262475], [17.36615912616253, 33.504024505615234], [18.395610809326172, 33.504024505615234], [18.395639419555664, 35.04170608520508], [16.71068572998047, 35.04170608520508], [16.71068000793457, 34.6865234375], [18.031787872314453, 34.6865234375], [18.023109436035156, 33.85920715332031], [17.511991500854492, 33.85920715332031], [16.995099544525146, 33.77835124731064], [16.598035320299005, 33.23258364200592], [16.598026275634766, 32.74601364135742], [16.684647366404533, 32.24355736374855], [17.26072919368744, 31.836397171020508]],
                "o": [[17.84692534804344, 31.836397171020508], [18.418691024184227, 32.24355736374855], [18.50388526916504, 32.74601364135742], [18.11404680458827, 32.572753712534904], [17.861370354890823, 32.23345012962818], [17.377685353159904, 32.182918548583984], [17.038389325141907, 32.43558671325445], [16.98786163330078, 32.74601364135742], [16.9878685549088, 33.114189341664314], [17.233325742185116, 33.453489169478416], [17.53364372253418, 33.504024505615234], [18.395610809326172, 33.504024505615234], [18.395639419555664, 35.04170608520508], [16.71068572998047, 35.04170608520508], [16.71068000793457, 34.6865234375], [18.031787872314453, 34.6865234375], [18.023109436035156, 33.85920715332031], [17.22033727169037, 33.85920715332031], [16.67745055258274, 33.457820385694504], [16.59803009033203, 32.9409294128418], [16.598021252796116, 32.465910106897354], [17.02827374637127, 31.917251139879227], [17.55527114868164, 31.836397171020508]]
              }
            },
            "_render": true
          }, {
            "ty": "fl",
            "c": {
              "a": 0,
              "k": [1, 1, 1],
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "r": 1,
            "bm": 0,
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [17.550954818725586, 33.43905258178711],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [17.550955772290692, 33.43905162811279],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "gr",
          "nm": "Filled region",
          "it": [{
            "ty": "sh",
            "d": 1,
            "ks": {
              "a": 0,
              "k": {
                "c": true,
                "v": [[26.128232955932617, 29.189237594604492], [26.53559684753418, 29.749916076660156], [27.69200897216797, 28.909751892089844], [28.050996780395508, 29.40384864807129], [28.21109962463379, 31.584388732910156], [27.85366439819336, 31.84407615661621], [27.6846923828125, 29.56290054321289], [27.585397720336914, 29.42623519897461], [26.744369506835938, 30.037263870239258], [27.197561264038086, 30.66101837158203], [26.88217544555664, 30.890153884887695], [25.812847137451172, 29.41837501525879], [26.128232955932617, 29.189237594604492]],
                "i": [[26.128232955932617, 29.189237594604492], [26.53559684753418, 29.749916076660156], [27.69200897216797, 28.909751892089844], [28.050996780395508, 29.40384864807129], [28.21109962463379, 31.584388732910156], [27.85366439819336, 31.84407615661621], [27.6846923828125, 29.56290054321289], [27.585397720336914, 29.42623519897461], [26.744369506835938, 30.037263870239258], [27.197561264038086, 30.66101837158203], [26.88217544555664, 30.890153884887695], [25.812847137451172, 29.41837501525879], [26.128232955932617, 29.189237594604492]],
                "o": [[26.128232955932617, 29.189237594604492], [26.53559684753418, 29.749916076660156], [27.69200897216797, 28.909751892089844], [28.050996780395508, 29.40384864807129], [28.21109962463379, 31.584388732910156], [27.85366439819336, 31.84407615661621], [27.6846923828125, 29.56290054321289], [27.585397720336914, 29.42623519897461], [26.744369506835938, 30.037263870239258], [27.197561264038086, 30.66101837158203], [26.88217544555664, 30.890153884887695], [25.812847137451172, 29.41837501525879], [26.128232955932617, 29.189237594604492]]
              }
            },
            "_render": true
          }, {
            "ty": "fl",
            "c": {
              "a": 0,
              "k": [1, 1, 1],
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "r": 1,
            "bm": 0,
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [27.011974334716797, 30.376914978027344],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [27.01197338104248, 30.376914024353027],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "gr",
          "nm": "Filled region",
          "it": [{
            "ty": "sh",
            "d": 1,
            "ks": {
              "a": 0,
              "k": {
                "c": true,
                "v": [[31.21969223022461, 21.70640754699707], [31.664554595947266, 21.12224578857422], [32.377933502197266, 21.085325241088867], [32.25746154785156, 21.456079483032227], [31.819259643554688, 21.47310447692871], [31.547914505004883, 21.817607879638672], [31.56493377685547, 22.25580596923828], [31.90943717956543, 22.527145385742188], [32.115413665771484, 22.594070434570312], [32.55361557006836, 22.577045440673828], [32.8249626159668, 22.232542037963867], [32.93070602416992, 21.907102584838867], [33.25202941894531, 22.011505126953125], [33.79513168334961, 23.00320816040039], [34.19669723510742, 21.767362594604492], [34.53449630737305, 21.877119064331055], [33.99639892578125, 23.533151626586914], [33.650360107421875, 23.420717239379883], [33.040618896484375, 22.311721801757812], [33.1518440246582, 22.34786033630371], [32.704200744628906, 22.926565170288086], [31.994943618774414, 22.964824676513672], [31.78896713256836, 22.897899627685547], [31.23487663269043, 22.44460105895996], [31.21969223022461, 21.70640754699707]],
                "i": [[31.21969223022461, 21.70640754699707], [31.458109959959984, 21.234308272600174], [32.11153897643089, 20.99876906722784], [32.25746154785156, 21.456079483032227], [31.9466143399477, 21.408214777708054], [31.601456731557846, 21.652828440070152], [31.500044971704483, 22.12845304608345], [31.744657039642334, 22.47360548004508], [32.115413665771484, 22.594070434570312], [32.42626079916954, 22.641935110092163], [32.771420400589705, 22.397321432828903], [32.93070602416992, 21.907102584838867], [33.25202941894531, 22.011505126953125], [33.79513168334961, 23.00320816040039], [34.19669723510742, 21.767362594604492], [34.53449630737305, 21.877119064331055], [33.99639892578125, 23.533151626586914], [33.650360107421875, 23.420717239379883], [33.040618896484375, 22.311721801757812], [33.1518440246582, 22.34786033630371], [32.91249932348728, 22.818141236901283], [32.26133817434311, 23.05138085782528], [31.78896713256836, 22.897899627685547], [31.33787553012371, 22.660243451595306], [31.128670446574688, 21.986532598733902]],
                "o": [[31.309821613132954, 21.429028928279877], [31.87374557554722, 21.011075608432293], [32.377933502197266, 21.085325241088867], [32.09268140792847, 21.40253957733512], [31.691904932260513, 21.537994168698788], [31.49437228962779, 21.982387274503708], [31.629822559654713, 22.38315887749195], [31.90943717956543, 22.527145385742188], [32.28019380569458, 22.64761034026742], [32.68097026646137, 22.51215574145317], [32.8249626159668, 22.232542037963867], [32.93070602416992, 21.907102584838867], [33.25202941894531, 22.011505126953125], [33.79513168334961, 23.00320816040039], [34.19669723510742, 21.767362594604492], [34.53449630737305, 21.877119064331055], [33.99639892578125, 23.533151626586914], [33.650360107421875, 23.420717239379883], [33.040618896484375, 22.311721801757812], [33.06171464920044, 22.625238925218582], [32.49775603413582, 23.038627676665783], [31.994943618774414, 22.964824676513672], [31.522572606801987, 22.81134345382452], [31.13373166322708, 22.232597440481186], [31.21969223022461, 21.70640754699707]]
              }
            },
            "_render": true
          }, {
            "ty": "fl",
            "c": {
              "a": 0,
              "k": [1, 1, 1],
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "r": 1,
            "bm": 0,
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [32.84476089477539, 22.280820846557617],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [32.844759120432386, 22.280820385844557],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "gr",
          "nm": "Filled region",
          "it": [{
            "ty": "sh",
            "d": 1,
            "ks": {
              "a": 0,
              "k": {
                "c": true,
                "v": [[30.906309127807617, 12.298346519470215], [31.248228073120117, 12.187248229980469], [32.64455795288086, 12.840269088745117], [33.156898498535156, 13.01537799835205], [33.54062271118164, 12.990893363952637], [33.88512420654297, 12.719551086425781], [33.90894317626953, 12.288251876831055], [33.626686096191406, 11.938185691833496], [33.17612838745117, 11.925179481506348], [33.055660247802734, 11.554425239562988], [33.56543731689453, 11.52541732788086], [33.97746658325195, 11.742229461669922], [34.238502502441406, 12.181169509887695], [34.28800582885742, 12.697952270507812], [34.08488845825195, 13.110084533691406], [33.659645080566406, 13.371225357055664], [33.167686462402344, 13.398998260498047], [32.50231170654297, 13.173416137695312], [31.3900089263916, 12.637611389160156], [31.83439826965332, 14.00528335571289], [31.496599197387695, 14.115042686462402], [30.906309127807617, 12.298346519470215]],
                "i": [[30.906309127807617, 12.298346519470215], [31.248228073120117, 12.187248229980469], [32.64455795288086, 12.840269088745117], [33.0164283066988, 12.994222227483988], [33.425276808440685, 13.028372123837471], [33.820235051214695, 12.8469048589468], [33.96159189194441, 12.450285345315933], [33.76042492687702, 12.004036597907543], [33.34640075266361, 11.869853746145964], [33.055660247802734, 11.554425239562988], [33.408627569675446, 11.49135297164321], [33.86233675479889, 11.630860440433025], [34.17960734292865, 11.999911770224571], [34.3156850989908, 12.540181040763855], [34.19261872023344, 12.993100792169571], [33.83815664052963, 13.313222497701645], [33.35285171866417, 13.426885416731238], [32.76161962747574, 13.29866361618042], [31.3900089263916, 12.637611389160156], [31.83439826965332, 14.00528335571289], [31.496599197387695, 14.115042686462402], [30.906309127807617, 12.298346519470215]],
                "o": [[30.906309127807617, 12.298346519470215], [31.248228073120117, 12.187248229980469], [32.84564697742462, 12.935852907598019], [33.297368720173836, 13.036533845588565], [33.70540247857571, 12.937352307140827], [33.953652158379555, 12.594051212072372], [33.85450978204608, 12.120725810527802], [33.49658592045307, 11.87418881803751], [33.17612838745117, 11.925179481506348], [33.2387026399374, 11.50102274492383], [33.72499318420887, 11.55858937650919], [34.09259624034166, 11.85359850525856], [34.29918238148093, 12.367919966578484], [34.26032639667392, 12.855723544955254], [33.97990445792675, 13.226175859570503], [33.5168359875679, 13.417627591639757], [32.98341354727745, 13.373857397586107], [32.50231170654297, 13.173416137695312], [31.3900089263916, 12.637611389160156], [31.83439826965332, 14.00528335571289], [31.496599197387695, 14.115042686462402], [30.906309127807617, 12.298346519470215]]
              }
            },
            "_render": true
          }, {
            "ty": "fl",
            "c": {
              "a": 0,
              "k": [1, 1, 1],
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "r": 1,
            "bm": 0,
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [32.603660583496094, 12.810279846191406],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [32.603660275974406, 12.810280238859221],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "gr",
          "nm": "Filled region",
          "it": [{
            "ty": "sh",
            "d": 1,
            "ks": {
              "a": 0,
              "k": {
                "c": true,
                "v": [[25.21958351135254, 5.328159809112549], [25.428356170654297, 5.0408124923706055], [26.122203826904297, 5.5449113845825195], [27.573434829711914, 3.547496795654297], [26.502775192260742, 3.5620245933532715], [26.765016555786133, 3.2010881900787354], [27.656381607055664, 3.1901497840881348], [28.0874080657959, 3.5033023357391357], [26.437589645385742, 5.774047374725342], [27.00528335571289, 6.186491966247559], [26.7965087890625, 6.473839282989502], [25.21958351135254, 5.328159809112549]],
                "i": [[25.21958351135254, 5.328159809112549], [25.428356170654297, 5.0408124923706055], [26.122203826904297, 5.5449113845825195], [27.573434829711914, 3.547496795654297], [26.502775192260742, 3.5620245933532715], [26.765016555786133, 3.2010881900787354], [27.656381607055664, 3.1901497840881348], [28.0874080657959, 3.5033023357391357], [26.437589645385742, 5.774047374725342], [27.00528335571289, 6.186491966247559], [26.7965087890625, 6.473839282989502], [25.21958351135254, 5.328159809112549]],
                "o": [[25.21958351135254, 5.328159809112549], [25.428356170654297, 5.0408124923706055], [26.122203826904297, 5.5449113845825195], [27.573434829711914, 3.547496795654297], [26.502775192260742, 3.5620245933532715], [26.765016555786133, 3.2010881900787354], [27.656381607055664, 3.1901497840881348], [28.0874080657959, 3.5033023357391357], [26.437589645385742, 5.774047374725342], [27.00528335571289, 6.186491966247559], [26.7965087890625, 6.473839282989502], [25.21958351135254, 5.328159809112549]]
              }
            },
            "_render": true
          }, {
            "ty": "fl",
            "c": {
              "a": 0,
              "k": [1, 1, 1],
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "r": 1,
            "bm": 0,
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [26.65349578857422, 4.831994533538818],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [26.65349578857422, 4.831994533538818],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "tr",
          "p": {
            "a": 0,
            "k": [60.562744140625, 83.6688003540039],
            "ix": 2
          },
          "a": {
            "a": 0,
            "k": [17.267248153686523, 17.52085304260254],
            "ix": 2
          },
          "s": {
            "a": 0,
            "k": [109.14504528045654, 109.14504528045654],
            "ix": 2
          },
          "r": {
            "a": 0,
            "k": -2.172794366275684e-7,
            "ix": 2
          },
          "o": {
            "a": 0,
            "k": 100,
            "ix": 2
          },
          "sk": {
            "a": 0,
            "k": 0,
            "ix": 2
          },
          "sa": {
            "a": 0,
            "k": 0,
            "ix": 2
          },
          "_render": true
        }],
        "_render": true
      }, {
        "ty": "gr",
        "it": [{
          "ty": "gr",
          "nm": "Vector",
          "it": [{
            "ty": "sh",
            "d": 1,
            "ks": {
              "a": 0,
              "k": {
                "c": true,
                "v": [[0.647433311739829, 0], [1.2956955432891846, 0.647433340549469], [0.647433311739829, 1.294866681098938], [0, 0.647433340549469], [0.647433311739829, 0]],
                "i": [[0.647433311739829, 0], [1.2956955432891846, 0.290142995353382], [1.0055526349632316, 1.294866681098938], [0, 1.0055526797085497], [0.2893139885164264, 0]],
                "o": [[1.0055526349632316, 0], [1.2956955432891846, 1.0055526797085497], [0.2893139885164264, 1.294866681098938], [0, 0.290142995353382], [0.647433311739829, 0]]
              }
            },
            "_render": true
          }, {
            "ty": "fl",
            "c": {
              "a": 0,
              "k": [1, 1, 1],
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "r": 1,
            "bm": 0,
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [197.82676696777344, 178.24118041992188],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [0.6478477716445923, 0.647433340549469],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, -100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 180,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": -180,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "gr",
          "nm": "Vector",
          "it": [{
            "ty": "sh",
            "d": 1,
            "ks": {
              "a": 0,
              "k": {
                "c": true,
                "v": [[0.6482623219490051, 0], [1.2965246438980103, 0.647433340549469], [0.6482623219490051, 1.294866681098938], [0, 0.647433340549469], [0.6482623219490051, 0]],
                "i": [[0.6482623219490051, 0], [1.2965246438980103, 0.290142995353382], [1.0063816678157254, 1.294866681098938], [0, 1.0055526797085497], [0.2901429760822849, 0]],
                "o": [[1.0063816678157254, 0], [1.2965246438980103, 1.0055526797085497], [0.2901429760822849, 1.294866681098938], [0, 0.290142995353382], [0.6482623219490051, 0]]
              }
            },
            "_render": true
          }, {
            "ty": "fl",
            "c": {
              "a": 0,
              "k": [1, 1, 1],
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "r": 1,
            "bm": 0,
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [186.1193084716797, 182.03805541992188],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [0.6482623219490051, 0.647433340549469],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, -100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 180,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": -180,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "gr",
          "nm": "Vector",
          "it": [{
            "ty": "sh",
            "d": 1,
            "ks": {
              "a": 0,
              "k": {
                "c": true,
                "v": [[0.6482623219490051, 0], [1.2965246438980103, 0.6474332623287768], [0.6482623219490051, 1.2956955432891846], [0, 0.6474332623287768], [0.6482623219490051, 0]],
                "i": [[0.6482623219490051, 0], [1.2965246438980103, 0.2901429330314791], [1.0063816678157254, 1.2956955432891846], [0, 1.0055525855521794], [0.2901429760822849, 0]],
                "o": [[1.0063816678157254, 0], [1.2965246438980103, 1.0055525855521794], [0.2901429760822849, 1.2956955432891846], [0, 0.2901429330314791], [0.6482623219490051, 0]]
              }
            },
            "_render": true
          }, {
            "ty": "fl",
            "c": {
              "a": 0,
              "k": [1, 1, 1],
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "r": 1,
            "bm": 0,
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [178.8829803466797, 192.00172424316406],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [0.6482623219490051, 0.6478477716445923],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, -100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 180,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": -180,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "gr",
          "nm": "Vector",
          "it": [{
            "ty": "sh",
            "d": 1,
            "ks": {
              "a": 0,
              "k": {
                "c": true,
                "v": [[0.6482623219490051, 0], [1.2965246438980103, 0.647433340549469], [0.6482623219490051, 1.294866681098938], [0, 0.647433340549469], [0.6482623219490051, 0]],
                "i": [[0.6482623219490051, 0], [1.2965246438980103, 0.290142995353382], [1.0063816678157254, 1.294866681098938], [0, 1.0055526797085497], [0.2901429760822849, 0]],
                "o": [[1.0063816678157254, 0], [1.2965246438980103, 1.0055526797085497], [0.2901429760822849, 1.294866681098938], [0, 0.290142995353382], [0.6482623219490051, 0]]
              }
            },
            "_render": true
          }, {
            "ty": "fl",
            "c": {
              "a": 0,
              "k": [1, 1, 1],
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "r": 1,
            "bm": 0,
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [178.8829803466797, 204.31259155273438],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [0.6482623219490051, 0.647433340549469],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, -100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 180,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": -180,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "gr",
          "nm": "Vector",
          "it": [{
            "ty": "sh",
            "d": 1,
            "ks": {
              "a": 0,
              "k": {
                "c": true,
                "v": [[0.6482623219490051, 0], [1.2965246438980103, 0.6474332623287768], [0.6482623219490051, 1.2956955432891846], [0, 0.6474332623287768], [0.6482623219490051, 0]],
                "i": [[0.6482623219490051, 0], [1.2965246438980103, 0.2901429330314791], [1.0063816678157254, 1.2956955432891846], [0, 1.0055525855521794], [0.2901429760822849, 0]],
                "o": [[1.0063816678157254, 0], [1.2965246438980103, 1.0055525855521794], [0.2901429760822849, 1.2956955432891846], [0, 0.2901429330314791], [0.6482623219490051, 0]]
              }
            },
            "_render": true
          }, {
            "ty": "fl",
            "c": {
              "a": 0,
              "k": [1, 1, 1],
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "r": 1,
            "bm": 0,
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [186.1193084716797, 214.26832580566406],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [0.6482623219490051, 0.6478477716445923],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, -100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 180,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": -180,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "gr",
          "nm": "Vector",
          "it": [{
            "ty": "sh",
            "d": 1,
            "ks": {
              "a": 0,
              "k": {
                "c": true,
                "v": [[0.647433311739829, 0], [1.2956955432891846, 0.6474332623287768], [0.647433311739829, 1.2956955432891846], [0, 0.6474332623287768], [0.647433311739829, 0]],
                "i": [[0.647433311739829, 0], [1.2956955432891846, 0.2901429330314791], [1.0055526349632316, 1.2956955432891846], [0, 1.0055525855521794], [0.2893139885164264, 0]],
                "o": [[1.0055526349632316, 0], [1.2956955432891846, 1.0055525855521794], [0.2893139885164264, 1.2956955432891846], [0, 0.2901429330314791], [0.647433311739829, 0]]
              }
            },
            "_render": true
          }, {
            "ty": "fl",
            "c": {
              "a": 0,
              "k": [1, 1, 1],
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "r": 1,
            "bm": 0,
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [197.82676696777344, 218.07313537597656],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [0.6478477716445923, 0.6478477716445923],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, -100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 180,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": -180,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "gr",
          "nm": "Vector",
          "it": [{
            "ty": "sh",
            "d": 1,
            "ks": {
              "a": 0,
              "k": {
                "c": true,
                "v": [[0.6482623219490051, 0], [1.2965246438980103, 0.6474332623287768], [0.6482623219490051, 1.2956955432891846], [0, 0.6474332623287768], [0.6482623219490051, 0]],
                "i": [[0.6482623219490051, 0], [1.2965246438980103, 0.2901429330314791], [1.0063816678157254, 1.2956955432891846], [0, 1.0055525855521794], [0.2901429760822849, 0]],
                "o": [[1.0063816678157254, 0], [1.2965246438980103, 1.0055525855521794], [0.2901429760822849, 1.2956955432891846], [0, 0.2901429330314791], [0.6482623219490051, 0]]
              }
            },
            "_render": true
          }, {
            "ty": "fl",
            "c": {
              "a": 0,
              "k": [1, 1, 1],
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "r": 1,
            "bm": 0,
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [209.5333709716797, 214.26832580566406],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [0.6482623219490051, 0.6478477716445923],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, -100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 180,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": -180,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "gr",
          "nm": "Vector",
          "it": [{
            "ty": "sh",
            "d": 1,
            "ks": {
              "a": 0,
              "k": {
                "c": true,
                "v": [[0.6482623219490051, 0], [1.2965246438980103, 0.647433340549469], [0.6482623219490051, 1.294866681098938], [0, 0.647433340549469], [0.6482623219490051, 0]],
                "i": [[0.6482623219490051, 0], [1.2965246438980103, 0.290142995353382], [1.0063816678157254, 1.294866681098938], [0, 1.0055526797085497], [0.2901429760822849, 0]],
                "o": [[1.0063816678157254, 0], [1.2965246438980103, 1.0055526797085497], [0.2901429760822849, 1.294866681098938], [0, 0.290142995353382], [0.6482623219490051, 0]]
              }
            },
            "_render": true
          }, {
            "ty": "fl",
            "c": {
              "a": 0,
              "k": [1, 1, 1],
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "r": 1,
            "bm": 0,
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [216.7696990966797, 204.31259155273438],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [0.6482623219490051, 0.647433340549469],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, -100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 180,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": -180,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "gr",
          "nm": "Vector",
          "it": [{
            "ty": "sh",
            "d": 1,
            "ks": {
              "a": 0,
              "k": {
                "c": true,
                "v": [[0.6482623219490051, 0], [1.2965246438980103, 0.6474332623287768], [0.6482623219490051, 1.2956955432891846], [0, 0.6474332623287768], [0.6482623219490051, 0]],
                "i": [[0.6482623219490051, 0], [1.2965246438980103, 0.2901429330314791], [1.0063816678157254, 1.2956955432891846], [0, 1.0055525855521794], [0.2901429760822849, 0]],
                "o": [[1.0063816678157254, 0], [1.2965246438980103, 1.0055525855521794], [0.2901429760822849, 1.2956955432891846], [0, 0.2901429330314791], [0.6482623219490051, 0]]
              }
            },
            "_render": true
          }, {
            "ty": "fl",
            "c": {
              "a": 0,
              "k": [1, 1, 1],
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "r": 1,
            "bm": 0,
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [216.7696990966797, 192.00172424316406],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [0.6482623219490051, 0.6478477716445923],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, -100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 180,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": -180,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "gr",
          "nm": "Vector",
          "it": [{
            "ty": "sh",
            "d": 1,
            "ks": {
              "a": 0,
              "k": {
                "c": true,
                "v": [[0.6482623219490051, 0], [1.2965246438980103, 0.647433340549469], [0.6482623219490051, 1.294866681098938], [0, 0.647433340549469], [0.6482623219490051, 0]],
                "i": [[0.6482623219490051, 0], [1.2965246438980103, 0.290142995353382], [1.0063816678157254, 1.294866681098938], [0, 1.0055526797085497], [0.2901429760822849, 0]],
                "o": [[1.0063816678157254, 0], [1.2965246438980103, 1.0055526797085497], [0.2901429760822849, 1.294866681098938], [0, 0.290142995353382], [0.6482623219490051, 0]]
              }
            },
            "_render": true
          }, {
            "ty": "fl",
            "c": {
              "a": 0,
              "k": [1, 1, 1],
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "r": 1,
            "bm": 0,
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [209.5333709716797, 182.03805541992188],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [0.6482623219490051, 0.647433340549469],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, -100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 180,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": -180,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "gr",
          "nm": "Vector",
          "it": [{
            "ty": "sh",
            "d": 1,
            "ks": {
              "a": 0,
              "k": {
                "c": true,
                "v": [[0.647433311739829, 0], [1.2956955432891846, 0.647433340549469], [0.647433311739829, 1.294866681098938], [0, 0.647433340549469], [0.647433311739829, 0]],
                "i": [[0.647433311739829, 0], [1.2956955432891846, 0.290142995353382], [1.0055526349632316, 1.294866681098938], [0, 1.0055526797085497], [0.2893139885164264, 0]],
                "o": [[1.0055526349632316, 0], [1.2956955432891846, 1.0055526797085497], [0.2893139885164264, 1.294866681098938], [0, 0.290142995353382], [0.647433311739829, 0]]
              }
            },
            "_render": true
          }, {
            "ty": "fl",
            "c": {
              "a": 0,
              "k": [1, 1, 1],
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "r": 1,
            "bm": 0,
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [197.82676696777344, 178.24118041992188],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [0.6478477716445923, 0.647433340549469],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, -100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 180,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": -180,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "tr",
          "p": {
            "a": 0,
            "k": [60.534461975097656, 83.54061126708984],
            "ix": 2
          },
          "a": {
            "a": 0,
            "k": [197.82634735107422, 198.1573715209961],
            "ix": 2
          },
          "s": {
            "a": 0,
            "k": [109.14504528045654, 109.14504528045654],
            "ix": 2
          },
          "r": {
            "a": 0,
            "k": 0,
            "ix": 2
          },
          "o": {
            "a": 0,
            "k": 100,
            "ix": 2
          },
          "sk": {
            "a": 0,
            "k": 0,
            "ix": 2
          },
          "sa": {
            "a": 0,
            "k": 0,
            "ix": 2
          },
          "_render": true
        }],
        "_render": true
      }, {
        "ty": "tr",
        "p": {
          "a": 0,
          "k": [0.12225324660539627, 0.3143313527107239],
          "ix": 2
        },
        "a": {
          "a": 0,
          "k": [60.23484420776367, 83.24531555175781],
          "ix": 2
        },
        "s": {
          "a": 0,
          "k": [91.62120223045349, 91.62120223045349],
          "ix": 2
        },
        "r": {
          "a": 0,
          "k": 1.876219357654918e-7,
          "ix": 2
        },
        "o": {
          "a": 0,
          "k": 100,
          "ix": 2
        },
        "sk": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "sa": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "_render": true
      }],
      "_render": true
    }],
    "ip": 0,
    "op": 121,
    "st": 0,
    "bm": 0,
    "completed": true
  }, {
    "ddd": 0,
    "ind": 11,
    "ty": 3,
    "nm": "Lock A",
    "sr": 1,
    "ks": {
      "p": {
        "a": 0,
        "k": [0.39546966552734375, 0.814178466796875],
        "ix": 2
      },
      "a": {
        "a": 0,
        "k": [21.71578025817871, 21.715373992919922],
        "ix": 2
      },
      "s": {
        "a": 0,
        "k": [100, 100],
        "ix": 2
      },
      "r": {
        "a": 0,
        "k": 0,
        "ix": 2
      },
      "o": {
        "a": 0,
        "k": 100,
        "ix": 2
      },
      "sk": {
        "a": 0,
        "k": 0,
        "ix": 2
      },
      "sa": {
        "a": 0,
        "k": 0,
        "ix": 2
      }
    },
    "ao": 0,
    "ip": 0,
    "op": 121,
    "st": 0,
    "bm": 0,
    "parent": 9,
    "completed": true
  }, {
    "ddd": 0,
    "refId": "0",
    "w": 52,
    "h": 52,
    "ind": 1,
    "ty": 0,
    "nm": "Blur",
    "sr": 1,
    "ks": {
      "p": {
        "a": 0,
        "k": [-4, -4],
        "ix": 2
      },
      "a": {
        "a": 0,
        "k": [0, 0],
        "ix": 2
      },
      "s": {
        "a": 0,
        "k": [100, 100],
        "ix": 2
      },
      "r": {
        "a": 0,
        "k": 0,
        "ix": 2
      },
      "o": {
        "a": 0,
        "k": 100,
        "ix": 2
      },
      "sk": {
        "a": 0,
        "k": 0,
        "ix": 2
      },
      "sa": {
        "a": 0,
        "k": 0,
        "ix": 2
      }
    },
    "ao": 0,
    "ip": 0,
    "op": 121,
    "st": 0,
    "bm": 0,
    "parent": 11,
    "ef": [{
      "ty": 29,
      "nm": "Gaussian Blur2",
      "mn": "ADBE Gaussian Blur 2",
      "ef": [{
        "ty": 0,
        "nm": "Blurriness",
        "mn": "ADBE Gaussian Blur 2-0001",
        "v": {
          "a": 0,
          "k": 6,
          "ix": 2
        }
      }, {
        "ty": 7,
        "nm": "Blur Dimensions",
        "mn": "ADBE Gaussian Blur 2-0002",
        "v": {
          "a": 0,
          "k": 0,
          "ix": 2
        }
      }, {
        "ty": 4,
        "nm": "Repeat Edge Pixels",
        "mn": "ADBE Gaussian Blur 2-0003",
        "v": {
          "a": 0,
          "k": 0,
          "ix": 2
        }
      }],
      "np": 1,
      "ix": 0,
      "en": 1
    }],
    "completed": true,
    "layers": [{
      "ddd": 0,
      "ind": 1,
      "ty": 4,
      "nm": "Blur",
      "sr": 1,
      "ks": {
        "p": {
          "a": 0,
          "k": [4, 4],
          "ix": 2
        },
        "a": {
          "a": 0,
          "k": [0, 0],
          "ix": 2
        },
        "s": {
          "a": 0,
          "k": [100, 100],
          "ix": 2
        },
        "r": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "o": {
          "a": 0,
          "k": 100,
          "ix": 2
        },
        "sk": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "sa": {
          "a": 0,
          "k": 0,
          "ix": 2
        }
      },
      "ao": 0,
      "shapes": [{
        "ty": "gr",
        "it": [{
          "ty": "gr",
          "nm": "Blur",
          "it": [{
            "ty": "gr",
            "nm": "Path",
            "it": [{
              "ty": "sh",
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "v": [[43.43000030517578, 21.71500015258789], [21.71500015258789, 43.43000030517578], [0, 21.71500015258789], [21.71500015258789, 0], [43.43000030517578, 21.71500015258789]],
                  "i": [[43.43000030517578, 21.71500015258789], [33.7078630647702, 43.43000030517578], [0, 33.7078630647702], [9.722137240405582, 0], [43.43000030517578, 9.722137240405582]],
                  "o": [[43.43000030517578, 33.7078630647702], [9.722137240405582, 43.43000030517578], [0, 9.722137240405582], [33.7078630647702, 0], [43.43000030517578, 21.71500015258789]]
                }
              },
              "_render": true
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [21.71500015258789, 21.71500015258789],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [21.71500015258789, 21.71500015258789],
                "ix": 2
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 2
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 2
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "_render": true
            }],
            "_render": true
          }, {
            "ty": "gr",
            "nm": "Path",
            "it": [{
              "ty": "sh",
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "v": [[1.0617037320242593, 21.234059169880997], [21.234059169880997, 41.40641460773774], [41.40641460773774, 21.234059169880997], [21.234059169880997, 1.0617037320242593], [1.0617037320242593, 21.234059169880997]],
                  "i": [[1.0617037320242593, 21.234059169880997], [10.093174299672262, 41.40641460773774], [41.40641460773774, 32.37494404008973], [32.37494404008973, 1.0617037320242593], [1.0617037320242593, 10.093174299672262]],
                  "o": [[1.0617037320242593, 32.37494404008973], [32.37494404008973, 41.40641460773774], [41.40641460773774, 10.093174299672262], [10.093174299672262, 1.0617037320242593], [1.0617037320242593, 21.234059169880997]]
                }
              },
              "_render": true
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [21.714996337890625, 21.714996337890625],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [21.234059169881, 21.234059169881],
                "ix": 2
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 2
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 2
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "_render": true
            }],
            "_render": true
          }, {
            "ty": "fl",
            "c": {
              "a": 0,
              "k": [0, 0, 0],
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "r": 1,
            "bm": 0,
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [0, 0],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [0, 0],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "tr",
          "p": {
            "a": 0,
            "k": [21.715782165527344, 21.715003967285156],
            "ix": 2
          },
          "a": {
            "a": 0,
            "k": [21.71500015258789, 21.71500015258789],
            "ix": 2
          },
          "s": {
            "a": 0,
            "k": [100, 100],
            "ix": 2
          },
          "r": {
            "a": 0,
            "k": 1.8762201477034328e-7,
            "ix": 2
          },
          "o": {
            "a": 0,
            "k": 100,
            "ix": 2
          },
          "sk": {
            "a": 0,
            "k": 0,
            "ix": 2
          },
          "sa": {
            "a": 0,
            "k": 0,
            "ix": 2
          },
          "_render": true
        }],
        "_render": true
      }],
      "ip": 0,
      "op": 121,
      "st": 0,
      "bm": 0,
      "completed": true
    }, {
      "ddd": 0,
      "ind": 2,
      "ty": 4,
      "nm": "Blur Overscan",
      "sr": 1,
      "ks": {
        "p": {
          "a": 0,
          "k": [0, 0],
          "ix": 2
        },
        "a": {
          "a": 0,
          "k": [0, 0],
          "ix": 2
        },
        "s": {
          "a": 0,
          "k": [100, 100],
          "ix": 2
        },
        "r": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "o": {
          "a": 0,
          "k": 100,
          "ix": 2
        },
        "sk": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "sa": {
          "a": 0,
          "k": 0,
          "ix": 2
        }
      },
      "ao": 0,
      "shapes": [{
        "ty": "rc",
        "d": 1,
        "s": {
          "a": 0,
          "k": [52, 52],
          "ix": 2
        },
        "p": {
          "a": 0,
          "k": [26, 26],
          "ix": 2
        },
        "r": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "_render": true
      }, {
        "ty": "fl",
        "c": {
          "a": 0,
          "k": [0, 0, 0],
          "ix": 2
        },
        "o": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "r": 1,
        "bm": 0,
        "_render": true
      }],
      "ip": 0,
      "op": 121,
      "st": 0,
      "bm": 0,
      "completed": true
    }]
  }, {
    "ddd": 0,
    "ind": 12,
    "ty": 4,
    "nm": "Lock A",
    "sr": 1,
    "ks": {
      "p": {
        "a": 0,
        "k": [0, 0],
        "ix": 2
      },
      "a": {
        "a": 0,
        "k": [0, 0],
        "ix": 2
      },
      "s": {
        "a": 0,
        "k": [100, 100],
        "ix": 2
      },
      "r": {
        "a": 0,
        "k": 0,
        "ix": 2
      },
      "o": {
        "a": 0,
        "k": 100,
        "ix": 2
      },
      "sk": {
        "a": 0,
        "k": 0,
        "ix": 2
      },
      "sa": {
        "a": 0,
        "k": 0,
        "ix": 2
      }
    },
    "ao": 0,
    "parent": 11,
    "shapes": [{
      "ty": "gr",
      "nm": "Lock A",
      "it": [{
        "ty": "sh",
        "d": 1,
        "ks": {
          "a": 0,
          "k": {
            "c": true,
            "v": [[21.716184133428804, 0], [0, 21.715373992919922], [21.716184133428804, 43.430747985839844], [43.43156051635742, 21.715373992919922], [21.716184133428804, 0]],
            "i": [[21.716184133428804, 0], [0, 9.721769482491446], [9.722578302976133, 43.430747985839844], [43.43156051635742, 33.7089785033484], [33.70898144262699, 0]],
            "o": [[9.722578302976133, 0], [0, 33.7089785033484], [33.70898144262699, 43.430747985839844], [43.43156051635742, 9.721769482491446], [21.716184133428804, 0]]
          }
        },
        "_render": true
      }, {
        "ty": "gf",
        "o": {
          "a": 0,
          "k": 100,
          "ix": 2
        },
        "r": 1,
        "bm": 0,
        "g": {
          "p": 2,
          "k": {
            "a": 0,
            "k": [0, 0.0784313725490196, 0.0784313725490196, 0.0784313725490196, 1, 0.43137254901960786, 0.43137254901960786, 0.43137254901960786, 0, 1, 1, 1],
            "ix": 2
          }
        },
        "s": {
          "a": 0,
          "k": [32.21752944550053, 41.354403389068466],
          "ix": 2
        },
        "e": {
          "a": 0,
          "k": [13.604179358156102, 0.04083957302043473],
          "ix": 2
        },
        "t": 1,
        "_render": true
      }, {
        "ty": "tr",
        "p": {
          "a": 0,
          "k": [21.715782165527344, 21.715373992919922],
          "ix": 2
        },
        "a": {
          "a": 0,
          "k": [21.71578025817871, 21.715373992919922],
          "ix": 2
        },
        "s": {
          "a": 0,
          "k": [100, -100],
          "ix": 2
        },
        "r": {
          "a": 0,
          "k": -179.9999994973283,
          "ix": 2
        },
        "o": {
          "a": 0,
          "k": 100,
          "ix": 2
        },
        "sk": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "sa": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "_render": true
      }],
      "_render": true
    }],
    "ip": 0,
    "op": 121,
    "st": 0,
    "bm": 0,
    "completed": true
  }, {
    "ddd": 0,
    "ind": 13,
    "ty": 3,
    "nm": "Lcok B 1",
    "sr": 1,
    "ks": {
      "p": {
        "a": 0,
        "k": [-1.299890160560608, 0.03696342185139656],
        "ix": 2
      },
      "a": {
        "a": 0,
        "k": [197.81352996826172, 197.81504821777344],
        "ix": 2
      },
      "s": {
        "a": 0,
        "k": [100.00000268335543, 100.00000268335545],
        "ix": 2
      },
      "r": {
        "a": 0,
        "k": -3.9999995254690734,
        "ix": 2
      },
      "o": {
        "a": 0,
        "k": 100,
        "ix": 2
      },
      "sk": {
        "a": 0,
        "k": 0,
        "ix": 2
      },
      "sa": {
        "a": 0,
        "k": 0,
        "ix": 2
      }
    },
    "ao": 0,
    "ip": 0,
    "op": 121,
    "st": 0,
    "bm": 0,
    "parent": 6,
    "completed": true
  }, {
    "ddd": 0,
    "refId": "1",
    "w": 74,
    "h": 74,
    "ind": 3,
    "ty": 0,
    "nm": "Blur",
    "sr": 1,
    "ks": {
      "p": {
        "a": 0,
        "k": [161, 161],
        "ix": 2
      },
      "a": {
        "a": 0,
        "k": [0, 0],
        "ix": 2
      },
      "s": {
        "a": 0,
        "k": [100, 100],
        "ix": 2
      },
      "r": {
        "a": 0,
        "k": 0,
        "ix": 2
      },
      "o": {
        "a": 0,
        "k": 100,
        "ix": 2
      },
      "sk": {
        "a": 0,
        "k": 0,
        "ix": 2
      },
      "sa": {
        "a": 0,
        "k": 0,
        "ix": 2
      }
    },
    "ao": 0,
    "ip": 0,
    "op": 121,
    "st": 0,
    "bm": 0,
    "parent": 13,
    "ef": [{
      "ty": 29,
      "nm": "Gaussian Blur2",
      "mn": "ADBE Gaussian Blur 2",
      "ef": [{
        "ty": 0,
        "nm": "Blurriness",
        "mn": "ADBE Gaussian Blur 2-0001",
        "v": {
          "a": 0,
          "k": 8.67,
          "ix": 2
        }
      }, {
        "ty": 7,
        "nm": "Blur Dimensions",
        "mn": "ADBE Gaussian Blur 2-0002",
        "v": {
          "a": 0,
          "k": 0,
          "ix": 2
        }
      }, {
        "ty": 4,
        "nm": "Repeat Edge Pixels",
        "mn": "ADBE Gaussian Blur 2-0003",
        "v": {
          "a": 0,
          "k": 0,
          "ix": 2
        }
      }],
      "np": 1,
      "ix": 0,
      "en": 1
    }],
    "completed": true,
    "layers": [{
      "ddd": 0,
      "ind": 3,
      "ty": 4,
      "nm": "Blur",
      "sr": 1,
      "ks": {
        "p": {
          "a": 0,
          "k": [-161, -161],
          "ix": 2
        },
        "a": {
          "a": 0,
          "k": [0, 0],
          "ix": 2
        },
        "s": {
          "a": 0,
          "k": [100, 100],
          "ix": 2
        },
        "r": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "o": {
          "a": 0,
          "k": 100,
          "ix": 2
        },
        "sk": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "sa": {
          "a": 0,
          "k": 0,
          "ix": 2
        }
      },
      "ao": 0,
      "shapes": [{
        "ty": "gr",
        "it": [{
          "ty": "gr",
          "nm": "Blur",
          "it": [{
            "ty": "gr",
            "nm": "Path",
            "it": [{
              "ty": "sh",
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "v": [[62.83000183105469, 31.415000915527344], [31.415000915527344, 62.83000183105469], [0, 31.415000915527344], [31.415000915527344, 0], [62.83000183105469, 31.415000915527344]],
                  "i": [[62.83000183105469, 31.415000915527344], [48.7650260925293, 62.83000183105469], [0, 48.7650260925293], [14.06497573852539, 0], [62.83000183105469, 14.06497573852539]],
                  "o": [[62.83000183105469, 48.7650260925293], [14.06497573852539, 62.83000183105469], [0, 14.06497573852539], [48.7650260925293, 0], [62.83000183105469, 31.415000915527344]]
                }
              },
              "_render": true
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [31.415000915527344, 31.415000915527344],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [31.415000915527344, 31.415000915527344],
                "ix": 2
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 2
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 2
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "_render": true
            }],
            "_render": true
          }, {
            "ty": "gr",
            "nm": "Path",
            "it": [{
              "ty": "sh",
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "v": [[1.5707511901855469, 31.415000915527344], [31.415000915527344, 61.25925064086914], [61.25925064086914, 31.415000915527344], [31.415000915527344, 1.5707511901855469], [1.5707511901855469, 31.415000915527344]],
                  "i": [[1.5707511901855469, 31.415000915527344], [14.932476043701172, 61.25925064086914], [61.25925064086914, 47.897525787353516], [47.897525787353516, 1.5707511901855469], [1.5707511901855469, 14.932476043701172]],
                  "o": [[1.5707511901855469, 47.897525787353516], [47.897525787353516, 61.25925064086914], [61.25925064086914, 14.932476043701172], [14.932476043701172, 1.5707511901855469], [1.5707511901855469, 31.415000915527344]]
                }
              },
              "_render": true
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [31.415000915527344, 31.415000915527344],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [31.415000915527344, 31.415000915527344],
                "ix": 2
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 2
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 2
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "_render": true
            }],
            "_render": true
          }, {
            "ty": "fl",
            "c": {
              "a": 0,
              "k": [0.7098039215686275, 0.7019607843137254, 0.9490196078431372],
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 80,
              "ix": 2
            },
            "r": 1,
            "bm": 0,
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [0, 0],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [0, 0],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "tr",
          "p": {
            "a": 0,
            "k": [197.81288146972656, 197.81520080566406],
            "ix": 2
          },
          "a": {
            "a": 0,
            "k": [31.415000915527344, 31.415000915527344],
            "ix": 2
          },
          "s": {
            "a": 0,
            "k": [100, 100],
            "ix": 2
          },
          "r": {
            "a": 0,
            "k": 1.8762198932590582e-7,
            "ix": 2
          },
          "o": {
            "a": 0,
            "k": 100,
            "ix": 2
          },
          "sk": {
            "a": 0,
            "k": 0,
            "ix": 2
          },
          "sa": {
            "a": 0,
            "k": 0,
            "ix": 2
          },
          "_render": true
        }],
        "_render": true
      }],
      "ip": 0,
      "op": 121,
      "st": 0,
      "bm": 0,
      "completed": true
    }, {
      "ddd": 0,
      "ind": 4,
      "ty": 4,
      "nm": "Blur Overscan",
      "sr": 1,
      "ks": {
        "p": {
          "a": 0,
          "k": [0, 0],
          "ix": 2
        },
        "a": {
          "a": 0,
          "k": [0, 0],
          "ix": 2
        },
        "s": {
          "a": 0,
          "k": [100, 100],
          "ix": 2
        },
        "r": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "o": {
          "a": 0,
          "k": 100,
          "ix": 2
        },
        "sk": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "sa": {
          "a": 0,
          "k": 0,
          "ix": 2
        }
      },
      "ao": 0,
      "shapes": [{
        "ty": "rc",
        "d": 1,
        "s": {
          "a": 0,
          "k": [74, 74],
          "ix": 2
        },
        "p": {
          "a": 0,
          "k": [37, 37],
          "ix": 2
        },
        "r": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "_render": true
      }, {
        "ty": "fl",
        "c": {
          "a": 0,
          "k": [0, 0, 0],
          "ix": 2
        },
        "o": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "r": 1,
        "bm": 0,
        "_render": true
      }],
      "ip": 0,
      "op": 121,
      "st": 0,
      "bm": 0,
      "completed": true
    }]
  }, {
    "ddd": 0,
    "ind": 14,
    "ty": 4,
    "nm": "Lcok B",
    "sr": 1,
    "ks": {
      "p": {
        "a": 0,
        "k": [0, 0],
        "ix": 2
      },
      "a": {
        "a": 0,
        "k": [0, 0],
        "ix": 2
      },
      "s": {
        "a": 0,
        "k": [100, 100],
        "ix": 2
      },
      "r": {
        "a": 0,
        "k": 0,
        "ix": 2
      },
      "o": {
        "a": 0,
        "k": 100,
        "ix": 2
      },
      "sk": {
        "a": 0,
        "k": 0,
        "ix": 2
      },
      "sa": {
        "a": 0,
        "k": 0,
        "ix": 2
      }
    },
    "ao": 0,
    "parent": 13,
    "shapes": [{
      "ty": "gr",
      "nm": "Lcok B",
      "it": [{
        "ty": "sh",
        "d": 1,
        "ks": {
          "a": 0,
          "k": {
            "c": true,
            "v": [[31.414165496826172, 0], [0, 31.413225173950195], [31.414165496826172, 62.82645034790039], [62.827388763427734, 31.413225173950195], [31.414165496826172, 0]],
            "i": [[31.414165496826172, 0], [0, 14.062995910644531], [14.064876556396484, 62.82645034790039], [62.827388763427734, 48.76251411437988], [48.76345443725586, 0]],
            "o": [[14.064876556396484, 0], [0, 48.76251411437988], [48.76345443725586, 62.82645034790039], [62.827388763427734, 14.062995910644531], [31.414165496826172, 0]]
          }
        },
        "_render": true
      }, {
        "ty": "fl",
        "c": {
          "a": 0,
          "k": [0.09803921568627451, 0.09411764705882353, 0.10588235294117647],
          "ix": 2
        },
        "o": {
          "a": 0,
          "k": 100,
          "ix": 2
        },
        "r": 1,
        "bm": 0,
        "_render": true
      }, {
        "ty": "tr",
        "p": {
          "a": 0,
          "k": [197.8155059814453, 197.8134307861328],
          "ix": 2
        },
        "a": {
          "a": 0,
          "k": [31.413694381713867, 31.413225173950195],
          "ix": 2
        },
        "s": {
          "a": 0,
          "k": [99.99999403953552, -99.99999403953552],
          "ix": 2
        },
        "r": {
          "a": 0,
          "k": 179.99999999999997,
          "ix": 2
        },
        "o": {
          "a": 0,
          "k": 100,
          "ix": 2
        },
        "sk": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "sa": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "_render": true
      }],
      "_render": true
    }],
    "ip": 0,
    "op": 121,
    "st": 0,
    "bm": 0,
    "completed": true
  }, {
    "ddd": 0,
    "refId": "2",
    "ind": 15,
    "ty": 2,
    "nm": "BalaPng.png 1",
    "sr": 1,
    "ks": {
      "p": {
        "a": 1,
        "k": [{
          "t": 330,
          "s": [-24.505836486816406, -51.10407638549805],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          }
        }, {
          "t": 350,
          "s": [-24.505836486816406, -42.354042053222656],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          }
        }, {
          "t": 370,
          "s": [-42.5165901184082, -45.58359909057617],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          }
        }],
        "ix": 2
      },
      "a": {
        "a": 0,
        "k": [0, 0],
        "ix": 2
      },
      "s": {
        "a": 0,
        "k": [20, 20],
        "ix": 2
      },
      "r": {
        "a": 1,
        "k": [{
          "t": 350,
          "s": [0],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          }
        }, {
          "t": 370,
          "s": [-24],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          }
        }],
        "ix": 2
      },
      "o": {
        "a": 0,
        "k": 100,
        "ix": 2
      },
      "sk": {
        "a": 0,
        "k": 0,
        "ix": 2
      },
      "sa": {
        "a": 0,
        "k": 0,
        "ix": 2
      }
    },
    "ao": 0,
    "ip": 0,
    "op": 121,
    "st": 0,
    "bm": 0,
    "parent": 5,
    "completed": true
  }],
  "markers": [],
  "__complete": true
};
const CorrectPasswordAnimationConst = {
  "v": "5.7.5",
  "fr": 100,
  "ip": 0,
  "op": 140,
  "w": 171,
  "h": 171,
  "nm": "Comp 1",
  "ddd": 0,
  "metadata": {
    "lottielabInteractivity": {
      "__version": "v1",
      "initialState": "Typing",
      "states": {
        "Typing": {
          "segment": [0, 1.2],
          "speed": 1,
          "direction": "forward",
          "loop": true
        },
        "Wrong": {
          "segment": [1.57, 3.22],
          "speed": 1,
          "direction": "forward",
          "loop": false
        },
        "Correct": {
          "segment": [3.22, 4.5],
          "speed": 1,
          "direction": "forward",
          "loop": false
        }
      }
    }
  },
  "assets": [{
    "id": "0",
    "layers": [{
      "ddd": 0,
      "ind": 1,
      "ty": 4,
      "nm": "Blur",
      "sr": 1,
      "ks": {
        "p": {
          "a": 0,
          "k": [4, 4],
          "ix": 2
        },
        "a": {
          "a": 0,
          "k": [0, 0],
          "ix": 2
        },
        "s": {
          "a": 0,
          "k": [100, 100],
          "ix": 2
        },
        "r": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "o": {
          "a": 0,
          "k": 100,
          "ix": 2
        },
        "sk": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "sa": {
          "a": 0,
          "k": 0,
          "ix": 2
        }
      },
      "ao": 0,
      "shapes": [{
        "ty": "gr",
        "it": [{
          "ty": "gr",
          "nm": "Blur",
          "it": [{
            "ty": "gr",
            "nm": "Path",
            "it": [{
              "ty": "sh",
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "v": [[43.43000030517578, 21.71500015258789], [21.71500015258789, 43.43000030517578], [0, 21.71500015258789], [21.71500015258789, 0], [43.43000030517578, 21.71500015258789]],
                  "i": [[43.43000030517578, 21.71500015258789], [33.7078630647702, 43.43000030517578], [0, 33.7078630647702], [9.722137240405582, 0], [43.43000030517578, 9.722137240405582]],
                  "o": [[43.43000030517578, 33.7078630647702], [9.722137240405582, 43.43000030517578], [0, 9.722137240405582], [33.7078630647702, 0], [43.43000030517578, 21.71500015258789]]
                }
              },
              "_render": true
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [21.71500015258789, 21.71500015258789],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [21.71500015258789, 21.71500015258789],
                "ix": 2
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 2
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 2
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "_render": true
            }],
            "_render": true
          }, {
            "ty": "gr",
            "nm": "Path",
            "it": [{
              "ty": "sh",
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "v": [[1.0617037320242593, 21.234059169880997], [21.234059169880997, 41.40641460773774], [41.40641460773774, 21.234059169880997], [21.234059169880997, 1.0617037320242593], [1.0617037320242593, 21.234059169880997]],
                  "i": [[1.0617037320242593, 21.234059169880997], [10.093174299672262, 41.40641460773774], [41.40641460773774, 32.37494404008973], [32.37494404008973, 1.0617037320242593], [1.0617037320242593, 10.093174299672262]],
                  "o": [[1.0617037320242593, 32.37494404008973], [32.37494404008973, 41.40641460773774], [41.40641460773774, 10.093174299672262], [10.093174299672262, 1.0617037320242593], [1.0617037320242593, 21.234059169880997]]
                }
              },
              "_render": true
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [21.714996337890625, 21.714996337890625],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [21.234059169881, 21.234059169881],
                "ix": 2
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 2
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 2
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "_render": true
            }],
            "_render": true
          }, {
            "ty": "fl",
            "c": {
              "a": 0,
              "k": [0, 0, 0],
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "r": 1,
            "bm": 0,
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [0, 0],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [0, 0],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "tr",
          "p": {
            "a": 0,
            "k": [21.715782165527344, 21.715003967285156],
            "ix": 2
          },
          "a": {
            "a": 0,
            "k": [21.71500015258789, 21.71500015258789],
            "ix": 2
          },
          "s": {
            "a": 0,
            "k": [100, 100],
            "ix": 2
          },
          "r": {
            "a": 0,
            "k": 1.8762201477034328e-7,
            "ix": 2
          },
          "o": {
            "a": 0,
            "k": 100,
            "ix": 2
          },
          "sk": {
            "a": 0,
            "k": 0,
            "ix": 2
          },
          "sa": {
            "a": 0,
            "k": 0,
            "ix": 2
          },
          "_render": true
        }],
        "_render": true
      }],
      "ip": 0,
      "op": 141,
      "st": 0,
      "bm": 0,
      "completed": true
    }, {
      "ddd": 0,
      "ind": 2,
      "ty": 4,
      "nm": "Blur Overscan",
      "sr": 1,
      "ks": {
        "p": {
          "a": 0,
          "k": [0, 0],
          "ix": 2
        },
        "a": {
          "a": 0,
          "k": [0, 0],
          "ix": 2
        },
        "s": {
          "a": 0,
          "k": [100, 100],
          "ix": 2
        },
        "r": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "o": {
          "a": 0,
          "k": 100,
          "ix": 2
        },
        "sk": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "sa": {
          "a": 0,
          "k": 0,
          "ix": 2
        }
      },
      "ao": 0,
      "shapes": [{
        "ty": "rc",
        "d": 1,
        "s": {
          "a": 0,
          "k": [52, 52],
          "ix": 2
        },
        "p": {
          "a": 0,
          "k": [26, 26],
          "ix": 2
        },
        "r": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "_render": true
      }, {
        "ty": "fl",
        "c": {
          "a": 0,
          "k": [0, 0, 0],
          "ix": 2
        },
        "o": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "r": 1,
        "bm": 0,
        "_render": true
      }],
      "ip": 0,
      "op": 141,
      "st": 0,
      "bm": 0,
      "completed": true
    }]
  }, {
    "id": "1",
    "layers": [{
      "ddd": 0,
      "ind": 3,
      "ty": 4,
      "nm": "Blur",
      "sr": 1,
      "ks": {
        "p": {
          "a": 0,
          "k": [-161, -161],
          "ix": 2
        },
        "a": {
          "a": 0,
          "k": [0, 0],
          "ix": 2
        },
        "s": {
          "a": 0,
          "k": [100, 100],
          "ix": 2
        },
        "r": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "o": {
          "a": 0,
          "k": 100,
          "ix": 2
        },
        "sk": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "sa": {
          "a": 0,
          "k": 0,
          "ix": 2
        }
      },
      "ao": 0,
      "shapes": [{
        "ty": "gr",
        "it": [{
          "ty": "gr",
          "nm": "Blur",
          "it": [{
            "ty": "gr",
            "nm": "Path",
            "it": [{
              "ty": "sh",
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "v": [[62.83000183105469, 31.415000915527344], [31.415000915527344, 62.83000183105469], [0, 31.415000915527344], [31.415000915527344, 0], [62.83000183105469, 31.415000915527344]],
                  "i": [[62.83000183105469, 31.415000915527344], [48.7650260925293, 62.83000183105469], [0, 48.7650260925293], [14.06497573852539, 0], [62.83000183105469, 14.06497573852539]],
                  "o": [[62.83000183105469, 48.7650260925293], [14.06497573852539, 62.83000183105469], [0, 14.06497573852539], [48.7650260925293, 0], [62.83000183105469, 31.415000915527344]]
                }
              },
              "_render": true
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [31.415000915527344, 31.415000915527344],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [31.415000915527344, 31.415000915527344],
                "ix": 2
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 2
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 2
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "_render": true
            }],
            "_render": true
          }, {
            "ty": "gr",
            "nm": "Path",
            "it": [{
              "ty": "sh",
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "v": [[1.5707511901855469, 31.415000915527344], [31.415000915527344, 61.25925064086914], [61.25925064086914, 31.415000915527344], [31.415000915527344, 1.5707511901855469], [1.5707511901855469, 31.415000915527344]],
                  "i": [[1.5707511901855469, 31.415000915527344], [14.932476043701172, 61.25925064086914], [61.25925064086914, 47.897525787353516], [47.897525787353516, 1.5707511901855469], [1.5707511901855469, 14.932476043701172]],
                  "o": [[1.5707511901855469, 47.897525787353516], [47.897525787353516, 61.25925064086914], [61.25925064086914, 14.932476043701172], [14.932476043701172, 1.5707511901855469], [1.5707511901855469, 31.415000915527344]]
                }
              },
              "_render": true
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [31.415000915527344, 31.415000915527344],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [31.415000915527344, 31.415000915527344],
                "ix": 2
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 2
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 2
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "_render": true
            }],
            "_render": true
          }, {
            "ty": "fl",
            "c": {
              "a": 0,
              "k": [0.7098039215686275, 0.7019607843137254, 0.9490196078431372],
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 80,
              "ix": 2
            },
            "r": 1,
            "bm": 0,
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [0, 0],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [0, 0],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "tr",
          "p": {
            "a": 0,
            "k": [197.81288146972656, 197.81520080566406],
            "ix": 2
          },
          "a": {
            "a": 0,
            "k": [31.415000915527344, 31.415000915527344],
            "ix": 2
          },
          "s": {
            "a": 0,
            "k": [100, 100],
            "ix": 2
          },
          "r": {
            "a": 0,
            "k": 1.8762198932590582e-7,
            "ix": 2
          },
          "o": {
            "a": 0,
            "k": 100,
            "ix": 2
          },
          "sk": {
            "a": 0,
            "k": 0,
            "ix": 2
          },
          "sa": {
            "a": 0,
            "k": 0,
            "ix": 2
          },
          "_render": true
        }],
        "_render": true
      }],
      "ip": 0,
      "op": 141,
      "st": 0,
      "bm": 0,
      "completed": true
    }, {
      "ddd": 0,
      "ind": 4,
      "ty": 4,
      "nm": "Blur Overscan",
      "sr": 1,
      "ks": {
        "p": {
          "a": 0,
          "k": [0, 0],
          "ix": 2
        },
        "a": {
          "a": 0,
          "k": [0, 0],
          "ix": 2
        },
        "s": {
          "a": 0,
          "k": [100, 100],
          "ix": 2
        },
        "r": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "o": {
          "a": 0,
          "k": 100,
          "ix": 2
        },
        "sk": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "sa": {
          "a": 0,
          "k": 0,
          "ix": 2
        }
      },
      "ao": 0,
      "shapes": [{
        "ty": "rc",
        "d": 1,
        "s": {
          "a": 0,
          "k": [74, 74],
          "ix": 2
        },
        "p": {
          "a": 0,
          "k": [37, 37],
          "ix": 2
        },
        "r": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "_render": true
      }, {
        "ty": "fl",
        "c": {
          "a": 0,
          "k": [0, 0, 0],
          "ix": 2
        },
        "o": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "r": 1,
        "bm": 0,
        "_render": true
      }],
      "ip": 0,
      "op": 141,
      "st": 0,
      "bm": 0,
      "completed": true
    }]
  }, {
    "id": "2",
    "u": "",
    "p": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPkAAAEPCAYAAACA82IgAAAACXBIWXMAADddAAA3XQEZgEZdAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAFTDSURBVHgB7X3djx3Hdefpe4ekLMUWlcTYffNoH/1ibvZlkYdopPwBlrxAXgJbpODNQjFim1pbghzHHBoBnIcgErEwkGyCiETe9LCS/oC1RvuUfVnRQIA85IFjwEEE50OkLMskZ27XVt3q0+ezqu+QM3f4UT9gprurq6ur+9avzu+cqu4GaGhoaGhoaGhoaGi4R9FBw32NEMLm3t7e6dlsttn3/emY9HjXdU+EADGte3zIk9JPV4q5Ho+5PuT9ybDcjWVej8vl34kTJ3YxT8P9hUby+wCJyIvF4kwk8eci8c4k0kbCnYm7NmvHxTx4/Lg+cZ6p/Ynku/EvLX8ct6/FctPy+smTJ69Cwz2JRvJ7CIm8+/v7icRfGMiciHwm/Uyco1OETfunCHsIddXbifiJ6D+O538/dkg/bsS/N9BIfowYpPYWLIk8++JsJi3zKtbXR+4UiIdBEb9bpvH8fDvnBZWnDkv6cW0HMvF35vP5TpP860cj+RqRLHUk9bPRSj8VLd1W8qP5fo/UvtTmpNSEPX7wOnPyD+tX4/K9uP/t6OfvQMORo5H8iHH79u0zsUF/Ma5upT9N2NWtNZE5cYUfdlCre3BIZTBVZSS2vraCxE/W/e1o5RPxd6Hh0NFIfgQYJPhTIXRnuy5s8sbO12sBMU7kVUicCYQdwWFYd6zXVNCOn5OldrJuU3GCYV8i/OW9vfl7n/pUI/xhoZH8kJD86xg0ez4uI7G7Tc9ily3cuFYqG6aIK/lzWAQftiZaCfrwfr6uSniP/JLwe5Hwn9qFhjtGI/ldYPCxn4+N8VnIcvyO5Hcua1wrnMvfZ43jYch27fPXiM5VSiGHs2NFyz6sd5ejIrrSfPg7QyP5HSDJ8dgIE7ETwU8fNApeJ+zq6bRPpMDh4GBEX8WK+2llhaKtfZqgEzdfXyxOvNPk/OpoJD8ABnJfiI1uC9NWJXhliEmlefnWZcE9TEn3kiUvW3gdoyhLfQm8h8M9uRz/XWpj8dNoJJ8ASvK4+s3ka6e0O5k9psk6tZ/Sxq3Kvnq+7q5/5dWIXiK53lcKROJ2rc52SK7bmc26yxsbG1egwUUjeQHD7LNvxGUit5j3jfJRLpdHseNp29+n99fSSsevdCXmODlRhtLYljre86n9/NPpVq7XtktTc51g3bXZbHaxkd2ikVzhIOQeUtNRBeIeLslXJ7esGy8v80QPtXnLaZQUDSe0TcvpJdLX5hHoYJ3eHtYb2RUayQdwcsfN06XGVhjuGdaX/6vptM3zihInpfjBLPnRoOayeNZcE38Vy36nE4dykA6uzeeN7AmN5BG//OUvz8be/8KqPrcKABXW83adwKEoy6eIvOo89LuHvhdhguAHse5dcT8qDp/w3WScgX6jpYx/4WEefnuoSY7RclhhjPsgFnt1kvtp2tL79SnugaP4WdGPnxovL+WrWfLydrdCwK6rBOmW/3Hz8mKxuPgwTqx5KEkeLfdmbCSvpUks2Fj8h0OW/8W6JXBYIS8vM1TPY9NFChwE/Hgk3yrQeetWs05unUefx/rtXWG9ROxOdRD84Zjlf2DqJt7+cDEOu116mJ6Ge+hIHq33hb7vmd/NG2koBXMUcaeIL4/lOAjJ5f6DozajzJ9xlggjA3C1+fW2TDe1uM/63JSfb3uE1r9duUMgDBNq0mp62UUi+xV4CPDQkDxa7635fP5aehGD9u+gMgFlmuQyfZUgWpnoJhWQaHCXvraMrtvtO4W2ojA5pk55a362JXzZquv9Uw/U5Pu5vAGXY4f/wEv4B57kKWp+69atFFRL1nvC717+X8lqe9beruPxkqDS5y7t8+qmpbSXuavsWxW8Tvx+5fpy1cPT3ZIKnYA3ocbK+bqULwfnuhXIPv5WH8bl9x955JHX4QHFA03yZL3jD/0GRs0TSjIuL5f/VyB7mdj+9rjmpEGhPnWy3qmEvxPUAlt2uCwMx0yRnh8DVYLzbSvd63K+Jt/zNYyK7d3498KDaNUfWJLfvHnzNchTUcc0OdZNDZL90MNy+X8l6+0TWJLZs75TJNWyf7gC0B0FD3jVyyxb2ynUI+rcusv6yDzcGsu62I4CJqQ7ACe5l1Zb+q7Lg2vVHziSp8h5HBd9C5bvTYMhwIR7rcXV/nfNz65bb14OGHj5JTFKAa9Q9ddXVQcHgXzee/kfPPnOSSLJbf1ya/Xl+XR+tqXS7LBazbqXLDqfI69/1/Qc+4Pkqz9QJI/W+xtxsc2no3pRZGu5a4Q+CMlzfrlN+8mK+Mdaa3wQeX9QyA5ilfxlkub95X22rNL+Ulk1kuvjOJF90tuOhYNNj/3Sg/CU2wNBcgyugZLnTj6znJLm5UkwouSitS3xr2ydvQ6i5pfXiMpdEtuJaEvsH8uXPmn9l0JguXwfSXt9Lr9cmcemAXhj55rIMgjXCevPLbpGyEgW/SLcx7jvSZ7keVy8671yyRKRGjwOoxyE5LRdktGlITNwsBqhvUi8d17/GLuvJL2niMyP98jnHedLd915lKxqyTf394ETUbf+uLbwJOftOTKG3+OtuHzpfpXv9zXJf/GLX6QZa29EWbWU53KmE/lbRGBN4sAIz9MBSoG11UlZP650LNbZHuPVp2SpS+Xmbc9Httas3PBBBL1451C2+nqfrIfseEpWXSsD3YlYaS7r6i09+W6NxbLtXIurz9yPRL9vSR4t+AXI/vdyW0bOCTjLybPY0+RejdgyT9mPrgXraL+21tZd0KSV5eYy7sRP9yU2AH/ElqfhMSynQ2zaJ/Pz2XWyDvoYfx8oP7xeh2y9tXzXlt0fq2dt48MYkHvhscceexvuI9x3JP/www9PxyGONDx2tvassSY2kh33ySXlG44WBF11Kupq1poslian7lgysUpklmpEnXU8B1TiAgRs3FIdSCtpiV+yfpb40x0C3JVf7pXB8/r+Opfx3Kp7HQf9Lsu7eV/56fcVyRPBT536VPS/9dTUDCvFfcu9itWeip7bdIBygCyYMsq+fb2u3rl4B6bODKtYdT5zLQRpYUvR6Fq6H/FedV2mybJNimt57TFTJMdlp6x8cM8x3O/XHn300ZfgPsB9Q/JI8M1Tpx6JBIfNtO0H2YIrz8vktiSnbRB57Ln0enCPsZ1GMOfre7LYssPpTV1sOZ6MX015lK0njzh3Lvn8ABffJ4llJXT56TF9Ts+FoPPqcr193YEsOoAlu++nd2/duvXLF5544ol7+om2+4LkkeBnTp069RZOT/X8bzksdjALrjlRDojRfuse5LJK69YVWLUDKrsZej9PQ6uM55yGlOzT8pwfowkuiexJe8+al0jqqwhSGzq/PsbK+YOQvRvPJwO7429xLQ7fPhOJvgv3KO55kieCnzx58l2MoOMPhESmdU4au55w5/Lcf2GjVw4ewwnsEZorD11HvV+S2w8aljoc3PYsNh7iE6QT+yxJO7OejpnN+LFIcl6mJb4mnkdGnk/WtZRm99vy6yTXHRXeR9sO7m2i39Mk/+ijj56dz+dvcIJ7FlI3/tXleVcgdz1Y5SuIMUWVoevlEZ6n98t6xSgu24/l+NebfGjqJCjvVN01vEBavPc8R1HSesTtupnpDPg5sGwv8DVN+BKxqY3UOom6Re+cenmxBtGu7lmi37Mkj0Nkz8ebdzmt8x9UkqluvX1y1632KuT2rKa/hCVZtUVPPrhnpa0i6U3HVTu2Vk+9z7eApFg04bChZ0vtW3OZNhutOJe9lK7LkR2FJF/H1oHVn+qn4aeVLHqZ7L6Mt+e9l4l+T5I8ETyS47L28zyJOmUl5ZKfBYnYARSGoXSa7CQ86Q0u8ZCY3DpjOic3QFBkt3/5uF7dA61uZAyAn1Ojc9hQJl0nSJkIr7fx+FI+bRm9vLxeWjkMNTSkpPSs0OhavGvT+zx1AoW6+udnv/u127dvP3P69Old794eB+45kiPBwR26WP6HkgUvyXIpZXOaLRfTpwNqnOxehyI7ICIkJzVeR7b0lA8JjAoAj0tWPR/P74E8V66n9dl5/WrQnaq1zrSepLYmKVpqJHU+JlvuUn7qBHJecKV/5xIPt30pXyc7v046BzjXj+WX7gkpIHavE9F/OxL92r1A9HuK5MkHn83mb6UfPd0zvD/BSPTgWtASyWUZltSUXiJ3neSyLpyYJYucCEudVCZ0Px6Xydyb43iHoK/XWvXgXhdP0w2QN2ra7qrk5H61JrLcnjGLDmPa1Dkov5X5eQmgLTFvO/x66DrBXLde1+fShPc6Bbq3y//3DNHvGZKnKPqJEyfiOPjsNP+huPS0staXx0HIakLeLslzYMdSOdqfzqTk+7mlljKarDEIEhOx7ZIsfq/SZD6AoAgvlU2uR8+ul65dLqVsxW1LNrS0MJB1Jkjsr0srztOJ8JhHkx6AAnedSqc65fp2huzjFXWgrpFDKwAqj+8vEVzWg+4duVVwbX//+Il+T5A8TXTZ2Nh4n6LoBGkhNdF5J2CDXlSGttDl/ZjHWkR5fukjW0stCc3TepfgmtA6TXYEsvMg1WDvlb5OaemsBcN1K5c96W2JnZZ5fTZaepknpcO4LgnfFTsKKf8tyXgeUP57Po6uDe+Dt5/WraUuW3SpKmR76SPR94+V6MdO8kTwbMG7Tb3Pl6NWmlvLLYlet9o5vzwfL0MSBglL61Jaa6nNibpYLIAkeW+Ir8nd94vluTm58Zw8as/XcZaclutIbnb1ACbuIWVodJ1y6tB4M/FAWXEQpMZ9RPr5SHaZz0vj5WOenA4igAcijeqYjvdmzvE8UsHIDi84+bViqFl1T7ovb/r7e3t7vx2j7h/CMeBYSY4Ej6ubuYfle7UELZM8L32LjGUBlOdw+zI/mA6E+9mWzNqK9yIPEbyv/knL3rMOIZe1WGhfvVf3pXevowS0hqBmuuGkFi2dich5/3w+Y/vQes8N4TWh5/O5svaS/NrCU314PbQ70QmSyYk5wK7TktEaWU5uvi3PpVUFnVe3rbATf8dnHn/88fKPcUQ4VpL//Oc/fz/enDM6XVtpLY9LJJdlLP+D54PjOvefPCvOyYx5auSWVrsf0zJRF4rQi2W6JP9iJHWN9Nyic8vNFYb1w3UniJaLGmcCBj0pQt6pdetnJ1JryZ7Iz9PxL5EbSYx5sHxOfLvkf77E91wM32eW8l1DJ3F14/npskPsjGxHxN/w9fh7n48WHdaJDTgmxEj6a/FGuAQPBT/cSnRNXtmIieg8z7gGQ5wMwBnj9qLjJR9bW27PQicyc4KnTqBkza3VXyhycz+chtY40fU9wkaKxOeNdvmfNX5JmE4FxWAgLxhJjsTNy5S2Lyx4SkvXhml9n/IsRvKna+UdQgjpuH5YcknfA5gJNsEQnbeFPH6erhE7/U508ngPeJ6c1o33MpfN1V0+JrUjcgVmpjza7r4RY0/XY3kX1+mfH4sljxb8QrxB27KHlA0TLRWl+344HMD/lpabjtVpRGLc5pbTBtG0xeVkRYuOJM8EzrIbyZzzLRiZA+sIFlCLxHPfn98rfp+QwLrDy5C/Af0mM0Z4WteBNB1wQ+uNFltbcFqiFff3awXgB/Lmol7Sb5cWve6nqzvipk356dpl6Eze4TcIMRD3pRiIe3tdRF87ydNYeFy8xX8EbXV0A17uKZIchjSxBXhpfmcgfW2pHChqbeU4LXngLBM0KAu9EMSuLalT2FfbPUg/3EbmAfj4eRBk5vdsCvz3GFKWUXBpLck31yTPUrtzSYu+OU/z1svHyc6EfP0O9Fi7Vh2a8P61+sT20j2yS9eAy3ffHYi/yYfxt/9P64q4r5XkKdAWf7zkh4/vZOOSfJrkANMSXTdq7ZNbac6JnaAlMSe1luXSGuc8sacWREerjdYaLTRZc76/HpCjJXVE7D7txuXVeFuvxyw/iTyIjam/ke/1bDdf/z5ohLARf5elz7gJyw9Bzj6XlrGxxu1uk1smnPyCpOYBNyLffCQmrUtSS5Kn5caYj0g/F759zjcH6ZdTsC+B6qLjCSAsbFfw19WdKe7jZJeqoXOtu73n4Voi+joi7msjeXqrS/wBEsE35alLpFtdokMhcq6tO7feoMbZS8NgRCxJdE5IaZmJvJLk+5H8cn9KwyCdteLUeWiCx9ruxn878e9q3+//JOa5ur29vQtHgDfffBP+4R/+4Uzfd5vxvGciqZ6KyWfSnAZOcm3JuVWm9flI1LQe/VNj0TnR8Y98/BnrPGZMohPRpUXXKsQLzC23oCzbyT+XabQ9RXKATpyPtdW349Dac7/2a78GR4m1kfzGjRsp0PZNfTO15fasOc/HjyvBSncAKc91h5Ito46Ue/KcCE3+srTSiyWZcRvXM4mDIbuU9ekci1Geo5VP1jnufy/ev53F4vZOJPSxvokEib9YzCLZYSsS6qlk8Tn5NNk9eZ5JviHSkfjaR8+dwpwpAlIK0qLLiTo+2dNVeDKeYjcZHsH1uvS9y/65Dggu21qIv+tLUba/fpSyfS0kjwRPXzYRF1L3wWU65cdjSUbpfUMKcJkuOwceQacxZj4WzSeceNZbL7M8l4RORE3puJ6XC7GOpNfKIJ46yu3FTlx/p+/33j5uUk8BSR/F8lMxMv1sJNYWEZwi69Zq49+GIXgiNFn/uZH51n8nVSHjBXqCzcyV69pCL7dW9tOpDKsWyj760L4T0lNrO0dF9CMnefLD442NMh1Oy9NxXzg4f5gHl7JXHUsJ/FJ0NFmSmkjvyXNtwXHGGUW/uQxHcmuLjWloscmK97C3t88kvA6+hUTsq/F0FxeLW1fvdWKXsL39bvz/fzdPnAhb8Zd4PjbcLRt0k/43EjqRPP1xq53T5izvhrHwfLzdRuJ5wI4HDsFI6uV/h+yUTsbDk/hEYl0+EZ9P0MlYtrVr8e83jupdcUdO8uvXr1+Tfvi0D673a6wq1XUZ/Bx6SMzKc5qswmU5BtWI+PvLNElykuRpmY/h1p2kfvzbiTWLvtmtK/crsUtAws/n4ZuxcX8xEm1TWvSNMejGia4te95H69q6c1+fR95tRF4G4zQBuUUOAQnLVaN8t1/Jp7ediEd0wmDILsf2c+4o/PMjJXm04hfihW3jxdX94pIVB3GsB71PSvygJHowspwPTfGZajwgRgT3rPZiIPqekuzcmsu/iLdj+Zf+6I9e3YGHAD/84Q9jh//R2WTdIyG3OFHJP+fEPjHuP3Fig3UEG6M1R6uPljx3AHYaLUpmvs1lND7PruW79M/LsL56ieTc0svx8+yfL1761V/91UP3z4+M5JHgW5C/UQagplZqf1vOLtMkBeAyPafxntePomui8wku3pxwIjlKcRkcQwueybw/EHtvtNRo0THwRv64kOfX475LUY6//qBZ7VWR/ffdMzHA+M1I4Od5VB2tdVpmYpOER3InInNr7w/JkXWXY+pybF8OC+qHXTrh9tV5hw2QiMsJjeXSecG4CUP7T8Npv3HYr486EpKn4bJ4c5IfvmkDDeQfkyXVPrM0zb4Vp5sDaiycExxJzIfK9LCYDq7xABn3vdEyI4GTj01yHa32vrHy8S/525eiJH9oya3x7rvvwt/+7d9uxtuzHYn7PFl2IrMmeSK+JPyGE8CzE2w4sbl0l1Y91Uo/1rr8L8iOIB/dh7Xc4Fp1Jxi9E9vc04cp24+K5OkzRt9cnqDrhGxeLdCWUZbopAxgnNlW8r/xlUpWqpNfHFgwjQ+F7bu+N0lzst5xvJN1ABhsWy4juW9vN3L7QLLHn2U7Ev15JLCU7hvs7wTrBDaYlMdg3gZTBnwyDUb6O6jNmNMTWKS1RfAAnMTq0t12AijbY/s8VNl+6CRP0fRY2Wu6fmg5cb1E8OAyuzPrKR/5+lSGLB+U/y1nq9l55gtluRfMzyaCJ0Ij6a0138fx7Z1bt/pz29uv7kLDJP7iL/4Cfvaz689Frv5ZJOWmHE47Mcr0tI7EPnHihJDvPCLPfX0+r54ec+3AvqHGEjLBEr1Mch6c48eXST4b8zD39MO4/9Bk+6GT/F//9V+X0XSy4AmSdPYJL0luDHhQhNNPp2NoaAwgGJlu/W+aaILWm4bCpO9t//ZGcnNfnFnw3f39/tzDElA7bLz22mvw8cc3o4Tf+EYk42ki8XwkeInsdry9JN/l7DwMwnlkT9CyOsMnuIYmuozu87LNsNrb0Zo/dxjW/FBJHgm+jKZT0dbf9t5YKn3pbrKanOA2km4JLie4LJT1tr43XyKxkdS0vjfKdHZMlOY3mzS/S3AJH4n6PPfBieiZ2IngXLZL+V6eSENPwHmz47RVT7XSVl0bpeC6l7mMfAwu7RAe349lLmfDPfPrv/7rO3dL9EMjeZLpkTDXMJLoSXD+iGTOU5Lo00TH4/m6VAv6sUz/MVAcFuNDZJzQycpnf3tvlOrSsqdOY393b2/RrPchA4fdImkvRIJu8qAbER0tOS15UI6k+5yNs3tTYmfjhBmMtlNAjiy6j5JVz52B55tzsid4k2QiIp9mdz1JZgaHhNjIt9NS+9o0+aRXwbAgCC/BrbO+eJlHnjOnUzRdEjxbbTmRBSU6/qG/nZbp7/btW3F5e1jfE8tM+NuXbt785D82gh8+vva1r8Fv/uZ/vhzC/jOxk92hzhbv/+1hnZY8D1dlWcHxqcX8WX39Fp8cqM3BWhBuoQ/56jLupuI2b/ekKuUDUKhuWWzpyVj/b/ocWR2HYsn/5V/+ZfmM+LLAjiy5H0X3ffBhDTxSe/4Ql/hhHAvn4+D2ZQ78WW+ceYZDXiS7SY6nJTYaTMOOIJ4jjXmf+853XnkbGo4cyVf/5JPbabjtgoy2owUnGc+XOlrPp8zqJ9roJRTyMVZuhRNsIC5BGh0ExZCApXVukE9L94EnH8b63lUQ7lBI/s///M9q6mqN4J4PLofD+LqOVELlhQ96air3wfmTXjQjbeEMg3Fi76m00eJfBVg89+qrLXK+Trzxxhvw059+8PTJkxt/Hcm7aUlOsp1LdyS7fcpNPvfOfXQbkPN8Zx0so3WePuZmTC+TXPrmAy7HcfNzd+qb3zXJf/azn52NJ38DxKSBULHk4Ep0fOcWrxqV1wG9owvzW4KHAGxiC385ogyyyamokuBkwW8PJN8f5d+Q/8qtW7/8ZguuHQ+GoNyTXTf/ERJdkvoEnDx5Qvjr3KJ7ATnto3PC20AZAKcNGSGpSL1gnLTmJYJ3jlJYlvLMZz/72R24AxwGyZkVxyqVSA6OH46WXAc37I2cKl/Lc0ny3sxGQ2Lj7LVE5ORvayuOxI/5Lr766ivb0HCsiB1sWjxx6tRjr6XZcjzqzq26tegnDMlpHJ2mwXLrnkAWfTYSddqq0oiSTidFsLo1j+16J5L86Tux5ndF8ijTL8STb1srXhoT98bD5XfPaJuTvGbBdWCP+97yfWty3rkcGiNS+zI9PSH06qsvX4aGewbJT795c1/46SdOnGQ+ORL/pInII7lTHiS2N8SGBNcWPaFEOD9QR0o0E3tZQoHoct/Q3kPcviNrfsfR9X/6p3/ajAQ6K4kdKlacLHjeP1y6suqc+AjdeXjrkvQ8WroQ003lePhC+OBoyXnALe6/HjuNpxvB7z2cP38eHnlkYzv+jhcpKCoj7Pk31sOe+2zS00K5d/qZhqBcUEliz1ITeBBaBuDCRGA65+FtG7q4fuFOIu13TPLYyz0fF5u4zS03DQ9YK46VhuqMIbtfdwxhjKLL4Qg+DKJfaywnuuyZMW8aH7+N29HvXkSCf3sHGu5JJKI/9tip7b29/iU++sGVGP2u9slA7Ox78dLM3myHgvuJsSKEjC1Zi647CnI1ddm9IPyQ96kPPvhgCw6IOyJ5suLx5GeHU7s3wFp3a8U9cKmC4L2pPB+wG4I/ju6Z6Y0uUqrzB032VO+/bBBLgr/88stXoeGexte//nV4/PFHX4u/6Qu80759+7Zyw/YF4ZH0/D179ApsOX7uW1oQbTGBB4vJG9aTXCTBkS+c6Po5j+GYSIv5ga35HVrybMXxYjSR9YC/tOIWfEgiBH3zZI+ppQxXDTzCzl+z5EXUrRXnln3RCH6fIU2c+cxnHnsj/n6J6IEHTbHjts8ZeH+S2PzJRUnQ5X/XYGUDJdsrrts/HquSHxXh7gIZx/7A1vwOSd6fpYuwX/Ow1tsPQICZ2UZLPdygiQ8gLTiR3b5sUVtxTn5J7mVDuB4lVyP4fYhE9Mcee+SNvb3FS/rJQIyzlIiuP4bB4zvSiGiLLl3MKaWKeZl1FoaqzB/yzSMjLly7dg1WxYFJHqX6WRisuPW1oVjRXFm6yAwuaSTkcdYlkEES/eCJfYTUPnCyZ6RbbgyL515++Xwj+H2KJN0/9amN9GHBi97Tg9ai08NJub3ss/a1AO4j86mnfvvMipOPBnkR+CDkPi8rKMJbaz7keyqODmzBijgwyeOJLmCFtN/tP2FmffLaXPQ8nMD9d+6b9ABmbnoP9jlxevjESvZ99QAKj7Yuzrcg2/2PFIw7eXJjO81rsNZcvgOAv02Xz4q0cy4kAWVAGQDUPHWtRH3UDZnmELfm8/nG91b1zQ9E8p/+9Kdn40k2g/GZ7R8GDvDC3UsUwYpOpcvA25DTyBo9sy2lyY8WLNhw2V6R4PGYi6+88u3XoeGBQCL6fN5d7Pv9K/h7Z2Lvgf8+voVy8ZD03rsA9QNQXgPX7ZntURO+goozQXFImncoYesf//Efz8AKOBDJ07AZnsTreTyrTZXOx2F66SZw6QLiGfQePB9cRtLl65t08I3ewcbfoprkWX/plVf++zY0PFD4+OOPQ5S15yNh36fRFD2cRm0BH1zCURrb7ig4xq15AledCTillRsoC+IF+fggVEMuu3dIn8bN4ewq1nxlkufJL+mF+aAqxk+sP8CnL1APJcCY7kzjA+7X6N5M96Tcj+KRUvpx7YsYh8kSux9//NE2NDxwSNNfb9y4/uH+/q3/En/vD/VDSbxd0JduqO3Iz0YHIdv5BzF5W+ekx5lsmuDUhgHAROu5exoqMa6lS/CV3d3d01P3YWWSx0DVtiS2Z8Vlb8ZlCG13Zv5vjeDcF5dfE7Wzk7yprGTF952efLG7v9893R42eXCRiP7v//2/uxbbzZe4NedTm3O6/HCG/Ax1LyS7NjZQiKrbNP7YqsyXl3Ve6TRYfnn2xFmYwEokj+H69DnbLw5VgZJE1/4EyREtVeREASvX5awh2aPpC5bfCS//6V57GTndfvXV87vQ8EDj3LlzaW76e8kt49F1Pn+Cj8Toh5vkk40eAUFYWVzmNswlvFc7/Qj1FL+wzEys2Sx8cWo4bSWSz+fzZ2Ohp1frabwebNpv4BfNL0YTWgZB7OeDcxpF12m66oL9uMtjLn3rWy9dgYaHAi+99FLo+1Pn4+++g20hDpcCt+5S/eF38LwpruXAm1av3lOVhM6x/lrF2kAcTTBb/j0FUB9OW1Gud89LeQIuwTGdKmwlzFgik+p80j6wi/Wtt3xVj4yE0qt99Cue6Euiy44g+uGwDQ0PFT755PMhumcvpI9dyI9R0ggMnxyjR224b47z2bnRKRkz/VaYYa3Y9qWf788aZR1ALKF/NoSyIZ0keZQCm7GALZIIdTkRVAChPl5Ye4UOFFUCD37gjbaz3PZVoI1+wBj5jH74+eaHP2TY3n4aHn10di22ooterEY+vKI/N70Qw2cUeffVbEJwffTsjpbAlTBv6wCebM+YzbpqAG4VS34WwPc/SlY8LfVbXrwII4gJBMDK0D43T+M3muQ5l1TUK/fGN495L8Yx1F1oeCiRZsQ98sjJS0m2cwLLNuK5gPJpNG5ty8aOEz2M0fZaJ8C2BJ+0NZePwabPgkNxzHyS5DHg9rwltx9sw8p5vsZQGqwCWa48r/9oqX7N0747Vp5k+s9/Dm3Cy0OOz3/+82E+hxdie7murXd+o+s+mwizYAZFfvG23P6BrQdhvcsG0B9e5kTXlpxtx76jK86Aq5I8SvUz8cBNX6Z7Ft2rpEzDcUNcBuGHA8geEhS57YcKuf9EvbJ8WSNNU0wjKk2mP+x4+umnUzu6lr4wK927pAB75ZsHJtXDSG7ylb2AGLq2HJaA/Gk1rWqtus15glLPbP+ZkmSvkjy9+YWfGAvUPZitBL8QfkH6Iv1ez3MDdOCN+0O9egurtuLDM+aXX3rpGy2a3rDEjRs34MSJ7lJSd9RW9rGtuENp9Jy5fpTaa6dWjmdoq12KS5VVM54LO568DadjnZ/1zlgleRobX02igyCnvSj/grmVl70XlaXnDWvf29uW8gufJlpchIaGAWmSzOOPP/5hNGXnaHIVxXN4e+LxH1yH4UEpbtE1QcHM+CwbPf+9cZwXVjEsczDJHoe6v+JJ9iLJSapTpT15rqUDq7a5ALkdwPNDZGdRDmxIcmuCy8dMY/7LLdjWoJEmyZw8efK92D52dKBNtydSjHyCjDRCJVfWtnWLlK80C85TuHqMfiD/matXrxrJXiR5rPwWuFF1a7WD8iGG6oGWJfQ+aemH0IVJhcB9cR1ow8kK2jfXUxLzzWhWvMHHo48+GpvR/kWaRCUVIJfsclSHy+UAVsmWlmVYW0nBOs67ikE8/Su/8ismyj4rnzB80ZPn/kUF8Ry4h/KUPi37ZbANwPZc3qw3DIr0ZkoiNCveUARZc9iRMybLw2qyDdbe6OIZPy3Zq+9axyNABt0ArLpdnie90dX45S7J01z1eMAWnkhLD05ukhX8Yuy4eI6k6wvRx5MfI/0dSXzfN98H/eqn/EPsNSveUEWy5rFdXSTffAF8bJw/EKXVpeSHlewZnOV2mqv03y0k97gB5PvzX4yjfeXv/u7vxPEuySNJtsAZyrK9CZ4kV2BZ9c6SGy/Ujg/S8aXyZdBN3kh5420wLqJZ8YZJZGs+ey82mZ3crryPZMo565Lo8v3sHCFogsv98nFUb36JDObxzoNH9ln+01GZCMleIvmzXGpYaUBBMR1B9KWJHvDneX2p7rkJXK7LXnbBfhiaW7xY3G5WvGElZGveX+TtSvvl8o1D1uhIS9uPZfN2DcC/GOQNK/szQ8mo0nkAtHrI+XI8jVDwybunLNEAtBSh3ms8zq2w9ccDqywUSa0DHCHIqKYn3XEMPZ61WfGGlYHWPK7ukJHQz5LzOJF8UIpkPFlXvk4I4pNiiK4SfKcifP4pI5hK2uLHG5L//d///WY8bBMLtbId02XF7cXICupna3l2+SEFEOfUfogevuDEJrIH2NuDK9DQcABECx2t+eId2dZkgJeTmvviRH4AAE/xZuT9nVG4nrGUaWRQC+QezxX59FvcLzckD2F2Jrh+MS9In8gG2vzBfU+KgOgpvVgAv5m+ZJeWPR61e/78izvQ0HAA/Nu//VsK4F5Jc9ox8MuttTYu1G4BKEjMDR7Jc9qm9AT+YZFSzGp5hCC47lBkvrhf+OWOXF9s6R6CLLiVIDSxJUxKDh1Z9/IHJ+CmpZB3s5Hw+aJn29DQcECkWXBxnPl6bJdXZNuSQ2alvwTODWzHmC5VcBjzyC+ZgtlP4GUHcY4QQKiJ/f39Lczr+eRPab0vg1+aiBR4C8WAgpQf8kbo8vk2jGTOPaU300j+ZanevwcNDXeA+XweJTu8zdu3DsbZYBfJerLoOfDGeYOQrqquAX+pRGdmwfkGl843GMP0VNoX8DhB8vfffz+Nj5/RvRLvLbiPIV9tw3smTJNTW7k08YfQALjVphlF4BCak33Bb/w7UarvQkPDHSAF4B55ZOO95PJpUkufXEp2bpikT563CfKRU98wll1cLM8axKC58hRuC5JvbGwognsHg7gQPCk4g/z4ehvZWdD59DifrjhAML2pjrDnJR0bO5O3oKHhLhB5kMTvFQBLIvva8VLcyLq2GVr5dmNbRyBvwAloS35ITso6wSbOYxckjyc8Yystew1gQ19DYSDLIAuPJ5dWPJjKW2KX68BlOR1Dvenv//5/uwINDXeBxx57LMn2McpOS3wzTD8aOhwP57Jck9bw3KATf1Lxgig/AYfg9fk0R5LRTvkEyWOFz1j/mxckK8398eX/TvrefI4uHe6PnUuZ0zukli+MkLOP8vFx3zvQ0HCX+J3f+Z3UZq9G13aX2r982qwciOtH46YVKahIeIIOtIEYqgaQ3zsHKBtCzdFUx86SPF7Y53gl8GCsgH1ulmQFHwevRdk1ZC/k93pYee4eZFL3zJL36TNOTao3HAqyweoHo1EiNEyk5aP5kngSQD+oYuvAt7RfL40uno+NQqVil8E3ZcnDVlki8wLxpN3Yy/Dext4sXUkQnYdWBuUeMghi8/rkC9x7DxoaDgEpyh7p8Q6o2NOUGynz9MCtuIZv1EgVI6dKXxjS5wQbQ5Mkj5F15Y/ni2JFsz8ryccqOpNgZPQwGFJ7leQXkYldkifYK3ZXX3yxRdUbDgdnz56FU6fm6Tv114NyW/Xoj5bJALaN8liSJDaqX/v5MDv0zI+RBpF4JTqczbTklvy0JRiongHcCvrIlh4rUkqzakH2fDKfd9x4A5oVbzg0DES7HtcS0RWZPaNUtuq27OV/AOC8wDQO2yFoPox7BHfHtNMxwr45kjx2SsKSqx4BfMnRFSx65zycoi/I6zDkRchpgrSUvWFe2diAd6Gh4RBx4sSJ2OT6d2Sb5UTHpTaE3LJ2jHhh8pxcptenunbjOYjcNnYQ3Y4vcEu+ibNmdA8kLXhJrkt5HgJU5+JS2fZmeO6C7RHljb11q/sxNDQcIvb29tLbjsZ25VnvYc8o330XFwyfQMS0MvSnw6x8p+N9mQ5GScRreHJGJ4AvyF4BzMXwdB8lPxxUJa0fYz8ep29mB1yyc4sff4jdF188twsNDYeI5JdHS3iVUjz5LBWp5Q62Ua1cidBMXot9/Dwel7jh5QqCxQS6+Pc5JtcD88ltQEFLDe9DbTLNr1S28OSX23PwTobfrF7kUdKlWfGGQ0dqp1GypwdWdilV+74B9DPn0seWypcbpxKnuNSnY62SxX26I+G8iWmnmVxPkTgulcEU4ksOUGm+9eYXwS9QT8Cni+TSJzjnE73eVWhoOALMZrPU9sagLm+jcpvSiTO9yZ+PCY7SldziX1fh4+jUucjJMbQOSvF22SdPD6bA8P1xyhSU+QdRCQQnaX1CTLa+5GvIXoov5bnK58bzzGYb70NDwxGgX86fThF2atfapQSwfOHE40+keYbKH4YWRmzMz+e0W5cXQAeqU4R9SfLonG9KsgFwp173RpzMtifjEULe63SqPN2ByGglLenc+ibhzen72z+BhoYjwGc+85n4v9ulNiynmpaCYnk9uGXyYDMeg0tvtigVY1/0WIqhUR36PIQWK3paZ+A9gz4ZP2npeViKDC6PoL3Mb6fyg7pAPUSmAx5yEv+5c+eaXG84Enz605+O//d/rBUoWvQSkQmW8P4s0NJkmGA4VDoHPw/n8ZLkfY8kB+C+sJUi4EgEO8PNQgYg9I3hFrwW7JMKIJcbXaZdaGg4ImxtbcX/nfkSrm/8pEzHfVJKU15cty4sd239KeNefMzzyVP6QPK905bIZTkOJrpNwQLq4er5/YrqGyahgxXD9i40NBwRcoT909dnM2xnYUy3X+W1stmzwBR489RxWf165XAlDMLFJTW+MaRsZpJyXwF7k6AqwKUGXminKqVrVbby1joHl/yitI5HHLsb0NBwhJjPb0dDOLuOfrm2zhkYc7LElq4npfnkJe5BYdhMgwgOguR532jJAQCCIyuCUzlJZpIcNGPNn+lmy5KVJJmiKy8hAyByDLOh4fBx6tQp0c7w22Ucw7v+h3VPwvvt3w6lyW0u6evG0vIXuTobMpy2PZMNvPET+wSU762yj8jZilr/vAcPPJCHFzzc7OvQ0HCEuHlzI7W5G1GyQzn0JHdQBD7Duq/gPKgCoF1lLevtegDpHmu5Tk+hndbja2jdsVAeSNAn45Fuvk/K/Jm4CEnmIBQBvwB5Hu6Pj3J9FxoajhAbGzeZMenMHPOyStWxKY8/0q+nL50CVGPZQL69HLEygfJuxg/QH27TlrwcSDApZphATggAgGEuOh820+WRxaaSeVo6x3w+h4aGo0R6Gi2RnMv0moXlJKPJM8HhiYZ+qWMH2j3VkKo6qHQxhNZDKeQ/HCIqYqomzt6BJLCescOHCYDdjA60mpBBCCpf9nbdh9DQsAbg6BG2axl/KnFE80pKa6l4A9hXQUn57qM8ISalidc/4Y4cMQ9OJQDACRx4ATfZ69gZPlNShKb2SZ8Fy6YI+6JF1xuOFCnwNpvNhnamXUZuhMaHQphV19Led2/97XK6pyBom3cKAQNvPXgD9bqgTE4dOOsqQwHduO6TvlxRfvPIcnfOekPD0eLjjz+O7XOx9MnRuNgPi1C7BDWZLK9TedoN9tUAx6TOF2Xzc/PAm3LWQVUUt71xQN45yOOs3Oe+hvZrvDL1jQhsHW/oBjQ0HC0+G//mwshIyGAxj2lx+LErv5zllmjnFj7frAoffPKgeoAS0fUJqLK8Unld+tFcrks/BRz4N1NacmhoWAs++9k0IcaqWHIbMSW4LmsoOtOdWlI5+bi87h+uja08jgfj+PPkoMPvXgU9/xvEJICatJCWXPc6Xl7yY0SwbfzbaIa8YS2Y6fkZIF1SMNvaEKIa9eadjyUwQ5m3/Vcy8+Nl0FxvjyTvHcutZTivBKgLk70aDRvIC/Q7gbJl9gMUpBSaT96wTqT2xifE6C8GZZBrqtsvH1aTea3rWgusIZfEWZnl5gY7QVhyXhFOek5aKbsl6XGftcpd4UbI8/oV74xv0nzyhuMBNzAstZMxI8yrraoup2z15WeLZXsPhWA3n9LaCfd7hifwSOZe5vKCtJyX29JPAaDOwvNB/Bun/XdgwxNyvLKh4egxm4EidieWuW12ah/mRo7okSlryfk+kt88v376zQO35qMlD8CXXDLwk+C+WmfAH1Thx1BPp/1w3WF0gsS8Y0hSSfaCjeUN60KaWdkt3/mWQJO1AHKbnY3r05PIpJL1hqft1FkolOVJdzmyNT6F5jntmGkVi+kRn1dU9ki8oihBAvAxRn48SnbsLKgTaCRvWB+wfVLgF9OLR6hlhpXmaBzr07y9MuQx1rgmKJ9c90DaT7e+NK+oDx1s6FRZPOLOpbktmw+rYVqLrjesA3kILa1NGRZtJLUF126oNK6mNKV2c5rdtvNX8nFqMgzfQUt7bk5KvpTAngnGuex8H5WF8p5ePsGPB0Vw2Vk0S96wPmS57geBEyRRrD9uH/jSzVe3dbYHrAEetpgqllacSD8OoWEm6jnkRXDCeidjxYtoPF6gLynkW12lnNc9oowy0o1oprxhPaD2B86wFnLDIyjCIyiYNNsREB+tHNcWXM5cHQNv9Oy4DoLV0FX31caxZTDBXpDeVx6bb5a8YZ3onJiQbefeyJJXlj2mM+fSeWWEX6tqf4RMyHVf/8MkZM9Gj4zKCKRPSjl0ptWCXVLUHRoa1gaa1uoPk2H79whOkfNOKGM9ZKwDb5KTHhGxPqESYZffJxeVHYvpuO73/Qm6iFJlrAyxEcYO8LE8fo7pCGZDwzqQqaJJTSC/e0wxPjIfIfKNKp1DDyPXCUBKIBRqLiqqUkIwfgFWlh+zqtXGY+XNIlnunWs42ixT3hZdb1gXeGDMcyF5uufu+h0Evca8JPNLMSrMV1Pbo0/OTygP5mQr9SR2phpW2p4wVCoLLN33TZo1bzhekDxebgn/mEtk38iVrTyMo0k2v55Cy/3vAJxvxFcZ9BbPk/sELMtvm6Z9EF65ca2QDia9LI06J1DR0HC08NtwSXHWLLkebuOz5Oxj2XKYjPJxf5xPr+UjVQliCI0QnErpitm89q0Y/km1P++R1bf0PNjRCN6wfnDJXiI4D0LzfRSc69wxchpd4tZYdy68E5GWXOYlGT+TlZLQ5Czpf5lPW2rvYRI9JBCq+WvWvqFh3eDuIxm3qQ4goaSKg5onQm6y5BZ//+JU46fj1Ysc7brX4+iCvICBfjOMBPU6pQ4m18GPB/hPszU0HB3yU2hIXtnufDWq1S9ZXY36OPsUAky9qMUZQqsdAGrcrh5Eo/KC8tO7aqUQXsBBT3dtM94ajhtWdSKh7YQWars+sT0ucbXLOxSPT9XJMCV44+a6N7PR9XIlcpnyc0q8nIk+BoDNnW9yvWG90OqUeKDJjCi5t2xrlOty/BzGcktKofxQi3yrk3kzzBSk3+ClcQsfWDDBlmNJbV/g6MsbaGg4FvAhLCvJpT/NUqFS4lguD8zxNB234sfZ+skAeIJryb1I+HSPxMP4SHDq7TCNKmL9ft5J2HHG4MqchobjAbVtj6A2r0aZ+OTilvIE5xi55NVwHjUlEopqmnryx+68dE5aWyE/yEfy3n/hI6yQ1tBw1LDup1zHbR1480B59TsMaR1YHr8MOXQmY2UFS+6/qTUTmKyxLlTkFP54MEE0Gn6Q523Ebbj3QURGecyH1QhI1Hq7RsWryem5sz4va/VkJOe6n2t63ZPgsJaceQMiTVpp/wkZWqf0qYdcGhqOEx6BuRuK26BmvekHr/B4stiyzSMXNcH5OaZe5sjrVPHJJZn165p4AEIGCuTJZS9HnYd3AXbKHhT9khZ8a1gv5mI0SE+AQXgdgQ/9IlP9fbVy8M4LYltjSSg8oBLMAfKiyr0ISXAbPNOBN+8C6mnesQ0N64GMGfVsGFgPrfFjpjljZ7qVCe0PYVue8TQ38FaX4F2xkrgflYCWMTra7p0PirPbqBzus7RHTRvWDfTDuWUv8cJa2RJxg9sZ+EHqUJi/kuvBo/0JM5tJH+z7ExbS+luCW8lPWWwsoITakF5Dw1HCPmzFXVlL0rIPr8vF/T4J/ZGtbPWl5Kd6wtQ4uec32xNRHpIQOV3LBStrfH9mlefXy5HHhob1gPvlWqF6ctuOSJV5g/vAvDRCpoEzalWCkus88GUrxbYAexEvzN91JYJSzzdduRqDtVRqaDh68MleeSkt+ZAKOhIOYN/wWuONfkGk54fL8t3ajvWpvBlGFxJEpenk5ggoTYLxOw15U6agJdD+PjQ0rAEL426CeVCk3JY9Mmp5L9/BoOeflAPRdfe5o2+hTUfNPetet7ZUYd5zkXTJ6TORH2Bq/A/Y8U2vN6wL8+V/DLpZTLXfYPLroWpuyfk5bDMPK+1DzPCEcsmq4ozJ0T7fonMCSt+cJIcMxnHLv6pVzzeiRdcb1gkvYj7scfJq9UsGji9lGd5cE51P81X76vKAwhAaryg4J5TfKvMCBd5kGdy2WF2u83KaJW9YJ7hR811VSTD/c0fgDoNRVu0SlLhZMozWuIohtFVeI+u9S8qeCFQF/R6qXPlyefLc0HzyhrUCeYJKlHhTkusdAKxmjMgVtdaYnx+Y7+8ZXW0AZ7YAqBTOK1CqeAf+jLfAooYg/ryhAZh8FA/aZJiGtYPHhHC7NL+DE28q5sWH4moK1R9Ok0ZXdxKT0fUySnnlK2R5Xv1QS9m34UEHX977xzY0HB1w6Lfrym3fbuc/b8oqQhq7VRq1tfRyVpwsZ4XXPwVTCEyMYWMePSnG5BQBCD2+TpHG0jHdQfqkhoa7BH+3eV6C2B5ymfxISt52tYEio9VVOTPkBlAT1mqHTH4miSoMK8POcJPb/PFTPbQGE0MRPG+z5A3rBPniNTJwKyrjV9Qp2KNW5RcaROmT11GIrgdWaEkWeAxDaWIDed62Pq99rFWXPR49HtcCbw3rwWIYvyarK+NUCC6l/SEuGY/iFjznLU0mw7weP7QrDOUZb36hfJ2ux+tCusJ6LSgBplKrPBSDN7wF3hrWD/mqptLMNLLcZf+Z0oKJrkt3luDxw866I9Krp9B0L6ALqklkHVQLYB9I6URZrGSAFYcZ8Fz8pjQ0HD3yjDcydJqUyzWQPrl+7Zlcouup387Kv1WgsZqslwcyS+5bXtuLBJi24lhh8k1KhLRkL8EGN1rgrWHd4MaQpDv3wX23crmX+eRyXBvGYTiK3vuNW/r1NR66Q2i8gnYIyx/qWsWya5mvcgXKWyet7ITwBjefvGE9WIxr/LnyaUNT+zSS7BTq8S4Q56dvouVzsL2mjIIll5XMlcIT+ENatiIAenZcbUbdnaL55A3rwXxc04EzGjXyLXDJQJK81xnqStVa+nqnMFu18Gn/10r82awc1/OGE1CC2PdYgyl7tV60oeHw4Ee1ad1/g2owvjkSm7dl+Y6FKZVc22c7GvczSbLierjA+gMyaCeH0HCmj66UDkLIfXwc0ItMrjJhoKHhaMDV7CoB5JTf+1iI5BmqAXAnykzXaVwDirBnFN4Mo6rjBN/suJzOXxpioPPpC8KoJVW2hHL0saHhaLAA/vJGqURtUHjYm1PcYLVVvlqdekHp0uPdNaz0ZhhORmtJw0TAgD7hKh+K9y9CLutxgoaGdQONllS4U+2xvl/P/uSkt3nl8DE/ls4lFcXkZBgsYLWeI5+gpArKM9pypey7svy68H0tut6wHtA4OUL70HYdzDFeGicoVwlyv7T8NXdXncknee3AVQrF3k3OwgHwZ+rQ/iElH1GV4mTlW3S9YZ3w2z9/1zkfftb5QqEsbPOlF0nIcr3zy3Nw96Bb/dPFNk+AcmW4XLCRcuvTONU25C/laWhYH/RoELVjek+iHlrL68v/hbLICPI2LbmhuVBSD51Jm/y4gv82l/ojpDRZQAYcZIChFECoE5tcgXq+hobDhn6e3BsrBxM1x2NtUE1acvK1dWfhG8KusG4zVz+uACoUzwstv71iVfJZ/7w2nc8tofG8YY0gSZ4h163hoVlxfkP1yvKGqIc97no9up9R/biCF0CTw2dlyAfsO1GuZ9GdEmD6HC3w1rBeyPkfnKjdMH5ektFhooOw6lZGzq3by/PKc0pjOTGE5lvx8nuhidB6SiuvhA37AzvG+vJeHbCMFnhrWCfIMHUV+U1pUBgKxs6i1imUAm8HeXNMQvXNMNz/GHMM1t3vTbqxctQRUO+GVt1/pdPqs9imPsDe0LAOWMvstUupjgkd8M8h8Q7Bj9LXAm929hwf2So8T+75F0HkK0cBO9MRkOWWVp4ikx3LXyK67YBS9ibXG44b9Px3V9g/rjEpruW3lPqWC1LKY5r1nDtVflcKvHVgZXc9gmf3UYchx8s1wWV6qXORPRtdcJPrDesGvhAFJTr50iUjRRwquaq5XB7B911eHgMAMVxH59Ixs+oXVKbeJUVTXC0Zvdcv886DbhCvNO3HNF/Cy46ioWH9KLVBKaO5dNaK14PkA7DjpJWvj6HLfZVx8mACbDmfJCrAqm+wBHfMnfsfXh10/qEW0NBwXLBxKm7QpOK1hKR9VJ6W7/p89vxluuk6VOeuo58MbgXLYXy/V/GCeDoi6Y016vwNDccJP4KeYdsvl/Gh0H61keRfIIICajyxdRBy3b51sisUVvu0Kl7YagE0Pllglc/EiDM10jesEXImJ7DJLphDWlHKx6PmyxSYhuaXDsLJbWv9af/M31GK9nGJXY7A4zrvnXiF9PiihuxAyjek+eQN68MC+KPSHKVgGpfVdsy7E/n43HcelNZql52VnTsU5pxkVKLreeldGA0DeP66jgjyzkF3FHqddxw1RdDY3bBuzE2Kjq6XZHSeJQpVlFTplPW3x1nerPyZJCqUiFrupTipeS/l5efpq1lwLL+h4ThQjm7boFfmwZShsn78ndWJOpmKJe/cg+X2dCU0WUv+uSYqnwBgjwnqHNDQsFbwOSOkZu3+Evw225mx7+ljMC9f5zNMq9F1T2p0kyfRvZp9ssyPIJb9DVAz8GhdK4I2463hOCD98JprKdUvHeOVF1g59Iopzi/ZuVgXetgryl75W2j0rKv2uTXkBZceVNGVt+f1/Rt9fJvx1nAckAT0pbeeEMYJ6kXDZXl0DO9IqKPI/MD88isulB+g+sFDSU76omOnCiv1InwyjTzGEt/KlLG0UBrCy2vNkjesB4viHhkck1FzP58NTMt0UrxlyI6j7N4WP3io13Ul5MX4U2J5ND1U8+ny5PnKNyqhWfKG9WBenMzlpbOtgkzvHM5JZVCeLVeDdh3CtE9ug2NUUPE0nd3mPjneHD6MJivW0HA/QkpqUOPXNnY1HMVGqaSP75xhNLL2vFiuPFenH1A5HJLJIJscbsMT84F+8lUO3G01NKwN5WcvSvlxdGm5tUzj7V1H6OV8EZuu1/W5VMq4puT6FMlsj1HKw6U6BSlk2t2hWf2G9UJOevGgg8U5HsUttp4IJo/V54NSTZzzevXMWOnjCrlCeAHBiQzKpZcm92kr35n0evAh16Op+4Z1ggyWN3SF73jT+3i0nW/LKa/leNW4pc4n89Xcgkm5bqN3nYkA+j2TJGnJH+Hhf/uADF82NBwveEyJAw1g3ehooxXc4TJ5Hns+zhuqF6jzHHCc3Mdqb2zNlfJ7IH5BB3HFvWhmQ8M6UPrCybSMh8p+qWp1dB3Ta8f5eahTWfnjCjISqD+BZC2wfG1UJyQFt/xaalifRtcHDtQpNDQcDhbucC6PNVnUouA+ZHS9rKx1udaaUx2qr3/yTuSTzPrSPGLudRSy0yhX0EdoZG84dvBI+ZCic4z5NDx31U6QmR7S9vNxw9ut/hSaHcsr+QRjqnusruidErUp9oZ1w48dZfiSXZLVC0zzdT62LbcpzeOQqqXID/Idbx3ACk+hucWKYIC9MJTk6G/YgMJBGdsY3rBu2OfJ+SQu/qyFbtcp6p7bv3RtZQDbuq31wFsJurMRltyrJD+oVFjdQuslOK/HqQUk/OE6Smxz1xvWBW/6qrW2XXE4TBtSHmTjAWjvPewwMcfdxgboPK5P7kUQVZXBe7ukHyjgX4iA8SK8KLn/bne/A0B10OauN6wTvN36QeMyMctRckloXj4tNbc81ewb5CXJ+56fsO7v4gnL0Xg31ZTr93Y1X4cfF4plNDQcFaYfGFk98FYLMPsucr2xl4N2g08+m4GZhVaG7q38k2GPx9/2wiPqdxI445L/TstoaLgb1Kea+ryoR8RloIyrg/qwtmf8sBzuFogHVPxwfY3wU/v4q5+8SOFBLTHvrabq1tBwuMjPk3Pflw8TA1jiWek+3WC5r82NoszjfSddvjiCH1OYDBPcwvEE2FPUxv/ohRFeeeXy9ds0fHTNijesGTm6rn1yCqh50PNHyo1WtnvPl7dBPyQ7rvO3JR/glcxeZahSXk8jv/0UCsfC5LH1Xo86iRZdb1gPFioCri05gvxw/ZWhen7e7i2hwZ0Ys5qUnZzxpsHn68owPskWPssNK6196OlB/ek6pGNbdL1hPSBLzmdwWiPO9yGBQ9GwYd6c7g2F1bGKop1NHVgaQuPrvJK2Z+pYnnqNSuN8um6lm9XQcHSgd7yhgeMGT0OOJHUiTcaTAvgvPbVD1LStO4E6EWZ+pfz1g0BOAeyc/fYY7lPACpHKO61bQ8PBoWe8ecTSI0mStJiGHQQq4RJpvUlpPCbgA+NllEfJde8R0lIQILBt3BdM/qmvoshoot8h2PyN4A3HA7LCUs3iPglOeO7ediY/jkQRXfwXQPKYAM8j6xL8wFtJekxFDnXgzMp1PLE6ukjW+rPqjdwNxwMu1ymVCNxB+bvlSDyvXLT2XMXmdMkRbTwDUwNBjZPzJdg3w+jvKeknb/Cl7m51Q3DXa9bZ6yRKD8uUjmtoOHrMwb5ivNTeM/hwMxQf/qKouuZMOVAXln5+zRhWxskDq1gQvZOd1GIliu2NKG8pmJejkPamgZoJZEoMjegNxwXiBM3qTJAGcOq1UPQ5JM2xOnn1syCYTnUojJPX/QluyTGdBwL8itBxnRhSkB2DHEKw8C8YhxvaOHnDuuC/401/Kahj+WX7LpQK3sNe4gxjHIwvS/mtaph8x5vvq0uLbUP8AJ6voS8G/+QkAR3oK7sG6bg2Tt6wTlBbld8uK33Oa5UYEg/IldVpqByr88m8B3yRo+ylapAKwB9H9INvq/jipAiaJW84DsgPf5KLawNksCJC8Rjp3q7+ElUs90BfNa1Zb10pPb3Vm+VDFt9KDCqLAhN4HN7ghGbJG9aDFF3HmWseDywhtFJFaAmvXWKfW9zAdkIJ07mCK99npYJMVjXezbd9Agc29sff1hqccm0P6NSAld8eUGlYN9JkGMkBbx0qz4lTfnDy6AZNwTzu/vLzeRzw0syLHEuTYaiXwEBa6SKlH88jjHxSgAxKyOhiDXpcsMn1hvWByHVQ39k3ZKFoxe24N1SOBQAoqYAg3wxjexiU0rpgLb9lUA4j6Vqmo9X2KpLPHyqV9dOaXG9YD/j3yTtXpnP5zKENYgj9mJ+XYZ/aDOAFo50zUM3qljwUDyoRTlp3XAanPMovt20+VAky4i7LaWg4TpC7qo2gyKW2pU/tQQ/NgfOiRjuXhOcLyk/PKzOvwJzBErOMTi2DIzu4JPGI6+9juVyfvqFhvQguSa21pvw6bTVedWLaqg5m6zrp4pzJMNgrsVMcKPQvnyG3J6QyPdLnaLkN5HkRSK/8hoZ1gBspG5PqmLEiHvC2D9VAHI/cy46BW3E+u04a4iDK4ZjxA+yJV4Hns5ekhcyrx/+mzi1vWEYLvDWsD3a2mWeRtRXPaYGlBRZA9g0jdRbBTFkFCBWOaF65z5MH90C9LnsU7hsEVR6dTF4oR2fSfQlfuiENDUeLHJyuNbwANUst3Vc+LyS47qs+Rst9Oqfmllbl6oOHsnAiGA+C6WmqVGlCbbK8ljK8giQ3ajeLejho/nnDmjBDzRv0krfxoJa8vRJSWh97Dc4dLsetJPeNLO4rzYgTgTfeM3gSWh8oOcgvIu/reyK/L9k7lQbgDx9I4nvqoKFhHUiWvE7ktPQntJSOg8LYOR6j/W2/4+D16KkUZjiXo8yW2Pl5VUqvR+F4r5YfZp+xbY/oltBUYTB5de8pb1RzyhvWB65y+bsVpMua82hiogGcz21Z6ixCsWplXUrT58X0wZL36mT8BAH8KJ8sKDBfQ1aQ91pk5bU00VabKqsvnnrM0Ex5wxpBxOJ8ANWGvai35EDim+YR5kv8SH9UnuQKP0bnpbhBEHXesBcgJ8BT6D+onod6LU5Ost4wlBVM+bwTYLcQ7A2lcnVerFvjecN6kBg0YwoXOZEIO2ME7Ia0biBi5oA0iPatLrq9U5vvQRrboPgTjLHV7gCbFCpJyyuGvUdOw8r3Ym46X6L/TNYdVAXCYNFlBXMwQl4AvwmeLGloWAcWC4gym7uf/Dt/XJ1iZyBJmNp7dmWxY4ChDPlBEV6Op3r5n+aQVdnGkucK5YtIlZiPRMf9shcBtxOgiwLjj/Oy8hKY9ACW5vdcch+MnUlDwzpAijVF20nZJuM0W4bfsxFM5Ev7kdh8mSxzyqt5wSeAURvvGdnJCGKaZyzzdi/SBpLnymGFU+AMpQcWlC+KZIj1p0m25M4CwEqSYC4AK0SdQ696IynxdXpDw3qQHlCZA7mjXFESb2azzIO8nfzkbjn8lo0ejBxBJcxfWoplcuIuFinvYoLgvVry9MGS24F+IjSdnCQK9ky8svnCcr50oX2fI+z8yTNOZis9eijJDrmvFyRvlrxhHUhynb+sBED6vZkb/cgDtOTJcmOn0Pc0xJU6BD03fbkWOMEXDk9wXy/SUtnSqpOxHEieJIT2x7tl+nw+H3qPDrLU6AQx0wXgkkv1RPThctgNgLEnIgkiZUhZqkgrjh3G/v4B32DV0HBHWDCjlziS23yy0qkDmLFmmNZDgNFlReOXg2gZONSMD56E0UfvFdH7kWv8j2JYvTGCnOwi8EZ+NQw9UQ4goL9BvRQRez6X21mWhGX+ZMkp+NYrS84r15teincCvLL6BmS0cfKG9QCHq7JFn41pKSBnFS5a837kVNfNB4J2Q6eQ1TJXCFbZSnLL/f1SypPh5Hzqh3MOljxHBOX88URoHRlEshGxdYChHyOFuTfDKbDaClOF5QX0Zh/vDGhcMJeTTtUeUGlYB1CdZkPYuZYcv2qSoN1ItPTZYAJgVB0njvEYFgbPPI7kvwWT6L1Yt4qY+eS8gkRkrBhFv3kQAZEJD8NFz4TvwSfMhzFAJ3srXtlSEIH29ePNyIvG8oajR9/v7+J73jD4hjKbCNwNbm03xKVyerbkVFbuGLpl/sy7boyL6faOHMn+uSU1BubyMYvBTcC32OTw/yDXF4BRP3r/WjdUOsv27E+gX46Vli+LwADDjDsobByRIoJlS8732329kuotwt6wHuzv7+9ubGR1m4Akp6mtYeAQKta58dMTsM3PZnOmCmjyGJF8IYwhciD56Nyic2nOOTWUtvyPlvw6BgVQiqBFxk+yUBABCY/bicT5dbXpmCw/ekbEbvTNtRXPFVuIC+AVtuTnE2aG0rtU94aGo8PTTz8Nb7755m5sh9dj0zud0ojkFIyTT6rJpzXJxeyEEcR1jId5KtdyYsECcouRN9wQDjVZ1mOw5P0uSQsuQ+hhE5IkFHTIBE7b8/Fi0uT7PNzAZ/LwyHtfkOr9KDekNClb8lT8jRs3dqGh4YixsbEBN2/e2ol8eBbT0KfO6pWkduZItuaZR1kBJK7w0SlUvriewF1UIjfJ8GzJFyZeRUQPiiPd1SHwFnbJz8V3S2Uy0zxd6qH42yaz9YZRppNc79jwAI2xY0V4oIACCUHIEB1o0GPk8ay7586da5a84cjxySefpEb3fyIvnkWrm9t4z1xdLt1JtuflbAhez0SQmlt14qAebu4Lwbcpd3bJ4/eWJI9j4Tv7+7fZJXVDdDyMFUPLnnskad3RgvPeSb90jiKHHsl7R7L7FyCDev2PoaFhDfjd3/1duHLlyuX5fOPPGIcGS45Dx2TJ8zrObpst55tIIwjMJUYDmqHHuq1E57KdB920FYcQ/95Znu255567HgvdTQegY5/XF2NB/C+lxUAE207599l6Tud59Db2RHhM+tvf5+frxflpP+/JuregoWENyMbr0euxLe7wNhmj7rFd7g3tf3/ZxlM7xbae1vNyD/b29tS+fcMtPF5u77Fj9sY/5BwtObeW9dv98pe/vDNOhok7r8Q+5MJwSSA/bxSUr4B+B/chUI7gYP9M3SCSIjyIJq35wpUmJX88do7vQUPD2vCL1Py+H9vvFrqu6JLiBDK01jhxLFnwZMlTOk6OwQB11/EYmB1mrnEDh9V0YJpNsw3xNBdzLQf8zd/8zVYcc3sXtyl6iBWkv+xLzIftLl7IxpiOQ2848Z5LEd1RkNTQEh0vyE7dG0pKZe88//yXn4aGhjXijTfe6KKl/VEietrmUXbkS5bmmSPEFc6lbiA5cSSDJrBoN5bzwSM8f9BrqNe13/u9//of0vpoyZNZf+ONyzsx4xYfv0uBBeqJZsNFUG+VAgt9v7e8MJoMQ/44Biiop6KxcpqATxXOfgeRvBRQiGVehoaG9SNEqfz96FFv8WHi/OxHN3CDnkjLfCHrzQmOx+in2niQ2TN2/vAyBsOX8bDE4Isw1o7hL//yL7di5d+lkL6sPLfqRGrZayHR+fAZzt3FXoaGBGyFeeDNTr4fe6ndr371hSehoeEY8Fd/9VfdrVu3XotN8xuYxq05N4hyvWNSnZOcB94sye1QM/FDq+OhLu/+wR987ZmxbvoC/vzP/2eU7FmKcN+cKpnJjNFCfRG0pF5qWfVxWEDP0PH9b7LkXIpkbGzMzn71q1+9Ag0Nx4DUFi9duvRENIj/L25u8tEk5Aone+bDfOQFubYzMcxMbm0P9Mx47xKdOgGy4gmxqGtx+5nz58/vYpr5Juje3uJitPZb2LvoHorPhuN+uSQ6Jzh/5xuf1hqMv0FP1QSRJsf9khX/vUbwhmNDas9vvvnmh7u7u1+K8agfhWEWHAXiiAdkzRdKqlMMC9hLW7gh9Cw5N5KUD+e1pH/9S9/61rd2RX29i7h06X+8HhdKivDeCSuvAwyUT4+TA5CckAE3SXrtZ2DngFL/xImNJ1988cVdaGg4Zvzwhz+Ejz76xbnY7v8a26kXiCuRGyeN8WcwKPC2AB6Ak891UCSdjzYlP/yVV769revpft07jv1tx57lqbh6JgR6YMWSfTEuidwghgio8li2nnhPT5dp600XAsOFdBe//vVG8IZ7A1/72tcS0d+4fv2jtPnX6V9gs+GI0GCMJHeFCdySk5HTEXT+uHXG8hwX//APX9326tmVLuC1117b3N/vfxQLezKMY4KdkiE84MYlSjdeHKi3WeYbYXsl62cQwYdps6+//PK3zkNDwz2GCxcuxDa68Wxsp4noT+T22jGCkwsriS8fcEFwgsulDLBh7ljE+e9973uXSvUrkjzhBz/4wSbAPAYXwhMheGOCVn5IqU7DaF5F9fQ93lthpzDcg8uvvvrKOWhouEexvb2dFk/G9vy/Y7N9Uo5/d8aiL1OFIaT2jm+gyVO4uYEMzH1N/7rdGP8+F8/9Xq1uVZLnyv9gcz4PS4suK6zJzqOF/CWOEnpIDOei84hiYMMJsYzL3/3udxrBG+4LJLLfurW3HVe/BwO/5HByJzgi9/MIu4xJMXIvV+Ixlz75ZOPi669vTz6gNUnyoeKbURREosOTGA2kJ9R80qMcyRWmitMFSOtN+8fpfcsphN///oVtaGi4j5CIfvPmzejuhu1Iga/AQAX6+gpZec4RTONKlvEh7U//d6L1vvgnf/In761an5VIjvjud7/3Wlx8IyQ3QPVOWGFNcDDvjgvmIoKIoC+H267Fnu6FP/7j7R1oaLhPkch+/frNza5bWvbfin+bsCQEDS1nyAh7Apflcf16zHplPu/e/tM//dOVyQ2s9APhO9/5zpnFIvwvXmHZO/GgW96mige2JLLnB1uWeVMQ4dLNm59EGfJ6e0684YFBCs7duHFjK3qnW7GtR8L3Z2J7Py1999GKJ1JfjTz6cQxzvROTr94NHw5McsS3v/3ts7EyX49/Z0D4HhRs45NgCEHL92VPNZ/PUk91KcqQXWhoeAiQLP0HH3ywydMeeeSR64dt4P4/Dwroa4/wgFIAAAAASUVORK5CYII=",
    "w": 249,
    "h": 271,
    "e": 1
  }, {
    "id": "3",
    "u": "",
    "p": "data:image/png;base64,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",
    "w": 357,
    "h": 357,
    "e": 1
  }],
  "layers": [{
    "ddd": 0,
    "ind": 5,
    "ty": 3,
    "nm": "Lock",
    "sr": 1,
    "ks": {
      "p": {
        "a": 0,
        "k": [85.10450744628906, 83.90176391601562],
        "ix": 2
      },
      "a": {
        "a": 0,
        "k": [0, 0],
        "ix": 2
      },
      "s": {
        "a": 1,
        "k": [{
          "t": 0,
          "s": [100, 100],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          },
          "__fnct": [null, null]
        }, {
          "t": 20,
          "s": [80, 80],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          },
          "__fnct": [null, null]
        }, {
          "t": 40,
          "s": [100, 100],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          }
        }],
        "ix": 2
      },
      "r": {
        "a": 1,
        "k": [{
          "t": 0,
          "s": [0],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          },
          "__fnct": [null]
        }, {
          "t": 20,
          "s": [0],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          },
          "__fnct": [null]
        }, {
          "t": 40,
          "s": [-4],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          }
        }],
        "ix": 2
      },
      "o": {
        "a": 0,
        "k": 100,
        "ix": 2
      },
      "sk": {
        "a": 0,
        "k": 0,
        "ix": 2
      },
      "sa": {
        "a": 0,
        "k": 0,
        "ix": 2
      }
    },
    "ao": 0,
    "ip": 0,
    "op": 141,
    "st": 0,
    "bm": 0,
    "completed": true
  }, {
    "ddd": 0,
    "ind": 6,
    "ty": 3,
    "nm": "Badane",
    "sr": 1,
    "ks": {
      "p": {
        "a": 1,
        "k": [{
          "t": 20,
          "s": [1.6947784423828125, 18.566986083984375],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          },
          "__fnct": [null, null]
        }, {
          "t": 40,
          "s": [3.689906597137451, 18.706499099731445],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          }
        }],
        "ix": 2
      },
      "a": {
        "a": 0,
        "k": [0, 0],
        "ix": 2
      },
      "s": {
        "a": 0,
        "k": [99.99999668543774, 99.99999668543774],
        "ix": 2
      },
      "r": {
        "a": 1,
        "k": [{
          "t": 20,
          "s": [3.999999525469073],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          },
          "__fnct": [null]
        }, {
          "t": 40,
          "s": [-11],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          }
        }],
        "ix": 2
      },
      "o": {
        "a": 0,
        "k": 100,
        "ix": 2
      },
      "sk": {
        "a": 0,
        "k": 0,
        "ix": 2
      },
      "sa": {
        "a": 0,
        "k": 0,
        "ix": 2
      }
    },
    "ao": 0,
    "ip": 0,
    "op": 141,
    "st": 0,
    "bm": 0,
    "parent": 5,
    "completed": true
  }, {
    "ddd": 0,
    "ind": 7,
    "ty": 4,
    "nm": "Middle Circle",
    "sr": 1,
    "ks": {
      "p": {
        "a": 0,
        "k": [0, 0],
        "ix": 2
      },
      "a": {
        "a": 0,
        "k": [0, 0],
        "ix": 2
      },
      "s": {
        "a": 0,
        "k": [100, 100],
        "ix": 2
      },
      "r": {
        "a": 0,
        "k": 0,
        "ix": 2
      },
      "o": {
        "a": 0,
        "k": 100,
        "ix": 2
      },
      "sk": {
        "a": 0,
        "k": 0,
        "ix": 2
      },
      "sa": {
        "a": 0,
        "k": 0,
        "ix": 2
      }
    },
    "ao": 0,
    "parent": 6,
    "shapes": [{
      "ty": "gr",
      "it": [{
        "ty": "gr",
        "nm": "Circle A",
        "it": [{
          "ty": "sh",
          "d": 1,
          "ks": {
            "a": 0,
            "k": {
              "c": true,
              "v": [[13.647854804992676, 6.823927402496338], [6.823927402496338, 13.647854804992676], [0, 6.823927402496338], [6.823927402496338, 0], [13.647854804992676, 6.823927402496338]],
              "i": [[13.647854804992676, 6.823927402496338], [10.592678620604888, 13.647854804992676], [0, 10.592678620604888], [3.0551761843877885, 0], [13.647854804992676, 3.0551761843877885]],
              "o": [[13.647854804992676, 10.592678620604888], [3.0551761843877885, 13.647854804992676], [0, 3.0551761843877885], [10.592678620604888, 0], [13.647854804992676, 6.823927402496338]]
            }
          },
          "_render": true
        }, {
          "ty": "st",
          "c": {
            "a": 0,
            "k": [0.49411764705882355, 0.49411764705882355, 0.49411764705882355],
            "ix": 2
          },
          "o": {
            "a": 0,
            "k": 100,
            "ix": 2
          },
          "w": {
            "a": 0,
            "k": 0.20000000298023224,
            "ix": 2
          },
          "lc": 2,
          "lj": 1,
          "ml": 4,
          "_render": true
        }, {
          "ty": "tr",
          "p": {
            "a": 0,
            "k": [-0.0008451848407275975, 0.1417044699192047],
            "ix": 2
          },
          "a": {
            "a": 0,
            "k": [6.823927402496338, 6.823927402496338],
            "ix": 2
          },
          "s": {
            "a": 0,
            "k": [100, -100],
            "ix": 2
          },
          "r": {
            "a": 0,
            "k": 180,
            "ix": 2
          },
          "o": {
            "a": 0,
            "k": 40.00000059604645,
            "ix": 2
          },
          "sk": {
            "a": 0,
            "k": 0,
            "ix": 2
          },
          "sa": {
            "a": 0,
            "k": 0,
            "ix": 2
          },
          "_render": true
        }],
        "_render": true
      }, {
        "ty": "gr",
        "nm": "Cicle B",
        "it": [{
          "ty": "sh",
          "d": 1,
          "ks": {
            "a": 0,
            "k": {
              "c": true,
              "v": [[8.86856460571289, 0], [17.73712921142578, 8.869507040676757], [8.86856460571289, 17.73807144165039], [0, 8.869507040676757], [8.86856460571289, 0]],
              "i": [[8.86856460571289, 0], [17.73712921142578, 3.971604110622632], [13.766467648839768, 17.73807144165039], [0, 13.767409970730881], [3.9697202694893052, 0]],
              "o": [[13.766467648839768, 0], [17.73712921142578, 13.767409970730881], [3.9697202694893052, 17.73807144165039], [0, 3.971604110622632], [8.86856460571289, 0]]
            }
          },
          "_render": true
        }, {
          "ty": "gf",
          "o": {
            "a": 0,
            "k": 100,
            "ix": 2
          },
          "r": 1,
          "bm": 0,
          "g": {
            "p": 2,
            "k": {
              "a": 0,
              "k": [0, 0.10980392156862745, 0.10980392156862745, 0.10980392156862745, 1, 0.35294117647058826, 0.35294117647058826, 0.35294117647058826, 0, 1, 1, 1],
              "ix": 2
            }
          },
          "s": {
            "a": 0,
            "k": [13.157401572815616, 16.89004670104441],
            "ix": 2
          },
          "e": {
            "a": 0,
            "k": [5.555846583042921, 0.016679778670152245],
            "ix": 2
          },
          "t": 1,
          "_render": true
        }, {
          "ty": "tr",
          "p": {
            "a": 0,
            "k": [-0.0025287296157330275, -0.0019147867569699883],
            "ix": 2
          },
          "a": {
            "a": 0,
            "k": [8.86856460571289, 8.869035720825195],
            "ix": 2
          },
          "s": {
            "a": 0,
            "k": [100, -100],
            "ix": 2
          },
          "r": {
            "a": 0,
            "k": 180,
            "ix": 2
          },
          "o": {
            "a": 0,
            "k": 100,
            "ix": 2
          },
          "sk": {
            "a": 0,
            "k": 0,
            "ix": 2
          },
          "sa": {
            "a": 0,
            "k": 0,
            "ix": 2
          },
          "_render": true
        }],
        "_render": true
      }, {
        "ty": "gr",
        "nm": "Citcle 3",
        "it": [{
          "ty": "sh",
          "d": 1,
          "ks": {
            "a": 0,
            "k": {
              "c": true,
              "v": [[12.03059693778647, 0], [24.060251235961914, 12.029655195927457], [12.03059693778647, 24.060251235961914], [0, 12.029655195927457], [12.03059693778647, 0]],
              "i": [[12.03059693778647, 0], [24.060251235961914, 5.386468970891877], [18.674724455805055, 24.060251235961914], [0, 18.673782713946046], [5.386469419767883, 0]],
              "o": [[18.674724455805055, 0], [24.060251235961914, 18.673782713946046], [5.386469419767883, 24.060251235961914], [0, 5.386468970891877], [12.03059693778647, 0]]
            }
          },
          "_render": true
        }, {
          "ty": "gf",
          "o": {
            "a": 0,
            "k": 100,
            "ix": 2
          },
          "r": 1,
          "bm": 0,
          "g": {
            "p": 2,
            "k": {
              "a": 0,
              "k": [0, 0, 0, 0, 1, 0.12941176470588237, 0.10588235294117647, 0.19607843137254902, 0, 1, 1, 1],
              "ix": 2
            }
          },
          "s": {
            "a": 0,
            "k": [17.847893178252207, 22.909974646964656],
            "ix": 2
          },
          "e": {
            "a": 0,
            "k": [7.536454350818133, 0.02262476316460038],
            "ix": 2
          },
          "t": 1,
          "_render": true
        }, {
          "ty": "tr",
          "p": {
            "a": 0,
            "k": [-9.894472441374091e-7, 1.9125218386761844e-7],
            "ix": 2
          },
          "a": {
            "a": 0,
            "k": [12.030125617980957, 12.030125617980957],
            "ix": 2
          },
          "s": {
            "a": 0,
            "k": [100, -100],
            "ix": 2
          },
          "r": {
            "a": 0,
            "k": 180,
            "ix": 2
          },
          "o": {
            "a": 0,
            "k": 100,
            "ix": 2
          },
          "sk": {
            "a": 0,
            "k": 0,
            "ix": 2
          },
          "sa": {
            "a": 0,
            "k": 0,
            "ix": 2
          },
          "_render": true
        }],
        "_render": true
      }, {
        "ty": "tr",
        "p": {
          "a": 0,
          "k": [-1.2999141216278076, 0.036949798464775085],
          "ix": 2
        },
        "a": {
          "a": 0,
          "k": [-9.5367431640625e-7, 0],
          "ix": 2
        },
        "s": {
          "a": 0,
          "k": [100.00000268335543, 100.00000268335545],
          "ix": 2
        },
        "r": {
          "a": 0,
          "k": -3.999999525469093,
          "ix": 2
        },
        "o": {
          "a": 0,
          "k": 100,
          "ix": 2
        },
        "sk": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "sa": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "_render": true
      }],
      "_render": true
    }],
    "ip": 0,
    "op": 141,
    "st": 0,
    "bm": 0,
    "completed": true
  }, {
    "ddd": 0,
    "ind": 8,
    "ty": 4,
    "nm": "Pointer",
    "sr": 1,
    "ks": {
      "p": {
        "a": 0,
        "k": [0, 0],
        "ix": 2
      },
      "a": {
        "a": 0,
        "k": [0, 0],
        "ix": 2
      },
      "s": {
        "a": 0,
        "k": [100, 100],
        "ix": 2
      },
      "r": {
        "a": 0,
        "k": 0,
        "ix": 2
      },
      "o": {
        "a": 0,
        "k": 100,
        "ix": 2
      },
      "sk": {
        "a": 0,
        "k": 0,
        "ix": 2
      },
      "sa": {
        "a": 0,
        "k": 0,
        "ix": 2
      }
    },
    "ao": 0,
    "parent": 6,
    "shapes": [{
      "ty": "gr",
      "nm": "Pointer",
      "it": [{
        "ty": "sh",
        "d": 1,
        "ks": {
          "a": 0,
          "k": {
            "c": true,
            "v": [[0, 0.003765621092503116], [2.823142290115356, 0], [1.463816607853733, 3.077310085296631], [0, 0.003765621092503116]],
            "i": [[0, 0.003765621092503116], [2.823142290115356, 0], [1.463816607853733, 3.077310085296631], [0, 0.003765621092503116]],
            "o": [[0, 0.003765621092503116], [2.823142290115356, 0], [1.463816607853733, 3.077310085296631], [0, 0.003765621092503116]]
          }
        },
        "_render": true
      }, {
        "ty": "fl",
        "c": {
          "a": 0,
          "k": [1, 0.2235294117647059, 0],
          "ix": 2
        },
        "o": {
          "a": 0,
          "k": 100,
          "ix": 2
        },
        "r": 1,
        "bm": 0,
        "_render": true
      }, {
        "ty": "tr",
        "p": {
          "a": 1,
          "k": [{
            "t": 20,
            "s": [-3.042144775390625, -24.878170013427734],
            "i": {
              "x": [0.75],
              "y": [0.75]
            },
            "o": {
              "x": [0.25],
              "y": [0.25]
            },
            "__fnct": [null, null]
          }, {
            "t": 40,
            "s": [-3.122174147516489, -25.249699592590332],
            "i": {
              "x": [0.75],
              "y": [0.75]
            },
            "o": {
              "x": [0.25],
              "y": [0.25]
            }
          }],
          "ix": 2
        },
        "a": {
          "a": 0,
          "k": [1.411571145057678, 1.538655042648315],
          "ix": 2
        },
        "s": {
          "a": 0,
          "k": [100.00000268335543, 100.00000268335545],
          "ix": 2
        },
        "r": {
          "a": 1,
          "k": [{
            "t": 0,
            "s": [-3.999999713091089],
            "i": {
              "x": [0.75],
              "y": [0.75]
            },
            "o": {
              "x": [0.25],
              "y": [0.25]
            },
            "__fnct": [null]
          }, {
            "t": 20,
            "s": [-3.999999713091089],
            "i": {
              "x": [0.75],
              "y": [0.75]
            },
            "o": {
              "x": [0.25],
              "y": [0.25]
            },
            "__fnct": [null]
          }, {
            "t": 40,
            "s": [-8.999999525469075],
            "i": {
              "x": [0.75],
              "y": [0.75]
            },
            "o": {
              "x": [0.25],
              "y": [0.25]
            }
          }],
          "ix": 2
        },
        "o": {
          "a": 0,
          "k": 100,
          "ix": 2
        },
        "sk": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "sa": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "_render": true
      }],
      "_render": true
    }],
    "ip": 0,
    "op": 141,
    "st": 0,
    "bm": 0,
    "completed": true
  }, {
    "ddd": 0,
    "ind": 9,
    "ty": 3,
    "nm": "whole lock",
    "sr": 1,
    "ks": {
      "p": {
        "a": 0,
        "k": [-1.2999215126037598, 0.036954134702682495],
        "ix": 2
      },
      "a": {
        "a": 0,
        "k": [0.3954734802246094, 0.814178466796875],
        "ix": 2
      },
      "s": {
        "a": 0,
        "k": [100.00000263138283, 100.00000263138283],
        "ix": 2
      },
      "r": {
        "a": 1,
        "k": [{
          "t": 0,
          "s": [-3.999999287244152],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          },
          "__fnct": [null]
        }, {
          "t": 20,
          "s": [176.0000004745309],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          },
          "__fnct": [null]
        }, {
          "t": 40,
          "s": [357],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          }
        }],
        "ix": 2
      },
      "o": {
        "a": 0,
        "k": 100,
        "ix": 2
      },
      "sk": {
        "a": 0,
        "k": 0,
        "ix": 2
      },
      "sa": {
        "a": 0,
        "k": 0,
        "ix": 2
      }
    },
    "ao": 0,
    "ip": 0,
    "op": 141,
    "st": 0,
    "bm": 0,
    "parent": 6,
    "completed": true
  }, {
    "ddd": 0,
    "ind": 10,
    "ty": 4,
    "nm": "Code",
    "sr": 1,
    "ks": {
      "p": {
        "a": 0,
        "k": [0, 0],
        "ix": 2
      },
      "a": {
        "a": 0,
        "k": [0, 0],
        "ix": 2
      },
      "s": {
        "a": 0,
        "k": [100, 100],
        "ix": 2
      },
      "r": {
        "a": 0,
        "k": 0,
        "ix": 2
      },
      "o": {
        "a": 0,
        "k": 100,
        "ix": 2
      },
      "sk": {
        "a": 0,
        "k": 0,
        "ix": 2
      },
      "sa": {
        "a": 0,
        "k": 0,
        "ix": 2
      }
    },
    "ao": 0,
    "parent": 9,
    "shapes": [{
      "ty": "gr",
      "it": [{
        "ty": "gr",
        "it": [{
          "ty": "gr",
          "it": [{
            "ty": "gr",
            "nm": "Filled region",
            "it": [{
              "ty": "gr",
              "nm": "Path",
              "it": [{
                "ty": "sh",
                "d": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "c": true,
                    "v": [[8.028193473815918, 6.246461391448975], [7.862060546875, 4.69136381149292], [7.846455097198486, 4.69199275970459], [7.815189361572266, 4.811079978942871], [7.732646465301514, 4.940651893615723], [7.599154949188232, 5.05905294418335], [7.138891220092773, 5.24353551864624], [6.678439140319824, 5.155101299285889], [6.288485527038574, 4.8173508644104], [6.077907562255859, 4.3064470291137695], [6.157443046569824, 3.804280996322632], [6.508584976196289, 3.388547420501709], [7.019496440887451, 3.17797589302063], [7.519125461578369, 3.254009246826172], [7.932322025299072, 3.6016430854797363], [8.12130069732666, 3.994389772415161], [8.216922760009766, 4.487086296081543], [8.396142959594727, 5.9791364669799805], [8.028193473815918, 6.246461391448975]],
                    "i": [[8.028193473815918, 6.246461391448975], [7.862060546875, 4.69136381149292], [7.846455097198486, 4.69199275970459], [7.836653403937817, 4.766931224614382], [7.7685473673045635, 4.896722313016653], [7.650551043450832, 5.0217122957110405], [7.298553958535194, 5.2274774089455605], [6.826383501291275, 5.226082004606724], [6.400510340929031, 4.97153727710247], [6.0977812968194485, 4.481182560324669], [6.0845455303788185, 3.964322865009308], [6.347387984395027, 3.5056613832712173], [6.844758167862892, 3.1978483237326145], [7.359080389142036, 3.181111976504326], [7.8152051866054535, 3.440448224544525], [8.07678747922182, 3.844694286584854], [8.195990545675159, 4.305981248617172], [8.396142959594727, 5.9791364669799805], [8.028193473815918, 6.246461391448975]],
                    "o": [[8.028193473815918, 6.246461391448975], [7.862060546875, 4.69136381149292], [7.847075273224618, 4.7272355034947395], [7.7960615288466215, 4.8535315208137035], [7.695048309862614, 4.982245296239853], [7.451975107192993, 5.165983065962791], [6.979867413640022, 5.255560245364904], [6.530494824051857, 5.0841206684708595], [6.167974039912224, 4.651483744382858], [6.058033933863044, 4.131711646914482], [6.2303406894207, 3.6442392617464066], [6.674454241991043, 3.268038921058178], [7.192537382245064, 3.155767334625125], [7.677472963929176, 3.3245703503489494], [8.013794615864754, 3.7137786597013474], [8.164116598665714, 4.141749143600464], [8.216922760009766, 4.487086296081543], [8.396142959594727, 5.9791364669799805], [8.028193473815918, 6.246461391448975]]
                  }
                },
                "_render": true
              }, {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [7.233832359313965, 4.708329200744629],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [7.233832212784639, 4.708329152215088],
                  "ix": 2
                },
                "s": {
                  "a": 0,
                  "k": [100, 100],
                  "ix": 2
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 2
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "_render": true
              }],
              "_render": true
            }, {
              "ty": "gr",
              "nm": "Path",
              "it": [{
                "ty": "sh",
                "d": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "c": true,
                    "v": [[7.505036354064941, 4.7526535987854], [7.76350736618042, 4.334646224975586], [7.622028827667236, 3.837787628173828], [7.349219799041748, 3.6023175716400146], [7.033016681671143, 3.5429322719573975], [6.715770721435547, 3.6663403511047363], [6.500365734100342, 3.929917573928833], [6.455627918243408, 4.251535892486572], [6.59877872467041, 4.581206321716309], [6.8680830001831055, 4.819222450256348], [7.19033670425415, 4.879565715789795], [7.505036354064941, 4.7526535987854]],
                    "i": [[7.505036354064941, 4.7526535987854], [7.743045633658767, 4.502993121743202], [7.7391456216573715, 3.9989824295043945], [7.453014478087425, 3.6518343836069107], [7.142360411584377, 3.531308245845139], [6.818562984466553, 3.591659002006054], [6.543513037264347, 3.8271834701299667], [6.4406083738431334, 4.1375215500593185], [6.5207008346915245, 4.4737430810928345], [6.766624554991722, 4.768008399754763], [7.079295597970486, 4.88885354436934], [7.404580257833004, 4.82563766092062]],
                    "o": [[7.656888544559479, 4.642328880727291], [7.786305136978626, 4.164602026343346], [7.543950937688351, 3.730324387550354], [7.247761279344559, 3.551103476434946], [6.92431178689003, 3.5505228880792856], [6.6153146252036095, 3.739324413239956], [6.455521106719971, 4.030315548181534], [6.472983689978719, 4.36385290324688], [6.676856569945812, 4.688669502735138], [6.971877671778202, 4.868739169090986], [7.299680434167385, 4.8679416896775365], [7.505036354064941, 4.7526535987854]]
                  }
                },
                "_render": true
              }, {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [7.109527587890625, 4.2107367515563965],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [7.109527437944722, 4.2107365317717225],
                  "ix": 2
                },
                "s": {
                  "a": 0,
                  "k": [100, 100],
                  "ix": 2
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 2
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "_render": true
              }],
              "_render": true
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [1, 1, 1],
                "ix": 2
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 2
              },
              "r": 1,
              "bm": 0,
              "_render": true
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [0, 0],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 2
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 2
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 2
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "_render": true
            }],
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [7.233832359313965, 4.708329200744629],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [7.233832212784639, 4.708329152215088],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "gr",
          "it": [{
            "ty": "gr",
            "nm": "Filled region",
            "it": [{
              "ty": "gr",
              "nm": "Path",
              "it": [{
                "ty": "sh",
                "d": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "c": true,
                    "v": [[3.148048162460327, 13.447731018066406], [2.8735177516937256, 13.914169311523438], [2.4534549713134766, 14.155698776245117], [1.9532523155212402, 14.125252723693848], [1.6313081979751587, 13.938668251037598], [1.4387072324752808, 13.648368835449219], [1.405832290649414, 13.28699779510498], [1.393473744392395, 13.282981872558594], [1.0368534326553345, 13.581561088562012], [0.5670338273048401, 13.583758354187012], [0.19122456014156342, 13.338682174682617], [0.011489860713481903, 12.938702583312988], [0.058420613408088684, 12.44385814666748], [0.311326265335083, 12.015938758850098], [0.6918442249298096, 11.797994613647461], [1.1399354934692383, 11.820618629455566], [1.5187333822250366, 12.098546028137207], [1.6317367553710938, 12.549714088439941], [1.6440951824188232, 12.553729057312012], [1.8817691802978516, 12.284818649291992], [2.209564208984375, 12.159049987792969], [2.5796961784362793, 12.197333335876465], [3.0009241104125977, 12.470829963684082], [3.200125217437744, 12.909014701843262], [3.148048162460327, 13.447731018066406]],
                    "i": [[3.148048162460327, 13.447731018066406], [2.994964435696602, 13.79270713031292], [2.6120501905679703, 14.116141021251678], [2.1262714862823486, 14.18146963045001], [1.7196063324809074, 14.022010706365108], [1.4788097962737083, 13.758559465408325], [1.385792352259159, 13.414082333445549], [1.393473744392395, 13.282981872558594], [1.188032865524292, 13.527448695152998], [0.7263213694095612, 13.635513618588448], [0.28522294759750366, 13.451203152537346], [0.03456810675561428, 13.091942071914673], [0.002201296389102936, 12.616876482963562], [0.1998341679573059, 12.125454023480415], [0.5469113737344742, 11.83288274332881], [0.9833944141864777, 11.769755735993385], [1.4254888817667961, 11.965016186237335], [1.6468995288014412, 12.381573423743248], [1.6440951824188232, 12.553729057312012], [1.7818086221814156, 12.349500387907028], [2.089140824973583, 12.174575229175389], [2.45336477458477, 12.156286086887121], [2.8931248039007187, 12.344715937972069], [3.1732697747647762, 12.739366605877876], [3.2105140686035156, 13.25548841059208]],
                    "o": [[3.0864746160805225, 13.637227326631546], [2.7520710676908493, 14.035631492733955], [2.293005794286728, 14.191617917269468], [1.8269209116697311, 14.084205474704504], [1.5430101454257965, 13.85532584041357], [1.3967507481575012, 13.53453952819109], [1.405832290649414, 13.28699779510498], [1.306906335055828, 13.427921995520592], [0.8829277753829956, 13.634781166911125], [0.41049274802207947, 13.53289546072483], [0.09447970986366272, 13.225268840789795], [-0.01344231516122818, 12.781824454665184], [0.11553231254220009, 12.268093436956406], [0.4200720340013504, 11.905531257390976], [0.8340305835008621, 11.762214187532663], [1.2992230355739594, 11.872373893857002], [1.6092316284775734, 12.231183663010597], [1.6317367553710938, 12.549714088439941], [1.7025838159024715, 12.439137168228626], [1.9798757955431938, 12.21649830788374], [2.3299876749515533, 12.143524774350226], [2.7527153491973877, 12.253550242632627], [3.1068695038557053, 12.593305215239525], [3.2278730161488056, 13.075916513800621], [3.148048162460327, 13.447731018066406]]
                  }
                },
                "_render": true
              }, {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [1.6064635515213013, 12.976266860961914],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [1.6064635910960534, 12.976267157506904],
                  "ix": 2
                },
                "s": {
                  "a": 0,
                  "k": [100, 100],
                  "ix": 2
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 2
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "_render": true
              }],
              "_render": true
            }, {
              "ty": "gr",
              "nm": "Path",
              "it": [{
                "ty": "sh",
                "d": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "c": true,
                    "v": [[2.81436824798584, 13.339313507080078], [2.801156520843506, 12.86136245727539], [2.4509875774383545, 12.565410614013672], [1.9937338829040527, 12.599017143249512], [1.697982907295227, 12.976580619812012], [1.715314269065857, 13.455869674682617], [2.065483570098877, 13.751821517944336], [2.5227370262145996, 13.718214988708496], [2.81436824798584, 13.339313507080078]],
                    "i": [[2.81436824798584, 13.339313507080078], [2.867076136171818, 13.004231631755829], [2.61576771736145, 12.61895051971078], [2.1310431212186813, 12.522180430591106], [1.7550946064293385, 12.800815910100937], [1.646648369729519, 13.312108129262924], [1.8979570865631104, 13.697389278560877], [2.382681429386139, 13.794159322977066], [2.7572565637528896, 13.51507817208767]],
                    "o": [[2.8714799471199512, 13.163548797369003], [2.7324905693531036, 12.717600852251053], [2.283461093902588, 12.510978374630213], [1.853678360581398, 12.67496145516634], [1.6408712230622768, 13.152345284819603], [1.7812338694930077, 13.598738893866539], [2.2302637100219727, 13.805361423641443], [2.660046249628067, 13.641378313302994], [2.81436824798584, 13.339313507080078]]
                  }
                },
                "_render": true
              }, {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [2.2566096782684326, 13.15829086303711],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [2.2566097748708063, 13.15829131606122],
                  "ix": 2
                },
                "s": {
                  "a": 0,
                  "k": [100, 100],
                  "ix": 2
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 2
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "_render": true
              }],
              "_render": true
            }, {
              "ty": "gr",
              "nm": "Path",
              "it": [{
                "ty": "sh",
                "d": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "c": true,
                    "v": [[1.3684226274490356, 12.869500160217285], [1.3529490232467651, 12.45457649230957], [1.0441826581954956, 12.199402809143066], [0.6443943381309509, 12.22435474395752], [0.3879809081554413, 12.55093765258789], [0.40345439314842224, 12.965862274169922], [0.7122208476066589, 13.22103500366211], [1.1120091676712036, 13.196084022521973], [1.3684226274490356, 12.869500160217285]],
                    "i": [[1.3684226274490356, 12.869500160217285], [1.4132374785840511, 12.57739844918251], [1.1897383630275726, 12.24669636413455], [0.765363983809948, 12.160426668822765], [0.437953632324934, 12.397143572568893], [0.3440582938492298, 12.840294033288956], [0.5666649639606476, 13.173741392791271], [0.9910394474864006, 13.260012030601501], [1.3193422593176365, 13.020547956228256]],
                    "o": [[1.4183953516185284, 12.715706080198288], [1.2926604822278023, 12.331754513084888], [0.8986267745494843, 12.152109198272228], [0.5234246924519539, 12.288282819092274], [0.33890054002404213, 12.701985448598862], [0.46374286338686943, 13.088684186339378], [0.857776552438736, 13.268328558653593], [1.2338711693882942, 13.129409655928612], [1.3684226274490356, 12.869500160217285]]
                  }
                },
                "_render": true
              }, {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [0.8785334229469299, 12.710219383239746],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [0.8785333985257092, 12.710219069505115],
                  "ix": 2
                },
                "s": {
                  "a": 0,
                  "k": [100, 100],
                  "ix": 2
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 2
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "_render": true
              }],
              "_render": true
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [1, 1, 1],
                "ix": 2
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 2
              },
              "r": 1,
              "bm": 0,
              "_render": true
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [0, 0],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 2
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 2
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 2
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "_render": true
            }],
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [1.6064635515213013, 12.976266860961914],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [1.6064635910960534, 12.976267157506904],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "gr",
          "nm": "Filled region",
          "it": [{
            "ty": "sh",
            "d": 1,
            "ks": {
              "a": 0,
              "k": {
                "c": true,
                "v": [[3.518833637237549, 22.259477615356445], [0.5013845562934875, 22.055774688720703], [0.8734949231147766, 23.200992584228516], [1.3595950603485107, 23.043046951293945], [1.480062484741211, 23.413801193237305], [0.6561636328697205, 23.681507110595703], [0.03508734330534935, 21.770061492919922], [0.3811247646808624, 21.657625198364258], [3.387657880783081, 21.85576629638672], [3.518833637237549, 22.259477615356445]],
                "i": [[3.518833637237549, 22.259477615356445], [0.5013845562934875, 22.055774688720703], [0.8734949231147766, 23.200992584228516], [1.3595950603485107, 23.043046951293945], [1.480062484741211, 23.413801193237305], [0.6561636328697205, 23.681507110595703], [0.03508734330534935, 21.770061492919922], [0.3811247646808624, 21.657625198364258], [3.387657880783081, 21.85576629638672], [3.518833637237549, 22.259477615356445]],
                "o": [[3.518833637237549, 22.259477615356445], [0.5013845562934875, 22.055774688720703], [0.8734949231147766, 23.200992584228516], [1.3595950603485107, 23.043046951293945], [1.480062484741211, 23.413801193237305], [0.6561636328697205, 23.681507110595703], [0.03508734330534935, 21.770061492919922], [0.3811247646808624, 21.657625198364258], [3.387657880783081, 21.85576629638672], [3.518833637237549, 22.259477615356445]]
              }
            },
            "_render": true
          }, {
            "ty": "fl",
            "c": {
              "a": 0,
              "k": [1, 1, 1],
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "r": 1,
            "bm": 0,
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [1.7769604921340942, 22.669567108154297],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [1.776960490271449, 22.66956615447998],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "gr",
          "it": [{
            "ty": "gr",
            "nm": "Filled region",
            "it": [{
              "ty": "gr",
              "nm": "Path",
              "it": [{
                "ty": "sh",
                "d": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "c": true,
                    "v": [[8.584076881408691, 29.142776489257812], [8.94477367401123, 29.560096740722656], [9.026854515075684, 30.058759689331055], [8.821369171142578, 30.562654495239258], [8.508782386779785, 30.86024284362793], [8.067194938659668, 31.1069393157959], [6.703527450561523, 31.73845672607422], [6.353099346160889, 31.483861923217773], [7.780773639678955, 30.845306396484375], [7.775352954864502, 30.83066177368164], [7.572489261627197, 30.822479248046875], [7.349831581115723, 30.70889663696289], [7.027681827545166, 30.319581985473633], [6.959946155548096, 29.852758407592773], [7.157164096832275, 29.374980926513672], [7.577999114990234, 29.016834259033203], [8.08017349243164, 28.93729591369629], [8.584076881408691, 29.142776489257812]],
                    "i": [[8.584076881408691, 29.142776489257812], [8.867842547595501, 29.400693774223328], [9.045030841603875, 29.88636040687561], [8.938485987484455, 30.401459649205208], [8.63570100069046, 30.773986473679543], [8.232970789074898, 31.031067073345184], [6.703527450561523, 31.73845672607422], [6.353099346160889, 31.483861923217773], [7.780773639678955, 30.845306396484375], [7.775352954864502, 30.83066177368164], [7.64850626885891, 30.845583723858], [7.422253370285034, 30.761513020843267], [7.090595863759518, 30.468801096081734], [6.938155934214592, 30.015393391251564], [7.04513930529356, 29.52916730940342], [7.416256904602051, 29.092067703604698], [7.905435174703598, 28.91742355003953], [8.420543760061264, 29.023965261876583]],
                    "o": [[8.747610077261925, 29.261587768793106], [9.0176712423563, 29.720138534903526], [9.006980825215578, 30.233495146036148], [8.739896550774574, 30.674790106713772], [8.38016639649868, 30.948835402727127], [8.067194938659668, 31.1069393157959], [6.703527450561523, 31.73845672607422], [6.353099346160889, 31.483861923217773], [7.780773639678955, 30.845306396484375], [7.716127637773752, 30.84831145964563], [7.496472284197807, 30.799374792724848], [7.197979390621185, 30.59857191890478], [6.9607342928647995, 30.171001613140106], [6.97940019890666, 29.68842601776123], [7.275978289544582, 29.21144989132881], [7.738044127821922, 28.943937063217163], [8.25257559120655, 28.95547094196081], [8.584076881408691, 29.142776489257812]]
                  }
                },
                "_render": true
              }, {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [7.692697525024414, 30.334684371948242],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [7.6926976768271995, 30.33468370880862],
                  "ix": 2
                },
                "s": {
                  "a": 0,
                  "k": [100, 100],
                  "ix": 2
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 2
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "_render": true
              }],
              "_render": true
            }, {
              "ty": "gr",
              "nm": "Path",
              "it": [{
                "ty": "sh",
                "d": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "c": true,
                    "v": [[8.383899688720703, 29.425661087036133], [8.069199562072754, 29.298748016357422], [7.750450611114502, 29.36163902282715], [7.477641582489014, 29.59710693359375], [7.337995529174805, 29.929325103759766], [7.3792290687561035, 30.248395919799805], [7.594634056091309, 30.511974334716797], [7.911879539489746, 30.6353816986084], [8.231587409973145, 30.578542709350586], [8.50089168548584, 30.340526580810547], [8.644042015075684, 30.01085662841797], [8.601850509643555, 29.685733795166016], [8.383899688720703, 29.425661087036133]],
                    "i": [[8.383899688720703, 29.425661087036133], [8.176207147538662, 29.3086747424677], [7.851909101009369, 29.310424976050854], [7.555719472467899, 29.489643692970276], [7.353015061467886, 29.81531085073948], [7.334384441375732, 30.147997945547104], [7.491841793060303, 30.437292985618114], [7.800838433206081, 30.626093870028853], [8.127792738378048, 30.628059428185225], [8.422813765704632, 30.447989858686924], [8.626686291769147, 30.12317357212305], [8.644997775554657, 29.788467951118946], [8.48435578495264, 29.498645149171352]],
                    "o": [[8.281107425689697, 29.35097973793745], [7.95815847069025, 29.289460169151425], [7.646655976772308, 29.41115576773882], [7.399563662707806, 29.704570211470127], [7.320639839395881, 30.04164207726717], [7.420040164142847, 30.349432811141014], [7.695090152323246, 30.584958396852016], [8.02122326940298, 30.647005724720657], [8.333045855164528, 30.527328658849], [8.578969575464725, 30.233063340187073], [8.6590615240857, 29.8968423306942], [8.557005897164345, 29.585335798561573], [8.383899688720703, 29.425661087036133]]
                  }
                },
                "_render": true
              }, {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [7.99029541015625, 29.967653274536133],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [7.990295432587681, 29.967653020169138],
                  "ix": 2
                },
                "s": {
                  "a": 0,
                  "k": [100, 100],
                  "ix": 2
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 2
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "_render": true
              }],
              "_render": true
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [1, 1, 1],
                "ix": 2
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 2
              },
              "r": 1,
              "bm": 0,
              "_render": true
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [0, 0],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 2
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 2
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 2
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "_render": true
            }],
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [7.692697525024414, 30.334684371948242],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [7.6926976768271995, 30.33468370880862],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "gr",
          "it": [{
            "ty": "gr",
            "nm": "Filled region",
            "it": [{
              "ty": "gr",
              "nm": "Path",
              "it": [{
                "ty": "sh",
                "d": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "c": true,
                    "v": [[17.3137264251709, 3.2486236095428467], [16.80693817138672, 3.136004686355591], [16.477739334106445, 2.8111422061920166], [16.36077880859375, 2.3173515796661377], [16.360754013061523, 0.931272029876709], [16.477697372436523, 0.437481164932251], [16.806884765625, 0.11695027351379395], [17.31366729736328, 0], [17.82045555114746, 0.11695027351379395], [18.149654388427734, 0.437481164932251], [18.26661491394043, 0.931272029876709], [18.266639709472656, 2.3173515796661377], [18.14969825744629, 2.8111422061920166], [17.816177368164062, 3.136004686355591], [17.3137264251709, 3.2486236095428467]],
                    "i": [[17.3137264251709, 3.2486236095428467], [16.95132277905941, 3.2110839933156967], [16.555708773434162, 2.949750155210495], [16.360782174414453, 2.5050498694181442], [16.360754013061523, 0.931272029876709], [16.399732887744904, 0.5760892182588577], [16.665390476584435, 0.19202964007854462], [17.12019370496273, 2.0372983685509466e-17], [17.67895856499672, 0.03898344933986664], [18.071684904396534, 0.29887329041957855], [18.266611496339237, 0.7406861484050751], [18.266639709472656, 2.3173515796661377], [18.227662712335587, 2.6696466207504272], [17.960559278726578, 3.058037720620632], [17.50720001757145, 3.2486236095428467]],
                    "o": [[17.120252832770348, 3.2486236095428467], [16.665441140532494, 3.058037720620632], [16.399769820272923, 2.6696466207504272], [16.36077880859375, 2.3173515796661377], [16.36075059546033, 0.7406861484050751], [16.5556618347764, 0.29887329041957855], [16.95126663148403, 0.03898344933986664], [17.51002860069275, -2.067706189612886e-17], [17.961952477693558, 0.19202964007854462], [18.227623872458935, 0.5760892182588577], [18.26661491394043, 0.931272029876709], [18.26664307529336, 2.5050498694181442], [18.071733750402927, 2.949750155210495], [17.67468312382698, 3.2110839933156967], [17.3137264251709, 3.2486236095428467]]
                  }
                },
                "_render": true
              }, {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [17.313695907592773, 1.6243118047714233],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [17.313696861263722, 1.6243118047714233],
                  "ix": 2
                },
                "s": {
                  "a": 0,
                  "k": [100, 100],
                  "ix": 2
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 2
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "_render": true
              }],
              "_render": true
            }, {
              "ty": "gr",
              "nm": "Path",
              "it": [{
                "ty": "sh",
                "d": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "c": true,
                    "v": [[17.313720703125, 2.9150984287261963], [17.729541778564453, 2.7505013942718506], [17.889799118041992, 2.3173515796661377], [17.889774322509766, 0.931272029876709], [17.72949981689453, 0.5024538040161133], [17.31367301940918, 0.3335251808166504], [16.893522262573242, 0.5024538040161133], [16.737594604492188, 0.931272029876709], [16.737619400024414, 2.3173515796661377], [16.89356231689453, 2.7505013942718506], [17.313720703125, 2.9150984287261963]],
                    "i": [[17.313720703125, 2.9150984287261963], [17.62558775395155, 2.860232688486576], [17.889802276735054, 2.4934991896152496], [17.889774322509766, 0.931272029876709], [17.83634540438652, 0.6121850535273552], [17.486932948231697, 0.3335251808166504], [17.000363864004612, 0.3898347541689873], [16.737591445800035, 0.7551244646310806], [16.737619400024414, 2.3173515796661377], [16.78960434347391, 2.637882426381111], [17.140460774302483, 2.9150984287261963]],
                    "o": [[17.486980631947517, 2.9150984287261963], [17.836383379995823, 2.637882426381111], [17.889799118041992, 2.3173515796661377], [17.889771163817613, 0.7551244646310806], [17.62554180622101, 0.3898347541689873], [17.140413090586662, 0.3335251808166504], [16.78956827521324, 0.6121850535273552], [16.737594604492188, 0.931272029876709], [16.737622558717476, 2.4934991896152496], [17.00040790438652, 2.860232688486576], [17.313720703125, 2.9150984287261963]]
                  }
                },
                "_render": true
              }, {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [17.313695907592773, 1.6243118047714233],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [17.313696861265147, 1.6243118047714233],
                  "ix": 2
                },
                "s": {
                  "a": 0,
                  "k": [100, 100],
                  "ix": 2
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 2
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "_render": true
              }],
              "_render": true
            }, {
              "ty": "gr",
              "nm": "Path",
              "it": [{
                "ty": "sh",
                "d": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "c": true,
                    "v": [[17.313701629638672, 1.862544298171997], [17.12311363220215, 1.7975716590881348], [17.05380630493164, 1.6113171577453613], [17.12310791015625, 1.4337258338928223], [17.313692092895508, 1.368753433227539], [17.499948501586914, 1.4337258338928223], [17.57358741760254, 1.6113171577453613], [17.499954223632812, 1.7975716590881348], [17.313701629638672, 1.862544298171997]],
                    "i": [[17.313701629638672, 1.862544298171997], [17.172204691916704, 1.8408866859972477], [17.053807754824675, 1.6921718642115593], [17.076905980706215, 1.474153146147728], [17.235725097358227, 1.368753433227539], [17.4537450671196, 1.3904108069837093], [17.573586019493746, 1.5333502516150475], [17.549043726176023, 1.7542567178606987], [17.391668625175953, 1.862544298171997]],
                    "o": [[17.23573463410139, 1.862544298171997], [17.076910197734833, 1.7542567178606987], [17.053804906822847, 1.5333502516150475], [17.17219741269946, 1.3904108069837093], [17.39165908843279, 1.368753433227539], [17.549039509147406, 1.474153146147728], [17.573588867495573, 1.6921718642115593], [17.45375234633684, 1.8408866859972477], [17.313701629638672, 1.862544298171997]]
                  }
                },
                "_render": true
              }, {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [17.313697814941406, 1.615648865699768],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [17.313696861267477, 1.615648865699768],
                  "ix": 2
                },
                "s": {
                  "a": 0,
                  "k": [100, 100],
                  "ix": 2
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 2
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "_render": true
              }],
              "_render": true
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [1, 1, 1],
                "ix": 2
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 2
              },
              "r": 1,
              "bm": 0,
              "_render": true
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [0, 0],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 2
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 2
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 2
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "_render": true
            }],
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [17.313695907592773, 1.6243118047714233],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [17.313696861263722, 1.6243118047714233],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "gr",
          "nm": "Filled region",
          "it": [{
            "ty": "sh",
            "d": 1,
            "ks": {
              "a": 0,
              "k": {
                "c": true,
                "v": [[17.55527114868164, 31.836397171020508], [18.248315811157227, 32.07896041870117], [18.50388526916504, 32.74601364135742], [18.114049911499023, 32.74601364135742], [17.962440490722656, 32.33451843261719], [17.550945281982422, 32.182918548583984], [17.139455795288086, 32.33451843261719], [16.98786163330078, 32.74601364135742], [16.987865447998047, 32.9409294128418], [17.135143280029297, 33.352420806884766], [17.53364372253418, 33.504024505615234], [18.395610809326172, 33.504024505615234], [18.395639419555664, 35.04170608520508], [16.71068572998047, 35.04170608520508], [16.71068000793457, 34.6865234375], [18.031787872314453, 34.6865234375], [18.023109436035156, 33.85920715332031], [17.511991500854492, 33.85920715332031], [16.836275100708008, 33.616641998291016], [16.59803009033203, 32.9409294128418], [16.598026275634766, 32.74601364135742], [16.8579044342041, 32.07896041870117], [17.55527114868164, 31.836397171020508]],
                "i": [[17.55527114868164, 31.836397171020508], [18.07794064283371, 31.917251139879227], [18.50388024632639, 32.465910106897354], [18.114049911499023, 32.74601364135742], [18.063510581851006, 32.43558671325445], [17.72420521080494, 32.182918548583984], [17.240522265434265, 32.23345012962818], [16.987858526390028, 32.572753712534904], [16.987865447998047, 32.9409294128418], [17.036960907280445, 33.2513525262475], [17.36615912616253, 33.504024505615234], [18.395610809326172, 33.504024505615234], [18.395639419555664, 35.04170608520508], [16.71068572998047, 35.04170608520508], [16.71068000793457, 34.6865234375], [18.031787872314453, 34.6865234375], [18.023109436035156, 33.85920715332031], [17.511991500854492, 33.85920715332031], [16.995099544525146, 33.77835124731064], [16.598035320299005, 33.23258364200592], [16.598026275634766, 32.74601364135742], [16.684647366404533, 32.24355736374855], [17.26072919368744, 31.836397171020508]],
                "o": [[17.84692534804344, 31.836397171020508], [18.418691024184227, 32.24355736374855], [18.50388526916504, 32.74601364135742], [18.11404680458827, 32.572753712534904], [17.861370354890823, 32.23345012962818], [17.377685353159904, 32.182918548583984], [17.038389325141907, 32.43558671325445], [16.98786163330078, 32.74601364135742], [16.9878685549088, 33.114189341664314], [17.233325742185116, 33.453489169478416], [17.53364372253418, 33.504024505615234], [18.395610809326172, 33.504024505615234], [18.395639419555664, 35.04170608520508], [16.71068572998047, 35.04170608520508], [16.71068000793457, 34.6865234375], [18.031787872314453, 34.6865234375], [18.023109436035156, 33.85920715332031], [17.22033727169037, 33.85920715332031], [16.67745055258274, 33.457820385694504], [16.59803009033203, 32.9409294128418], [16.598021252796116, 32.465910106897354], [17.02827374637127, 31.917251139879227], [17.55527114868164, 31.836397171020508]]
              }
            },
            "_render": true
          }, {
            "ty": "fl",
            "c": {
              "a": 0,
              "k": [1, 1, 1],
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "r": 1,
            "bm": 0,
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [17.550954818725586, 33.43905258178711],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [17.550955772290692, 33.43905162811279],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "gr",
          "nm": "Filled region",
          "it": [{
            "ty": "sh",
            "d": 1,
            "ks": {
              "a": 0,
              "k": {
                "c": true,
                "v": [[26.128232955932617, 29.189237594604492], [26.53559684753418, 29.749916076660156], [27.69200897216797, 28.909751892089844], [28.050996780395508, 29.40384864807129], [28.21109962463379, 31.584388732910156], [27.85366439819336, 31.84407615661621], [27.6846923828125, 29.56290054321289], [27.585397720336914, 29.42623519897461], [26.744369506835938, 30.037263870239258], [27.197561264038086, 30.66101837158203], [26.88217544555664, 30.890153884887695], [25.812847137451172, 29.41837501525879], [26.128232955932617, 29.189237594604492]],
                "i": [[26.128232955932617, 29.189237594604492], [26.53559684753418, 29.749916076660156], [27.69200897216797, 28.909751892089844], [28.050996780395508, 29.40384864807129], [28.21109962463379, 31.584388732910156], [27.85366439819336, 31.84407615661621], [27.6846923828125, 29.56290054321289], [27.585397720336914, 29.42623519897461], [26.744369506835938, 30.037263870239258], [27.197561264038086, 30.66101837158203], [26.88217544555664, 30.890153884887695], [25.812847137451172, 29.41837501525879], [26.128232955932617, 29.189237594604492]],
                "o": [[26.128232955932617, 29.189237594604492], [26.53559684753418, 29.749916076660156], [27.69200897216797, 28.909751892089844], [28.050996780395508, 29.40384864807129], [28.21109962463379, 31.584388732910156], [27.85366439819336, 31.84407615661621], [27.6846923828125, 29.56290054321289], [27.585397720336914, 29.42623519897461], [26.744369506835938, 30.037263870239258], [27.197561264038086, 30.66101837158203], [26.88217544555664, 30.890153884887695], [25.812847137451172, 29.41837501525879], [26.128232955932617, 29.189237594604492]]
              }
            },
            "_render": true
          }, {
            "ty": "fl",
            "c": {
              "a": 0,
              "k": [1, 1, 1],
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "r": 1,
            "bm": 0,
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [27.011974334716797, 30.376914978027344],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [27.01197338104248, 30.376914024353027],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "gr",
          "nm": "Filled region",
          "it": [{
            "ty": "sh",
            "d": 1,
            "ks": {
              "a": 0,
              "k": {
                "c": true,
                "v": [[31.21969223022461, 21.70640754699707], [31.664554595947266, 21.12224578857422], [32.377933502197266, 21.085325241088867], [32.25746154785156, 21.456079483032227], [31.819259643554688, 21.47310447692871], [31.547914505004883, 21.817607879638672], [31.56493377685547, 22.25580596923828], [31.90943717956543, 22.527145385742188], [32.115413665771484, 22.594070434570312], [32.55361557006836, 22.577045440673828], [32.8249626159668, 22.232542037963867], [32.93070602416992, 21.907102584838867], [33.25202941894531, 22.011505126953125], [33.79513168334961, 23.00320816040039], [34.19669723510742, 21.767362594604492], [34.53449630737305, 21.877119064331055], [33.99639892578125, 23.533151626586914], [33.650360107421875, 23.420717239379883], [33.040618896484375, 22.311721801757812], [33.1518440246582, 22.34786033630371], [32.704200744628906, 22.926565170288086], [31.994943618774414, 22.964824676513672], [31.78896713256836, 22.897899627685547], [31.23487663269043, 22.44460105895996], [31.21969223022461, 21.70640754699707]],
                "i": [[31.21969223022461, 21.70640754699707], [31.458109959959984, 21.234308272600174], [32.11153897643089, 20.99876906722784], [32.25746154785156, 21.456079483032227], [31.9466143399477, 21.408214777708054], [31.601456731557846, 21.652828440070152], [31.500044971704483, 22.12845304608345], [31.744657039642334, 22.47360548004508], [32.115413665771484, 22.594070434570312], [32.42626079916954, 22.641935110092163], [32.771420400589705, 22.397321432828903], [32.93070602416992, 21.907102584838867], [33.25202941894531, 22.011505126953125], [33.79513168334961, 23.00320816040039], [34.19669723510742, 21.767362594604492], [34.53449630737305, 21.877119064331055], [33.99639892578125, 23.533151626586914], [33.650360107421875, 23.420717239379883], [33.040618896484375, 22.311721801757812], [33.1518440246582, 22.34786033630371], [32.91249932348728, 22.818141236901283], [32.26133817434311, 23.05138085782528], [31.78896713256836, 22.897899627685547], [31.33787553012371, 22.660243451595306], [31.128670446574688, 21.986532598733902]],
                "o": [[31.309821613132954, 21.429028928279877], [31.87374557554722, 21.011075608432293], [32.377933502197266, 21.085325241088867], [32.09268140792847, 21.40253957733512], [31.691904932260513, 21.537994168698788], [31.49437228962779, 21.982387274503708], [31.629822559654713, 22.38315887749195], [31.90943717956543, 22.527145385742188], [32.28019380569458, 22.64761034026742], [32.68097026646137, 22.51215574145317], [32.8249626159668, 22.232542037963867], [32.93070602416992, 21.907102584838867], [33.25202941894531, 22.011505126953125], [33.79513168334961, 23.00320816040039], [34.19669723510742, 21.767362594604492], [34.53449630737305, 21.877119064331055], [33.99639892578125, 23.533151626586914], [33.650360107421875, 23.420717239379883], [33.040618896484375, 22.311721801757812], [33.06171464920044, 22.625238925218582], [32.49775603413582, 23.038627676665783], [31.994943618774414, 22.964824676513672], [31.522572606801987, 22.81134345382452], [31.13373166322708, 22.232597440481186], [31.21969223022461, 21.70640754699707]]
              }
            },
            "_render": true
          }, {
            "ty": "fl",
            "c": {
              "a": 0,
              "k": [1, 1, 1],
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "r": 1,
            "bm": 0,
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [32.84476089477539, 22.280820846557617],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [32.844759120432386, 22.280820385844557],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "gr",
          "nm": "Filled region",
          "it": [{
            "ty": "sh",
            "d": 1,
            "ks": {
              "a": 0,
              "k": {
                "c": true,
                "v": [[30.906309127807617, 12.298346519470215], [31.248228073120117, 12.187248229980469], [32.64455795288086, 12.840269088745117], [33.156898498535156, 13.01537799835205], [33.54062271118164, 12.990893363952637], [33.88512420654297, 12.719551086425781], [33.90894317626953, 12.288251876831055], [33.626686096191406, 11.938185691833496], [33.17612838745117, 11.925179481506348], [33.055660247802734, 11.554425239562988], [33.56543731689453, 11.52541732788086], [33.97746658325195, 11.742229461669922], [34.238502502441406, 12.181169509887695], [34.28800582885742, 12.697952270507812], [34.08488845825195, 13.110084533691406], [33.659645080566406, 13.371225357055664], [33.167686462402344, 13.398998260498047], [32.50231170654297, 13.173416137695312], [31.3900089263916, 12.637611389160156], [31.83439826965332, 14.00528335571289], [31.496599197387695, 14.115042686462402], [30.906309127807617, 12.298346519470215]],
                "i": [[30.906309127807617, 12.298346519470215], [31.248228073120117, 12.187248229980469], [32.64455795288086, 12.840269088745117], [33.0164283066988, 12.994222227483988], [33.425276808440685, 13.028372123837471], [33.820235051214695, 12.8469048589468], [33.96159189194441, 12.450285345315933], [33.76042492687702, 12.004036597907543], [33.34640075266361, 11.869853746145964], [33.055660247802734, 11.554425239562988], [33.408627569675446, 11.49135297164321], [33.86233675479889, 11.630860440433025], [34.17960734292865, 11.999911770224571], [34.3156850989908, 12.540181040763855], [34.19261872023344, 12.993100792169571], [33.83815664052963, 13.313222497701645], [33.35285171866417, 13.426885416731238], [32.76161962747574, 13.29866361618042], [31.3900089263916, 12.637611389160156], [31.83439826965332, 14.00528335571289], [31.496599197387695, 14.115042686462402], [30.906309127807617, 12.298346519470215]],
                "o": [[30.906309127807617, 12.298346519470215], [31.248228073120117, 12.187248229980469], [32.84564697742462, 12.935852907598019], [33.297368720173836, 13.036533845588565], [33.70540247857571, 12.937352307140827], [33.953652158379555, 12.594051212072372], [33.85450978204608, 12.120725810527802], [33.49658592045307, 11.87418881803751], [33.17612838745117, 11.925179481506348], [33.2387026399374, 11.50102274492383], [33.72499318420887, 11.55858937650919], [34.09259624034166, 11.85359850525856], [34.29918238148093, 12.367919966578484], [34.26032639667392, 12.855723544955254], [33.97990445792675, 13.226175859570503], [33.5168359875679, 13.417627591639757], [32.98341354727745, 13.373857397586107], [32.50231170654297, 13.173416137695312], [31.3900089263916, 12.637611389160156], [31.83439826965332, 14.00528335571289], [31.496599197387695, 14.115042686462402], [30.906309127807617, 12.298346519470215]]
              }
            },
            "_render": true
          }, {
            "ty": "fl",
            "c": {
              "a": 0,
              "k": [1, 1, 1],
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "r": 1,
            "bm": 0,
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [32.603660583496094, 12.810279846191406],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [32.603660275974406, 12.810280238859221],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "gr",
          "nm": "Filled region",
          "it": [{
            "ty": "sh",
            "d": 1,
            "ks": {
              "a": 0,
              "k": {
                "c": true,
                "v": [[25.21958351135254, 5.328159809112549], [25.428356170654297, 5.0408124923706055], [26.122203826904297, 5.5449113845825195], [27.573434829711914, 3.547496795654297], [26.502775192260742, 3.5620245933532715], [26.765016555786133, 3.2010881900787354], [27.656381607055664, 3.1901497840881348], [28.0874080657959, 3.5033023357391357], [26.437589645385742, 5.774047374725342], [27.00528335571289, 6.186491966247559], [26.7965087890625, 6.473839282989502], [25.21958351135254, 5.328159809112549]],
                "i": [[25.21958351135254, 5.328159809112549], [25.428356170654297, 5.0408124923706055], [26.122203826904297, 5.5449113845825195], [27.573434829711914, 3.547496795654297], [26.502775192260742, 3.5620245933532715], [26.765016555786133, 3.2010881900787354], [27.656381607055664, 3.1901497840881348], [28.0874080657959, 3.5033023357391357], [26.437589645385742, 5.774047374725342], [27.00528335571289, 6.186491966247559], [26.7965087890625, 6.473839282989502], [25.21958351135254, 5.328159809112549]],
                "o": [[25.21958351135254, 5.328159809112549], [25.428356170654297, 5.0408124923706055], [26.122203826904297, 5.5449113845825195], [27.573434829711914, 3.547496795654297], [26.502775192260742, 3.5620245933532715], [26.765016555786133, 3.2010881900787354], [27.656381607055664, 3.1901497840881348], [28.0874080657959, 3.5033023357391357], [26.437589645385742, 5.774047374725342], [27.00528335571289, 6.186491966247559], [26.7965087890625, 6.473839282989502], [25.21958351135254, 5.328159809112549]]
              }
            },
            "_render": true
          }, {
            "ty": "fl",
            "c": {
              "a": 0,
              "k": [1, 1, 1],
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "r": 1,
            "bm": 0,
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [26.65349578857422, 4.831994533538818],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [26.65349578857422, 4.831994533538818],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "tr",
          "p": {
            "a": 0,
            "k": [60.562744140625, 83.6688003540039],
            "ix": 2
          },
          "a": {
            "a": 0,
            "k": [17.267248153686523, 17.52085304260254],
            "ix": 2
          },
          "s": {
            "a": 0,
            "k": [109.14504528045654, 109.14504528045654],
            "ix": 2
          },
          "r": {
            "a": 0,
            "k": -2.172794366275684e-7,
            "ix": 2
          },
          "o": {
            "a": 0,
            "k": 100,
            "ix": 2
          },
          "sk": {
            "a": 0,
            "k": 0,
            "ix": 2
          },
          "sa": {
            "a": 0,
            "k": 0,
            "ix": 2
          },
          "_render": true
        }],
        "_render": true
      }, {
        "ty": "gr",
        "it": [{
          "ty": "gr",
          "nm": "Vector",
          "it": [{
            "ty": "sh",
            "d": 1,
            "ks": {
              "a": 0,
              "k": {
                "c": true,
                "v": [[0.647433311739829, 0], [1.2956955432891846, 0.647433340549469], [0.647433311739829, 1.294866681098938], [0, 0.647433340549469], [0.647433311739829, 0]],
                "i": [[0.647433311739829, 0], [1.2956955432891846, 0.290142995353382], [1.0055526349632316, 1.294866681098938], [0, 1.0055526797085497], [0.2893139885164264, 0]],
                "o": [[1.0055526349632316, 0], [1.2956955432891846, 1.0055526797085497], [0.2893139885164264, 1.294866681098938], [0, 0.290142995353382], [0.647433311739829, 0]]
              }
            },
            "_render": true
          }, {
            "ty": "fl",
            "c": {
              "a": 0,
              "k": [1, 1, 1],
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "r": 1,
            "bm": 0,
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [197.82676696777344, 178.24118041992188],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [0.6478477716445923, 0.647433340549469],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, -100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 180,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": -180,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "gr",
          "nm": "Vector",
          "it": [{
            "ty": "sh",
            "d": 1,
            "ks": {
              "a": 0,
              "k": {
                "c": true,
                "v": [[0.6482623219490051, 0], [1.2965246438980103, 0.647433340549469], [0.6482623219490051, 1.294866681098938], [0, 0.647433340549469], [0.6482623219490051, 0]],
                "i": [[0.6482623219490051, 0], [1.2965246438980103, 0.290142995353382], [1.0063816678157254, 1.294866681098938], [0, 1.0055526797085497], [0.2901429760822849, 0]],
                "o": [[1.0063816678157254, 0], [1.2965246438980103, 1.0055526797085497], [0.2901429760822849, 1.294866681098938], [0, 0.290142995353382], [0.6482623219490051, 0]]
              }
            },
            "_render": true
          }, {
            "ty": "fl",
            "c": {
              "a": 0,
              "k": [1, 1, 1],
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "r": 1,
            "bm": 0,
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [186.1193084716797, 182.03805541992188],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [0.6482623219490051, 0.647433340549469],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, -100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 180,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": -180,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "gr",
          "nm": "Vector",
          "it": [{
            "ty": "sh",
            "d": 1,
            "ks": {
              "a": 0,
              "k": {
                "c": true,
                "v": [[0.6482623219490051, 0], [1.2965246438980103, 0.6474332623287768], [0.6482623219490051, 1.2956955432891846], [0, 0.6474332623287768], [0.6482623219490051, 0]],
                "i": [[0.6482623219490051, 0], [1.2965246438980103, 0.2901429330314791], [1.0063816678157254, 1.2956955432891846], [0, 1.0055525855521794], [0.2901429760822849, 0]],
                "o": [[1.0063816678157254, 0], [1.2965246438980103, 1.0055525855521794], [0.2901429760822849, 1.2956955432891846], [0, 0.2901429330314791], [0.6482623219490051, 0]]
              }
            },
            "_render": true
          }, {
            "ty": "fl",
            "c": {
              "a": 0,
              "k": [1, 1, 1],
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "r": 1,
            "bm": 0,
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [178.8829803466797, 192.00172424316406],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [0.6482623219490051, 0.6478477716445923],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, -100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 180,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": -180,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "gr",
          "nm": "Vector",
          "it": [{
            "ty": "sh",
            "d": 1,
            "ks": {
              "a": 0,
              "k": {
                "c": true,
                "v": [[0.6482623219490051, 0], [1.2965246438980103, 0.647433340549469], [0.6482623219490051, 1.294866681098938], [0, 0.647433340549469], [0.6482623219490051, 0]],
                "i": [[0.6482623219490051, 0], [1.2965246438980103, 0.290142995353382], [1.0063816678157254, 1.294866681098938], [0, 1.0055526797085497], [0.2901429760822849, 0]],
                "o": [[1.0063816678157254, 0], [1.2965246438980103, 1.0055526797085497], [0.2901429760822849, 1.294866681098938], [0, 0.290142995353382], [0.6482623219490051, 0]]
              }
            },
            "_render": true
          }, {
            "ty": "fl",
            "c": {
              "a": 0,
              "k": [1, 1, 1],
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "r": 1,
            "bm": 0,
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [178.8829803466797, 204.31259155273438],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [0.6482623219490051, 0.647433340549469],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, -100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 180,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": -180,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "gr",
          "nm": "Vector",
          "it": [{
            "ty": "sh",
            "d": 1,
            "ks": {
              "a": 0,
              "k": {
                "c": true,
                "v": [[0.6482623219490051, 0], [1.2965246438980103, 0.6474332623287768], [0.6482623219490051, 1.2956955432891846], [0, 0.6474332623287768], [0.6482623219490051, 0]],
                "i": [[0.6482623219490051, 0], [1.2965246438980103, 0.2901429330314791], [1.0063816678157254, 1.2956955432891846], [0, 1.0055525855521794], [0.2901429760822849, 0]],
                "o": [[1.0063816678157254, 0], [1.2965246438980103, 1.0055525855521794], [0.2901429760822849, 1.2956955432891846], [0, 0.2901429330314791], [0.6482623219490051, 0]]
              }
            },
            "_render": true
          }, {
            "ty": "fl",
            "c": {
              "a": 0,
              "k": [1, 1, 1],
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "r": 1,
            "bm": 0,
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [186.1193084716797, 214.26832580566406],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [0.6482623219490051, 0.6478477716445923],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, -100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 180,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": -180,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "gr",
          "nm": "Vector",
          "it": [{
            "ty": "sh",
            "d": 1,
            "ks": {
              "a": 0,
              "k": {
                "c": true,
                "v": [[0.647433311739829, 0], [1.2956955432891846, 0.6474332623287768], [0.647433311739829, 1.2956955432891846], [0, 0.6474332623287768], [0.647433311739829, 0]],
                "i": [[0.647433311739829, 0], [1.2956955432891846, 0.2901429330314791], [1.0055526349632316, 1.2956955432891846], [0, 1.0055525855521794], [0.2893139885164264, 0]],
                "o": [[1.0055526349632316, 0], [1.2956955432891846, 1.0055525855521794], [0.2893139885164264, 1.2956955432891846], [0, 0.2901429330314791], [0.647433311739829, 0]]
              }
            },
            "_render": true
          }, {
            "ty": "fl",
            "c": {
              "a": 0,
              "k": [1, 1, 1],
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "r": 1,
            "bm": 0,
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [197.82676696777344, 218.07313537597656],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [0.6478477716445923, 0.6478477716445923],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, -100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 180,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": -180,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "gr",
          "nm": "Vector",
          "it": [{
            "ty": "sh",
            "d": 1,
            "ks": {
              "a": 0,
              "k": {
                "c": true,
                "v": [[0.6482623219490051, 0], [1.2965246438980103, 0.6474332623287768], [0.6482623219490051, 1.2956955432891846], [0, 0.6474332623287768], [0.6482623219490051, 0]],
                "i": [[0.6482623219490051, 0], [1.2965246438980103, 0.2901429330314791], [1.0063816678157254, 1.2956955432891846], [0, 1.0055525855521794], [0.2901429760822849, 0]],
                "o": [[1.0063816678157254, 0], [1.2965246438980103, 1.0055525855521794], [0.2901429760822849, 1.2956955432891846], [0, 0.2901429330314791], [0.6482623219490051, 0]]
              }
            },
            "_render": true
          }, {
            "ty": "fl",
            "c": {
              "a": 0,
              "k": [1, 1, 1],
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "r": 1,
            "bm": 0,
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [209.5333709716797, 214.26832580566406],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [0.6482623219490051, 0.6478477716445923],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, -100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 180,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": -180,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "gr",
          "nm": "Vector",
          "it": [{
            "ty": "sh",
            "d": 1,
            "ks": {
              "a": 0,
              "k": {
                "c": true,
                "v": [[0.6482623219490051, 0], [1.2965246438980103, 0.647433340549469], [0.6482623219490051, 1.294866681098938], [0, 0.647433340549469], [0.6482623219490051, 0]],
                "i": [[0.6482623219490051, 0], [1.2965246438980103, 0.290142995353382], [1.0063816678157254, 1.294866681098938], [0, 1.0055526797085497], [0.2901429760822849, 0]],
                "o": [[1.0063816678157254, 0], [1.2965246438980103, 1.0055526797085497], [0.2901429760822849, 1.294866681098938], [0, 0.290142995353382], [0.6482623219490051, 0]]
              }
            },
            "_render": true
          }, {
            "ty": "fl",
            "c": {
              "a": 0,
              "k": [1, 1, 1],
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "r": 1,
            "bm": 0,
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [216.7696990966797, 204.31259155273438],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [0.6482623219490051, 0.647433340549469],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, -100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 180,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": -180,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "gr",
          "nm": "Vector",
          "it": [{
            "ty": "sh",
            "d": 1,
            "ks": {
              "a": 0,
              "k": {
                "c": true,
                "v": [[0.6482623219490051, 0], [1.2965246438980103, 0.6474332623287768], [0.6482623219490051, 1.2956955432891846], [0, 0.6474332623287768], [0.6482623219490051, 0]],
                "i": [[0.6482623219490051, 0], [1.2965246438980103, 0.2901429330314791], [1.0063816678157254, 1.2956955432891846], [0, 1.0055525855521794], [0.2901429760822849, 0]],
                "o": [[1.0063816678157254, 0], [1.2965246438980103, 1.0055525855521794], [0.2901429760822849, 1.2956955432891846], [0, 0.2901429330314791], [0.6482623219490051, 0]]
              }
            },
            "_render": true
          }, {
            "ty": "fl",
            "c": {
              "a": 0,
              "k": [1, 1, 1],
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "r": 1,
            "bm": 0,
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [216.7696990966797, 192.00172424316406],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [0.6482623219490051, 0.6478477716445923],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, -100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 180,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": -180,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "gr",
          "nm": "Vector",
          "it": [{
            "ty": "sh",
            "d": 1,
            "ks": {
              "a": 0,
              "k": {
                "c": true,
                "v": [[0.6482623219490051, 0], [1.2965246438980103, 0.647433340549469], [0.6482623219490051, 1.294866681098938], [0, 0.647433340549469], [0.6482623219490051, 0]],
                "i": [[0.6482623219490051, 0], [1.2965246438980103, 0.290142995353382], [1.0063816678157254, 1.294866681098938], [0, 1.0055526797085497], [0.2901429760822849, 0]],
                "o": [[1.0063816678157254, 0], [1.2965246438980103, 1.0055526797085497], [0.2901429760822849, 1.294866681098938], [0, 0.290142995353382], [0.6482623219490051, 0]]
              }
            },
            "_render": true
          }, {
            "ty": "fl",
            "c": {
              "a": 0,
              "k": [1, 1, 1],
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "r": 1,
            "bm": 0,
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [209.5333709716797, 182.03805541992188],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [0.6482623219490051, 0.647433340549469],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, -100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 180,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": -180,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "gr",
          "nm": "Vector",
          "it": [{
            "ty": "sh",
            "d": 1,
            "ks": {
              "a": 0,
              "k": {
                "c": true,
                "v": [[0.647433311739829, 0], [1.2956955432891846, 0.647433340549469], [0.647433311739829, 1.294866681098938], [0, 0.647433340549469], [0.647433311739829, 0]],
                "i": [[0.647433311739829, 0], [1.2956955432891846, 0.290142995353382], [1.0055526349632316, 1.294866681098938], [0, 1.0055526797085497], [0.2893139885164264, 0]],
                "o": [[1.0055526349632316, 0], [1.2956955432891846, 1.0055526797085497], [0.2893139885164264, 1.294866681098938], [0, 0.290142995353382], [0.647433311739829, 0]]
              }
            },
            "_render": true
          }, {
            "ty": "fl",
            "c": {
              "a": 0,
              "k": [1, 1, 1],
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "r": 1,
            "bm": 0,
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [197.82676696777344, 178.24118041992188],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [0.6478477716445923, 0.647433340549469],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, -100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 180,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": -180,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "tr",
          "p": {
            "a": 0,
            "k": [60.534461975097656, 83.54061126708984],
            "ix": 2
          },
          "a": {
            "a": 0,
            "k": [197.82634735107422, 198.1573715209961],
            "ix": 2
          },
          "s": {
            "a": 0,
            "k": [109.14504528045654, 109.14504528045654],
            "ix": 2
          },
          "r": {
            "a": 0,
            "k": 0,
            "ix": 2
          },
          "o": {
            "a": 0,
            "k": 100,
            "ix": 2
          },
          "sk": {
            "a": 0,
            "k": 0,
            "ix": 2
          },
          "sa": {
            "a": 0,
            "k": 0,
            "ix": 2
          },
          "_render": true
        }],
        "_render": true
      }, {
        "ty": "tr",
        "p": {
          "a": 0,
          "k": [0.12225324660539627, 0.3143313527107239],
          "ix": 2
        },
        "a": {
          "a": 0,
          "k": [60.23484420776367, 83.24531555175781],
          "ix": 2
        },
        "s": {
          "a": 0,
          "k": [91.62120223045349, 91.62120223045349],
          "ix": 2
        },
        "r": {
          "a": 0,
          "k": 1.876219357654918e-7,
          "ix": 2
        },
        "o": {
          "a": 0,
          "k": 100,
          "ix": 2
        },
        "sk": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "sa": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "_render": true
      }],
      "_render": true
    }],
    "ip": 0,
    "op": 141,
    "st": 0,
    "bm": 0,
    "completed": true
  }, {
    "ddd": 0,
    "ind": 11,
    "ty": 3,
    "nm": "Lock A",
    "sr": 1,
    "ks": {
      "p": {
        "a": 0,
        "k": [0.39546966552734375, 0.814178466796875],
        "ix": 2
      },
      "a": {
        "a": 0,
        "k": [21.71578025817871, 21.715373992919922],
        "ix": 2
      },
      "s": {
        "a": 0,
        "k": [100, 100],
        "ix": 2
      },
      "r": {
        "a": 0,
        "k": 0,
        "ix": 2
      },
      "o": {
        "a": 0,
        "k": 100,
        "ix": 2
      },
      "sk": {
        "a": 0,
        "k": 0,
        "ix": 2
      },
      "sa": {
        "a": 0,
        "k": 0,
        "ix": 2
      }
    },
    "ao": 0,
    "ip": 0,
    "op": 141,
    "st": 0,
    "bm": 0,
    "parent": 9,
    "completed": true
  }, {
    "ddd": 0,
    "refId": "0",
    "w": 52,
    "h": 52,
    "ind": 1,
    "ty": 0,
    "nm": "Blur",
    "sr": 1,
    "ks": {
      "p": {
        "a": 0,
        "k": [-4, -4],
        "ix": 2
      },
      "a": {
        "a": 0,
        "k": [0, 0],
        "ix": 2
      },
      "s": {
        "a": 0,
        "k": [100, 100],
        "ix": 2
      },
      "r": {
        "a": 0,
        "k": 0,
        "ix": 2
      },
      "o": {
        "a": 0,
        "k": 100,
        "ix": 2
      },
      "sk": {
        "a": 0,
        "k": 0,
        "ix": 2
      },
      "sa": {
        "a": 0,
        "k": 0,
        "ix": 2
      }
    },
    "ao": 0,
    "ip": 0,
    "op": 141,
    "st": 0,
    "bm": 0,
    "parent": 11,
    "ef": [{
      "ty": 29,
      "nm": "Gaussian Blur2",
      "mn": "ADBE Gaussian Blur 2",
      "ef": [{
        "ty": 0,
        "nm": "Blurriness",
        "mn": "ADBE Gaussian Blur 2-0001",
        "v": {
          "a": 0,
          "k": 6,
          "ix": 2
        }
      }, {
        "ty": 7,
        "nm": "Blur Dimensions",
        "mn": "ADBE Gaussian Blur 2-0002",
        "v": {
          "a": 0,
          "k": 0,
          "ix": 2
        }
      }, {
        "ty": 4,
        "nm": "Repeat Edge Pixels",
        "mn": "ADBE Gaussian Blur 2-0003",
        "v": {
          "a": 0,
          "k": 0,
          "ix": 2
        }
      }],
      "np": 1,
      "ix": 0,
      "en": 1
    }],
    "completed": true,
    "layers": [{
      "ddd": 0,
      "ind": 1,
      "ty": 4,
      "nm": "Blur",
      "sr": 1,
      "ks": {
        "p": {
          "a": 0,
          "k": [4, 4],
          "ix": 2
        },
        "a": {
          "a": 0,
          "k": [0, 0],
          "ix": 2
        },
        "s": {
          "a": 0,
          "k": [100, 100],
          "ix": 2
        },
        "r": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "o": {
          "a": 0,
          "k": 100,
          "ix": 2
        },
        "sk": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "sa": {
          "a": 0,
          "k": 0,
          "ix": 2
        }
      },
      "ao": 0,
      "shapes": [{
        "ty": "gr",
        "it": [{
          "ty": "gr",
          "nm": "Blur",
          "it": [{
            "ty": "gr",
            "nm": "Path",
            "it": [{
              "ty": "sh",
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "v": [[43.43000030517578, 21.71500015258789], [21.71500015258789, 43.43000030517578], [0, 21.71500015258789], [21.71500015258789, 0], [43.43000030517578, 21.71500015258789]],
                  "i": [[43.43000030517578, 21.71500015258789], [33.7078630647702, 43.43000030517578], [0, 33.7078630647702], [9.722137240405582, 0], [43.43000030517578, 9.722137240405582]],
                  "o": [[43.43000030517578, 33.7078630647702], [9.722137240405582, 43.43000030517578], [0, 9.722137240405582], [33.7078630647702, 0], [43.43000030517578, 21.71500015258789]]
                }
              },
              "_render": true
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [21.71500015258789, 21.71500015258789],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [21.71500015258789, 21.71500015258789],
                "ix": 2
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 2
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 2
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "_render": true
            }],
            "_render": true
          }, {
            "ty": "gr",
            "nm": "Path",
            "it": [{
              "ty": "sh",
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "v": [[1.0617037320242593, 21.234059169880997], [21.234059169880997, 41.40641460773774], [41.40641460773774, 21.234059169880997], [21.234059169880997, 1.0617037320242593], [1.0617037320242593, 21.234059169880997]],
                  "i": [[1.0617037320242593, 21.234059169880997], [10.093174299672262, 41.40641460773774], [41.40641460773774, 32.37494404008973], [32.37494404008973, 1.0617037320242593], [1.0617037320242593, 10.093174299672262]],
                  "o": [[1.0617037320242593, 32.37494404008973], [32.37494404008973, 41.40641460773774], [41.40641460773774, 10.093174299672262], [10.093174299672262, 1.0617037320242593], [1.0617037320242593, 21.234059169880997]]
                }
              },
              "_render": true
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [21.714996337890625, 21.714996337890625],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [21.234059169881, 21.234059169881],
                "ix": 2
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 2
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 2
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "_render": true
            }],
            "_render": true
          }, {
            "ty": "fl",
            "c": {
              "a": 0,
              "k": [0, 0, 0],
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "r": 1,
            "bm": 0,
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [0, 0],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [0, 0],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "tr",
          "p": {
            "a": 0,
            "k": [21.715782165527344, 21.715003967285156],
            "ix": 2
          },
          "a": {
            "a": 0,
            "k": [21.71500015258789, 21.71500015258789],
            "ix": 2
          },
          "s": {
            "a": 0,
            "k": [100, 100],
            "ix": 2
          },
          "r": {
            "a": 0,
            "k": 1.8762201477034328e-7,
            "ix": 2
          },
          "o": {
            "a": 0,
            "k": 100,
            "ix": 2
          },
          "sk": {
            "a": 0,
            "k": 0,
            "ix": 2
          },
          "sa": {
            "a": 0,
            "k": 0,
            "ix": 2
          },
          "_render": true
        }],
        "_render": true
      }],
      "ip": 0,
      "op": 141,
      "st": 0,
      "bm": 0,
      "completed": true
    }, {
      "ddd": 0,
      "ind": 2,
      "ty": 4,
      "nm": "Blur Overscan",
      "sr": 1,
      "ks": {
        "p": {
          "a": 0,
          "k": [0, 0],
          "ix": 2
        },
        "a": {
          "a": 0,
          "k": [0, 0],
          "ix": 2
        },
        "s": {
          "a": 0,
          "k": [100, 100],
          "ix": 2
        },
        "r": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "o": {
          "a": 0,
          "k": 100,
          "ix": 2
        },
        "sk": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "sa": {
          "a": 0,
          "k": 0,
          "ix": 2
        }
      },
      "ao": 0,
      "shapes": [{
        "ty": "rc",
        "d": 1,
        "s": {
          "a": 0,
          "k": [52, 52],
          "ix": 2
        },
        "p": {
          "a": 0,
          "k": [26, 26],
          "ix": 2
        },
        "r": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "_render": true
      }, {
        "ty": "fl",
        "c": {
          "a": 0,
          "k": [0, 0, 0],
          "ix": 2
        },
        "o": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "r": 1,
        "bm": 0,
        "_render": true
      }],
      "ip": 0,
      "op": 141,
      "st": 0,
      "bm": 0,
      "completed": true
    }]
  }, {
    "ddd": 0,
    "ind": 12,
    "ty": 4,
    "nm": "Lock A",
    "sr": 1,
    "ks": {
      "p": {
        "a": 0,
        "k": [0, 0],
        "ix": 2
      },
      "a": {
        "a": 0,
        "k": [0, 0],
        "ix": 2
      },
      "s": {
        "a": 0,
        "k": [100, 100],
        "ix": 2
      },
      "r": {
        "a": 0,
        "k": 0,
        "ix": 2
      },
      "o": {
        "a": 0,
        "k": 100,
        "ix": 2
      },
      "sk": {
        "a": 0,
        "k": 0,
        "ix": 2
      },
      "sa": {
        "a": 0,
        "k": 0,
        "ix": 2
      }
    },
    "ao": 0,
    "parent": 11,
    "shapes": [{
      "ty": "gr",
      "nm": "Lock A",
      "it": [{
        "ty": "sh",
        "d": 1,
        "ks": {
          "a": 0,
          "k": {
            "c": true,
            "v": [[21.716184133428804, 0], [0, 21.715373992919922], [21.716184133428804, 43.430747985839844], [43.43156051635742, 21.715373992919922], [21.716184133428804, 0]],
            "i": [[21.716184133428804, 0], [0, 9.721769482491446], [9.722578302976133, 43.430747985839844], [43.43156051635742, 33.7089785033484], [33.70898144262699, 0]],
            "o": [[9.722578302976133, 0], [0, 33.7089785033484], [33.70898144262699, 43.430747985839844], [43.43156051635742, 9.721769482491446], [21.716184133428804, 0]]
          }
        },
        "_render": true
      }, {
        "ty": "gf",
        "o": {
          "a": 0,
          "k": 100,
          "ix": 2
        },
        "r": 1,
        "bm": 0,
        "g": {
          "p": 2,
          "k": {
            "a": 0,
            "k": [0, 0.0784313725490196, 0.0784313725490196, 0.0784313725490196, 1, 0.43137254901960786, 0.43137254901960786, 0.43137254901960786, 0, 1, 1, 1],
            "ix": 2
          }
        },
        "s": {
          "a": 0,
          "k": [32.21752944550053, 41.354403389068466],
          "ix": 2
        },
        "e": {
          "a": 0,
          "k": [13.604179358156102, 0.04083957302043473],
          "ix": 2
        },
        "t": 1,
        "_render": true
      }, {
        "ty": "tr",
        "p": {
          "a": 0,
          "k": [21.715782165527344, 21.715373992919922],
          "ix": 2
        },
        "a": {
          "a": 0,
          "k": [21.71578025817871, 21.715373992919922],
          "ix": 2
        },
        "s": {
          "a": 0,
          "k": [100, -100],
          "ix": 2
        },
        "r": {
          "a": 0,
          "k": -179.9999994973283,
          "ix": 2
        },
        "o": {
          "a": 0,
          "k": 100,
          "ix": 2
        },
        "sk": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "sa": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "_render": true
      }],
      "_render": true
    }],
    "ip": 0,
    "op": 141,
    "st": 0,
    "bm": 0,
    "completed": true
  }, {
    "ddd": 0,
    "ind": 13,
    "ty": 3,
    "nm": "Lcok B 1",
    "sr": 1,
    "ks": {
      "p": {
        "a": 0,
        "k": [-1.299890160560608, 0.03696342185139656],
        "ix": 2
      },
      "a": {
        "a": 0,
        "k": [197.81352996826172, 197.81504821777344],
        "ix": 2
      },
      "s": {
        "a": 0,
        "k": [100.00000268335543, 100.00000268335545],
        "ix": 2
      },
      "r": {
        "a": 0,
        "k": -3.9999995254690734,
        "ix": 2
      },
      "o": {
        "a": 0,
        "k": 100,
        "ix": 2
      },
      "sk": {
        "a": 0,
        "k": 0,
        "ix": 2
      },
      "sa": {
        "a": 0,
        "k": 0,
        "ix": 2
      }
    },
    "ao": 0,
    "ip": 0,
    "op": 141,
    "st": 0,
    "bm": 0,
    "parent": 6,
    "completed": true
  }, {
    "ddd": 0,
    "refId": "1",
    "w": 74,
    "h": 74,
    "ind": 3,
    "ty": 0,
    "nm": "Blur",
    "sr": 1,
    "ks": {
      "p": {
        "a": 0,
        "k": [161, 161],
        "ix": 2
      },
      "a": {
        "a": 0,
        "k": [0, 0],
        "ix": 2
      },
      "s": {
        "a": 0,
        "k": [100, 100],
        "ix": 2
      },
      "r": {
        "a": 0,
        "k": 0,
        "ix": 2
      },
      "o": {
        "a": 0,
        "k": 100,
        "ix": 2
      },
      "sk": {
        "a": 0,
        "k": 0,
        "ix": 2
      },
      "sa": {
        "a": 0,
        "k": 0,
        "ix": 2
      }
    },
    "ao": 0,
    "ip": 0,
    "op": 141,
    "st": 0,
    "bm": 0,
    "parent": 13,
    "ef": [{
      "ty": 29,
      "nm": "Gaussian Blur2",
      "mn": "ADBE Gaussian Blur 2",
      "ef": [{
        "ty": 0,
        "nm": "Blurriness",
        "mn": "ADBE Gaussian Blur 2-0001",
        "v": {
          "a": 0,
          "k": 8.67,
          "ix": 2
        }
      }, {
        "ty": 7,
        "nm": "Blur Dimensions",
        "mn": "ADBE Gaussian Blur 2-0002",
        "v": {
          "a": 0,
          "k": 0,
          "ix": 2
        }
      }, {
        "ty": 4,
        "nm": "Repeat Edge Pixels",
        "mn": "ADBE Gaussian Blur 2-0003",
        "v": {
          "a": 0,
          "k": 0,
          "ix": 2
        }
      }],
      "np": 1,
      "ix": 0,
      "en": 1
    }],
    "completed": true,
    "layers": [{
      "ddd": 0,
      "ind": 3,
      "ty": 4,
      "nm": "Blur",
      "sr": 1,
      "ks": {
        "p": {
          "a": 0,
          "k": [-161, -161],
          "ix": 2
        },
        "a": {
          "a": 0,
          "k": [0, 0],
          "ix": 2
        },
        "s": {
          "a": 0,
          "k": [100, 100],
          "ix": 2
        },
        "r": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "o": {
          "a": 0,
          "k": 100,
          "ix": 2
        },
        "sk": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "sa": {
          "a": 0,
          "k": 0,
          "ix": 2
        }
      },
      "ao": 0,
      "shapes": [{
        "ty": "gr",
        "it": [{
          "ty": "gr",
          "nm": "Blur",
          "it": [{
            "ty": "gr",
            "nm": "Path",
            "it": [{
              "ty": "sh",
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "v": [[62.83000183105469, 31.415000915527344], [31.415000915527344, 62.83000183105469], [0, 31.415000915527344], [31.415000915527344, 0], [62.83000183105469, 31.415000915527344]],
                  "i": [[62.83000183105469, 31.415000915527344], [48.7650260925293, 62.83000183105469], [0, 48.7650260925293], [14.06497573852539, 0], [62.83000183105469, 14.06497573852539]],
                  "o": [[62.83000183105469, 48.7650260925293], [14.06497573852539, 62.83000183105469], [0, 14.06497573852539], [48.7650260925293, 0], [62.83000183105469, 31.415000915527344]]
                }
              },
              "_render": true
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [31.415000915527344, 31.415000915527344],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [31.415000915527344, 31.415000915527344],
                "ix": 2
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 2
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 2
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "_render": true
            }],
            "_render": true
          }, {
            "ty": "gr",
            "nm": "Path",
            "it": [{
              "ty": "sh",
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "v": [[1.5707511901855469, 31.415000915527344], [31.415000915527344, 61.25925064086914], [61.25925064086914, 31.415000915527344], [31.415000915527344, 1.5707511901855469], [1.5707511901855469, 31.415000915527344]],
                  "i": [[1.5707511901855469, 31.415000915527344], [14.932476043701172, 61.25925064086914], [61.25925064086914, 47.897525787353516], [47.897525787353516, 1.5707511901855469], [1.5707511901855469, 14.932476043701172]],
                  "o": [[1.5707511901855469, 47.897525787353516], [47.897525787353516, 61.25925064086914], [61.25925064086914, 14.932476043701172], [14.932476043701172, 1.5707511901855469], [1.5707511901855469, 31.415000915527344]]
                }
              },
              "_render": true
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [31.415000915527344, 31.415000915527344],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [31.415000915527344, 31.415000915527344],
                "ix": 2
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 2
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 2
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "_render": true
            }],
            "_render": true
          }, {
            "ty": "fl",
            "c": {
              "a": 0,
              "k": [0.7098039215686275, 0.7019607843137254, 0.9490196078431372],
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 80,
              "ix": 2
            },
            "r": 1,
            "bm": 0,
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [0, 0],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [0, 0],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "tr",
          "p": {
            "a": 0,
            "k": [197.81288146972656, 197.81520080566406],
            "ix": 2
          },
          "a": {
            "a": 0,
            "k": [31.415000915527344, 31.415000915527344],
            "ix": 2
          },
          "s": {
            "a": 0,
            "k": [100, 100],
            "ix": 2
          },
          "r": {
            "a": 0,
            "k": 1.8762198932590582e-7,
            "ix": 2
          },
          "o": {
            "a": 0,
            "k": 100,
            "ix": 2
          },
          "sk": {
            "a": 0,
            "k": 0,
            "ix": 2
          },
          "sa": {
            "a": 0,
            "k": 0,
            "ix": 2
          },
          "_render": true
        }],
        "_render": true
      }],
      "ip": 0,
      "op": 141,
      "st": 0,
      "bm": 0,
      "completed": true
    }, {
      "ddd": 0,
      "ind": 4,
      "ty": 4,
      "nm": "Blur Overscan",
      "sr": 1,
      "ks": {
        "p": {
          "a": 0,
          "k": [0, 0],
          "ix": 2
        },
        "a": {
          "a": 0,
          "k": [0, 0],
          "ix": 2
        },
        "s": {
          "a": 0,
          "k": [100, 100],
          "ix": 2
        },
        "r": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "o": {
          "a": 0,
          "k": 100,
          "ix": 2
        },
        "sk": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "sa": {
          "a": 0,
          "k": 0,
          "ix": 2
        }
      },
      "ao": 0,
      "shapes": [{
        "ty": "rc",
        "d": 1,
        "s": {
          "a": 0,
          "k": [74, 74],
          "ix": 2
        },
        "p": {
          "a": 0,
          "k": [37, 37],
          "ix": 2
        },
        "r": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "_render": true
      }, {
        "ty": "fl",
        "c": {
          "a": 0,
          "k": [0, 0, 0],
          "ix": 2
        },
        "o": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "r": 1,
        "bm": 0,
        "_render": true
      }],
      "ip": 0,
      "op": 141,
      "st": 0,
      "bm": 0,
      "completed": true
    }]
  }, {
    "ddd": 0,
    "ind": 14,
    "ty": 4,
    "nm": "Lcok B",
    "sr": 1,
    "ks": {
      "p": {
        "a": 0,
        "k": [0, 0],
        "ix": 2
      },
      "a": {
        "a": 0,
        "k": [0, 0],
        "ix": 2
      },
      "s": {
        "a": 0,
        "k": [100, 100],
        "ix": 2
      },
      "r": {
        "a": 0,
        "k": 0,
        "ix": 2
      },
      "o": {
        "a": 0,
        "k": 100,
        "ix": 2
      },
      "sk": {
        "a": 0,
        "k": 0,
        "ix": 2
      },
      "sa": {
        "a": 0,
        "k": 0,
        "ix": 2
      }
    },
    "ao": 0,
    "parent": 13,
    "shapes": [{
      "ty": "gr",
      "nm": "Lcok B",
      "it": [{
        "ty": "sh",
        "d": 1,
        "ks": {
          "a": 0,
          "k": {
            "c": true,
            "v": [[31.414165496826172, 0], [0, 31.413225173950195], [31.414165496826172, 62.82645034790039], [62.827388763427734, 31.413225173950195], [31.414165496826172, 0]],
            "i": [[31.414165496826172, 0], [0, 14.062995910644531], [14.064876556396484, 62.82645034790039], [62.827388763427734, 48.76251411437988], [48.76345443725586, 0]],
            "o": [[14.064876556396484, 0], [0, 48.76251411437988], [48.76345443725586, 62.82645034790039], [62.827388763427734, 14.062995910644531], [31.414165496826172, 0]]
          }
        },
        "_render": true
      }, {
        "ty": "fl",
        "c": {
          "a": 0,
          "k": [0.09803921568627451, 0.09411764705882353, 0.10588235294117647],
          "ix": 2
        },
        "o": {
          "a": 0,
          "k": 100,
          "ix": 2
        },
        "r": 1,
        "bm": 0,
        "_render": true
      }, {
        "ty": "tr",
        "p": {
          "a": 0,
          "k": [197.8155059814453, 197.8134307861328],
          "ix": 2
        },
        "a": {
          "a": 0,
          "k": [31.413694381713867, 31.413225173950195],
          "ix": 2
        },
        "s": {
          "a": 0,
          "k": [99.99999403953552, -99.99999403953552],
          "ix": 2
        },
        "r": {
          "a": 0,
          "k": 179.99999999999997,
          "ix": 2
        },
        "o": {
          "a": 0,
          "k": 100,
          "ix": 2
        },
        "sk": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "sa": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "_render": true
      }],
      "_render": true
    }],
    "ip": 0,
    "op": 141,
    "st": 0,
    "bm": 0,
    "completed": true
  }, {
    "ddd": 0,
    "refId": "2",
    "ind": 15,
    "ty": 2,
    "nm": "BalaPng.png 1",
    "sr": 1,
    "ks": {
      "p": {
        "a": 1,
        "k": [{
          "t": 0,
          "s": [-24.505836486816406, -51.10407638549805],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          },
          "__fnct": [null, null]
        }, {
          "t": 20,
          "s": [-24.505836486816406, -42.354042053222656],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          },
          "__fnct": [null, null]
        }, {
          "t": 40,
          "s": [-42.5165901184082, -45.58359909057617],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          }
        }],
        "ix": 2
      },
      "a": {
        "a": 0,
        "k": [0, 0],
        "ix": 2
      },
      "s": {
        "a": 0,
        "k": [20, 20],
        "ix": 2
      },
      "r": {
        "a": 1,
        "k": [{
          "t": 20,
          "s": [0],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          },
          "__fnct": [null]
        }, {
          "t": 40,
          "s": [-24],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          }
        }],
        "ix": 2
      },
      "o": {
        "a": 0,
        "k": 100,
        "ix": 2
      },
      "sk": {
        "a": 0,
        "k": 0,
        "ix": 2
      },
      "sa": {
        "a": 0,
        "k": 0,
        "ix": 2
      }
    },
    "ao": 0,
    "ip": 0,
    "op": 141,
    "st": 0,
    "bm": 0,
    "parent": 5,
    "completed": true
  }, {
    "ddd": 0,
    "refId": "3",
    "ind": 16,
    "ty": 2,
    "nm": "BackGround.png 1",
    "sr": 1,
    "ks": {
      "p": {
        "a": 0,
        "k": [86.15999603271484, 83.88790130615234],
        "ix": 2
      },
      "a": {
        "a": 0,
        "k": [178.5, 178.5],
        "ix": 2
      },
      "s": {
        "a": 0,
        "k": [39.54227868511918, 39.54227868511918],
        "ix": 2
      },
      "r": {
        "a": 0,
        "k": 0,
        "ix": 2
      },
      "o": {
        "a": 0,
        "k": 100,
        "ix": 2
      },
      "sk": {
        "a": 0,
        "k": 0,
        "ix": 2
      },
      "sa": {
        "a": 0,
        "k": 0,
        "ix": 2
      }
    },
    "ao": 0,
    "ip": 0,
    "op": 141,
    "st": 0,
    "bm": 0,
    "hd": true,
    "completed": true
  }],
  "markers": [],
  "__complete": true
};
const WrongEnterPasswordConst = {
  "v": "5.7.5",
  "fr": 100,
  "ip": 0,
  "op": 120,
  "w": 171,
  "h": 171,
  "nm": "Comp 1",
  "ddd": 0,
  "metadata": {
    "lottielabInteractivity": {
      "__version": "v1",
      "initialState": "Typing",
      "states": {
        "Typing": {
          "segment": [0, 1.2],
          "speed": 1,
          "direction": "forward",
          "loop": true
        },
        "Wrong": {
          "segment": [1.57, 3.22],
          "speed": 1,
          "direction": "forward",
          "loop": false
        },
        "Correct": {
          "segment": [3.22, 4.5],
          "speed": 1,
          "direction": "forward",
          "loop": false
        }
      }
    }
  },
  "assets": [{
    "id": "0",
    "layers": [{
      "ddd": 0,
      "ind": 1,
      "ty": 4,
      "nm": "Blur",
      "sr": 1,
      "ks": {
        "p": {
          "a": 0,
          "k": [4, 4],
          "ix": 2
        },
        "a": {
          "a": 0,
          "k": [0, 0],
          "ix": 2
        },
        "s": {
          "a": 0,
          "k": [100, 100],
          "ix": 2
        },
        "r": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "o": {
          "a": 0,
          "k": 100,
          "ix": 2
        },
        "sk": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "sa": {
          "a": 0,
          "k": 0,
          "ix": 2
        }
      },
      "ao": 0,
      "shapes": [{
        "ty": "gr",
        "it": [{
          "ty": "gr",
          "nm": "Blur",
          "it": [{
            "ty": "gr",
            "nm": "Path",
            "it": [{
              "ty": "sh",
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "v": [[43.43000030517578, 21.71500015258789], [21.71500015258789, 43.43000030517578], [0, 21.71500015258789], [21.71500015258789, 0], [43.43000030517578, 21.71500015258789]],
                  "i": [[43.43000030517578, 21.71500015258789], [33.7078630647702, 43.43000030517578], [0, 33.7078630647702], [9.722137240405582, 0], [43.43000030517578, 9.722137240405582]],
                  "o": [[43.43000030517578, 33.7078630647702], [9.722137240405582, 43.43000030517578], [0, 9.722137240405582], [33.7078630647702, 0], [43.43000030517578, 21.71500015258789]]
                }
              },
              "_render": true
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [21.71500015258789, 21.71500015258789],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [21.71500015258789, 21.71500015258789],
                "ix": 2
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 2
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 2
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "_render": true
            }],
            "_render": true
          }, {
            "ty": "gr",
            "nm": "Path",
            "it": [{
              "ty": "sh",
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "v": [[1.0617037320242593, 21.234059169880997], [21.234059169880997, 41.40641460773774], [41.40641460773774, 21.234059169880997], [21.234059169880997, 1.0617037320242593], [1.0617037320242593, 21.234059169880997]],
                  "i": [[1.0617037320242593, 21.234059169880997], [10.093174299672262, 41.40641460773774], [41.40641460773774, 32.37494404008973], [32.37494404008973, 1.0617037320242593], [1.0617037320242593, 10.093174299672262]],
                  "o": [[1.0617037320242593, 32.37494404008973], [32.37494404008973, 41.40641460773774], [41.40641460773774, 10.093174299672262], [10.093174299672262, 1.0617037320242593], [1.0617037320242593, 21.234059169880997]]
                }
              },
              "_render": true
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [21.714996337890625, 21.714996337890625],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [21.234059169881, 21.234059169881],
                "ix": 2
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 2
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 2
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "_render": true
            }],
            "_render": true
          }, {
            "ty": "fl",
            "c": {
              "a": 0,
              "k": [0, 0, 0],
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "r": 1,
            "bm": 0,
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [0, 0],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [0, 0],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "tr",
          "p": {
            "a": 0,
            "k": [21.715782165527344, 21.715003967285156],
            "ix": 2
          },
          "a": {
            "a": 0,
            "k": [21.71500015258789, 21.71500015258789],
            "ix": 2
          },
          "s": {
            "a": 0,
            "k": [100, 100],
            "ix": 2
          },
          "r": {
            "a": 0,
            "k": 1.8762201477034328e-7,
            "ix": 2
          },
          "o": {
            "a": 0,
            "k": 100,
            "ix": 2
          },
          "sk": {
            "a": 0,
            "k": 0,
            "ix": 2
          },
          "sa": {
            "a": 0,
            "k": 0,
            "ix": 2
          },
          "_render": true
        }],
        "_render": true
      }],
      "ip": 0,
      "op": 121,
      "st": 0,
      "bm": 0,
      "completed": true
    }, {
      "ddd": 0,
      "ind": 2,
      "ty": 4,
      "nm": "Blur Overscan",
      "sr": 1,
      "ks": {
        "p": {
          "a": 0,
          "k": [0, 0],
          "ix": 2
        },
        "a": {
          "a": 0,
          "k": [0, 0],
          "ix": 2
        },
        "s": {
          "a": 0,
          "k": [100, 100],
          "ix": 2
        },
        "r": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "o": {
          "a": 0,
          "k": 100,
          "ix": 2
        },
        "sk": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "sa": {
          "a": 0,
          "k": 0,
          "ix": 2
        }
      },
      "ao": 0,
      "shapes": [{
        "ty": "rc",
        "d": 1,
        "s": {
          "a": 0,
          "k": [52, 52],
          "ix": 2
        },
        "p": {
          "a": 0,
          "k": [26, 26],
          "ix": 2
        },
        "r": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "_render": true
      }, {
        "ty": "fl",
        "c": {
          "a": 0,
          "k": [0, 0, 0],
          "ix": 2
        },
        "o": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "r": 1,
        "bm": 0,
        "_render": true
      }],
      "ip": 0,
      "op": 121,
      "st": 0,
      "bm": 0,
      "completed": true
    }]
  }, {
    "id": "1",
    "layers": [{
      "ddd": 0,
      "ind": 3,
      "ty": 4,
      "nm": "Blur",
      "sr": 1,
      "ks": {
        "p": {
          "a": 0,
          "k": [-161, -161],
          "ix": 2
        },
        "a": {
          "a": 0,
          "k": [0, 0],
          "ix": 2
        },
        "s": {
          "a": 0,
          "k": [100, 100],
          "ix": 2
        },
        "r": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "o": {
          "a": 0,
          "k": 100,
          "ix": 2
        },
        "sk": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "sa": {
          "a": 0,
          "k": 0,
          "ix": 2
        }
      },
      "ao": 0,
      "shapes": [{
        "ty": "gr",
        "it": [{
          "ty": "gr",
          "nm": "Blur",
          "it": [{
            "ty": "gr",
            "nm": "Path",
            "it": [{
              "ty": "sh",
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "v": [[62.83000183105469, 31.415000915527344], [31.415000915527344, 62.83000183105469], [0, 31.415000915527344], [31.415000915527344, 0], [62.83000183105469, 31.415000915527344]],
                  "i": [[62.83000183105469, 31.415000915527344], [48.7650260925293, 62.83000183105469], [0, 48.7650260925293], [14.06497573852539, 0], [62.83000183105469, 14.06497573852539]],
                  "o": [[62.83000183105469, 48.7650260925293], [14.06497573852539, 62.83000183105469], [0, 14.06497573852539], [48.7650260925293, 0], [62.83000183105469, 31.415000915527344]]
                }
              },
              "_render": true
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [31.415000915527344, 31.415000915527344],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [31.415000915527344, 31.415000915527344],
                "ix": 2
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 2
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 2
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "_render": true
            }],
            "_render": true
          }, {
            "ty": "gr",
            "nm": "Path",
            "it": [{
              "ty": "sh",
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "v": [[1.5707511901855469, 31.415000915527344], [31.415000915527344, 61.25925064086914], [61.25925064086914, 31.415000915527344], [31.415000915527344, 1.5707511901855469], [1.5707511901855469, 31.415000915527344]],
                  "i": [[1.5707511901855469, 31.415000915527344], [14.932476043701172, 61.25925064086914], [61.25925064086914, 47.897525787353516], [47.897525787353516, 1.5707511901855469], [1.5707511901855469, 14.932476043701172]],
                  "o": [[1.5707511901855469, 47.897525787353516], [47.897525787353516, 61.25925064086914], [61.25925064086914, 14.932476043701172], [14.932476043701172, 1.5707511901855469], [1.5707511901855469, 31.415000915527344]]
                }
              },
              "_render": true
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [31.415000915527344, 31.415000915527344],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [31.415000915527344, 31.415000915527344],
                "ix": 2
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 2
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 2
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "_render": true
            }],
            "_render": true
          }, {
            "ty": "fl",
            "c": {
              "a": 0,
              "k": [0.7098039215686275, 0.7019607843137254, 0.9490196078431372],
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 80,
              "ix": 2
            },
            "r": 1,
            "bm": 0,
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [0, 0],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [0, 0],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "tr",
          "p": {
            "a": 0,
            "k": [197.81288146972656, 197.81520080566406],
            "ix": 2
          },
          "a": {
            "a": 0,
            "k": [31.415000915527344, 31.415000915527344],
            "ix": 2
          },
          "s": {
            "a": 0,
            "k": [100, 100],
            "ix": 2
          },
          "r": {
            "a": 0,
            "k": 1.8762198932590582e-7,
            "ix": 2
          },
          "o": {
            "a": 0,
            "k": 100,
            "ix": 2
          },
          "sk": {
            "a": 0,
            "k": 0,
            "ix": 2
          },
          "sa": {
            "a": 0,
            "k": 0,
            "ix": 2
          },
          "_render": true
        }],
        "_render": true
      }],
      "ip": 0,
      "op": 121,
      "st": 0,
      "bm": 0,
      "completed": true
    }, {
      "ddd": 0,
      "ind": 4,
      "ty": 4,
      "nm": "Blur Overscan",
      "sr": 1,
      "ks": {
        "p": {
          "a": 0,
          "k": [0, 0],
          "ix": 2
        },
        "a": {
          "a": 0,
          "k": [0, 0],
          "ix": 2
        },
        "s": {
          "a": 0,
          "k": [100, 100],
          "ix": 2
        },
        "r": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "o": {
          "a": 0,
          "k": 100,
          "ix": 2
        },
        "sk": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "sa": {
          "a": 0,
          "k": 0,
          "ix": 2
        }
      },
      "ao": 0,
      "shapes": [{
        "ty": "rc",
        "d": 1,
        "s": {
          "a": 0,
          "k": [74, 74],
          "ix": 2
        },
        "p": {
          "a": 0,
          "k": [37, 37],
          "ix": 2
        },
        "r": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "_render": true
      }, {
        "ty": "fl",
        "c": {
          "a": 0,
          "k": [0, 0, 0],
          "ix": 2
        },
        "o": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "r": 1,
        "bm": 0,
        "_render": true
      }],
      "ip": 0,
      "op": 121,
      "st": 0,
      "bm": 0,
      "completed": true
    }]
  }, {
    "id": "2",
    "u": "",
    "p": "data:image/png;base64,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",
    "w": 249,
    "h": 271,
    "e": 1
  }],
  "layers": [{
    "ddd": 0,
    "ind": 5,
    "ty": 3,
    "nm": "Lock",
    "sr": 1,
    "ks": {
      "p": {
        "a": 0,
        "k": [85.10450744628906, 83.90176391601562],
        "ix": 2
      },
      "a": {
        "a": 0,
        "k": [0, 0],
        "ix": 2
      },
      "s": {
        "a": 1,
        "k": [{
          "t": 0,
          "s": [100, 100],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          },
          "__fnct": [null, null]
        }, {
          "t": 15,
          "s": [90, 90],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          },
          "__fnct": [null, null]
        }, {
          "t": 25,
          "s": [100, 100],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          }
        }],
        "ix": 2
      },
      "r": {
        "a": 1,
        "k": [{
          "t": 15,
          "s": [0],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          },
          "__fnct": [null]
        }, {
          "t": 25,
          "s": [10],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          },
          "__fnct": [null]
        }, {
          "t": 35,
          "s": [-10],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          },
          "__fnct": [null]
        }, {
          "t": 42,
          "s": [8],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          },
          "__fnct": [null]
        }, {
          "t": 49,
          "s": [-8],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          },
          "__fnct": [null]
        }, {
          "t": 54,
          "s": [6],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          },
          "__fnct": [null]
        }, {
          "t": 59,
          "s": [-6],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          },
          "__fnct": [null]
        }, {
          "t": 63,
          "s": [3],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          },
          "__fnct": [null]
        }, {
          "t": 67,
          "s": [-3],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          },
          "__fnct": [null]
        }, {
          "t": 69,
          "s": [1],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          },
          "__fnct": [null]
        }, {
          "t": 73,
          "s": [-1],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          },
          "__fnct": [null]
        }, {
          "t": 75,
          "s": [0],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          }
        }],
        "ix": 2
      },
      "o": {
        "a": 0,
        "k": 100,
        "ix": 2
      },
      "sk": {
        "a": 0,
        "k": 0,
        "ix": 2
      },
      "sa": {
        "a": 0,
        "k": 0,
        "ix": 2
      }
    },
    "ao": 0,
    "ip": 0,
    "op": 121,
    "st": 0,
    "bm": 0,
    "completed": true
  }, {
    "ddd": 0,
    "ind": 6,
    "ty": 3,
    "nm": "Badane",
    "sr": 1,
    "ks": {
      "p": {
        "a": 0,
        "k": [1.6947784423828125, 18.566986083984375],
        "ix": 2
      },
      "a": {
        "a": 0,
        "k": [0, 0],
        "ix": 2
      },
      "s": {
        "a": 0,
        "k": [99.99999668543774, 99.99999668543774],
        "ix": 2
      },
      "r": {
        "a": 0,
        "k": 3.999999525469073,
        "ix": 2
      },
      "o": {
        "a": 0,
        "k": 100,
        "ix": 2
      },
      "sk": {
        "a": 0,
        "k": 0,
        "ix": 2
      },
      "sa": {
        "a": 0,
        "k": 0,
        "ix": 2
      }
    },
    "ao": 0,
    "ip": 0,
    "op": 121,
    "st": 0,
    "bm": 0,
    "parent": 5,
    "completed": true
  }, {
    "ddd": 0,
    "ind": 7,
    "ty": 4,
    "nm": "Middle Circle",
    "sr": 1,
    "ks": {
      "p": {
        "a": 0,
        "k": [0, 0],
        "ix": 2
      },
      "a": {
        "a": 0,
        "k": [0, 0],
        "ix": 2
      },
      "s": {
        "a": 0,
        "k": [100, 100],
        "ix": 2
      },
      "r": {
        "a": 0,
        "k": 0,
        "ix": 2
      },
      "o": {
        "a": 0,
        "k": 100,
        "ix": 2
      },
      "sk": {
        "a": 0,
        "k": 0,
        "ix": 2
      },
      "sa": {
        "a": 0,
        "k": 0,
        "ix": 2
      }
    },
    "ao": 0,
    "parent": 6,
    "shapes": [{
      "ty": "gr",
      "it": [{
        "ty": "gr",
        "nm": "Circle A",
        "it": [{
          "ty": "sh",
          "d": 1,
          "ks": {
            "a": 0,
            "k": {
              "c": true,
              "v": [[13.647854804992676, 6.823927402496338], [6.823927402496338, 13.647854804992676], [0, 6.823927402496338], [6.823927402496338, 0], [13.647854804992676, 6.823927402496338]],
              "i": [[13.647854804992676, 6.823927402496338], [10.592678620604888, 13.647854804992676], [0, 10.592678620604888], [3.0551761843877885, 0], [13.647854804992676, 3.0551761843877885]],
              "o": [[13.647854804992676, 10.592678620604888], [3.0551761843877885, 13.647854804992676], [0, 3.0551761843877885], [10.592678620604888, 0], [13.647854804992676, 6.823927402496338]]
            }
          },
          "_render": true
        }, {
          "ty": "st",
          "c": {
            "a": 0,
            "k": [0.49411764705882355, 0.49411764705882355, 0.49411764705882355],
            "ix": 2
          },
          "o": {
            "a": 0,
            "k": 100,
            "ix": 2
          },
          "w": {
            "a": 0,
            "k": 0.20000000298023224,
            "ix": 2
          },
          "lc": 2,
          "lj": 1,
          "ml": 4,
          "_render": true
        }, {
          "ty": "tr",
          "p": {
            "a": 0,
            "k": [-0.0008451848407275975, 0.1417044699192047],
            "ix": 2
          },
          "a": {
            "a": 0,
            "k": [6.823927402496338, 6.823927402496338],
            "ix": 2
          },
          "s": {
            "a": 0,
            "k": [100, -100],
            "ix": 2
          },
          "r": {
            "a": 0,
            "k": 180,
            "ix": 2
          },
          "o": {
            "a": 0,
            "k": 40.00000059604645,
            "ix": 2
          },
          "sk": {
            "a": 0,
            "k": 0,
            "ix": 2
          },
          "sa": {
            "a": 0,
            "k": 0,
            "ix": 2
          },
          "_render": true
        }],
        "_render": true
      }, {
        "ty": "gr",
        "nm": "Cicle B",
        "it": [{
          "ty": "sh",
          "d": 1,
          "ks": {
            "a": 0,
            "k": {
              "c": true,
              "v": [[8.86856460571289, 0], [17.73712921142578, 8.869507040676757], [8.86856460571289, 17.73807144165039], [0, 8.869507040676757], [8.86856460571289, 0]],
              "i": [[8.86856460571289, 0], [17.73712921142578, 3.971604110622632], [13.766467648839768, 17.73807144165039], [0, 13.767409970730881], [3.9697202694893052, 0]],
              "o": [[13.766467648839768, 0], [17.73712921142578, 13.767409970730881], [3.9697202694893052, 17.73807144165039], [0, 3.971604110622632], [8.86856460571289, 0]]
            }
          },
          "_render": true
        }, {
          "ty": "gf",
          "o": {
            "a": 0,
            "k": 100,
            "ix": 2
          },
          "r": 1,
          "bm": 0,
          "g": {
            "p": 2,
            "k": {
              "a": 0,
              "k": [0, 0.10980392156862745, 0.10980392156862745, 0.10980392156862745, 1, 0.35294117647058826, 0.35294117647058826, 0.35294117647058826, 0, 1, 1, 1],
              "ix": 2
            }
          },
          "s": {
            "a": 0,
            "k": [13.157401572815616, 16.89004670104441],
            "ix": 2
          },
          "e": {
            "a": 0,
            "k": [5.555846583042921, 0.016679778670152245],
            "ix": 2
          },
          "t": 1,
          "_render": true
        }, {
          "ty": "tr",
          "p": {
            "a": 0,
            "k": [-0.0025287296157330275, -0.0019147867569699883],
            "ix": 2
          },
          "a": {
            "a": 0,
            "k": [8.86856460571289, 8.869035720825195],
            "ix": 2
          },
          "s": {
            "a": 0,
            "k": [100, -100],
            "ix": 2
          },
          "r": {
            "a": 0,
            "k": 180,
            "ix": 2
          },
          "o": {
            "a": 0,
            "k": 100,
            "ix": 2
          },
          "sk": {
            "a": 0,
            "k": 0,
            "ix": 2
          },
          "sa": {
            "a": 0,
            "k": 0,
            "ix": 2
          },
          "_render": true
        }],
        "_render": true
      }, {
        "ty": "gr",
        "nm": "Citcle 3",
        "it": [{
          "ty": "sh",
          "d": 1,
          "ks": {
            "a": 0,
            "k": {
              "c": true,
              "v": [[12.03059693778647, 0], [24.060251235961914, 12.029655195927457], [12.03059693778647, 24.060251235961914], [0, 12.029655195927457], [12.03059693778647, 0]],
              "i": [[12.03059693778647, 0], [24.060251235961914, 5.386468970891877], [18.674724455805055, 24.060251235961914], [0, 18.673782713946046], [5.386469419767883, 0]],
              "o": [[18.674724455805055, 0], [24.060251235961914, 18.673782713946046], [5.386469419767883, 24.060251235961914], [0, 5.386468970891877], [12.03059693778647, 0]]
            }
          },
          "_render": true
        }, {
          "ty": "gf",
          "o": {
            "a": 0,
            "k": 100,
            "ix": 2
          },
          "r": 1,
          "bm": 0,
          "g": {
            "p": 2,
            "k": {
              "a": 0,
              "k": [0, 0, 0, 0, 1, 0.12941176470588237, 0.10588235294117647, 0.19607843137254902, 0, 1, 1, 1],
              "ix": 2
            }
          },
          "s": {
            "a": 0,
            "k": [17.847893178252207, 22.909974646964656],
            "ix": 2
          },
          "e": {
            "a": 0,
            "k": [7.536454350818133, 0.02262476316460038],
            "ix": 2
          },
          "t": 1,
          "_render": true
        }, {
          "ty": "tr",
          "p": {
            "a": 0,
            "k": [-9.894472441374091e-7, 1.9125218386761844e-7],
            "ix": 2
          },
          "a": {
            "a": 0,
            "k": [12.030125617980957, 12.030125617980957],
            "ix": 2
          },
          "s": {
            "a": 0,
            "k": [100, -100],
            "ix": 2
          },
          "r": {
            "a": 0,
            "k": 180,
            "ix": 2
          },
          "o": {
            "a": 0,
            "k": 100,
            "ix": 2
          },
          "sk": {
            "a": 0,
            "k": 0,
            "ix": 2
          },
          "sa": {
            "a": 0,
            "k": 0,
            "ix": 2
          },
          "_render": true
        }],
        "_render": true
      }, {
        "ty": "tr",
        "p": {
          "a": 0,
          "k": [-1.2999141216278076, 0.036949798464775085],
          "ix": 2
        },
        "a": {
          "a": 0,
          "k": [-9.5367431640625e-7, 0],
          "ix": 2
        },
        "s": {
          "a": 0,
          "k": [100.00000268335543, 100.00000268335545],
          "ix": 2
        },
        "r": {
          "a": 0,
          "k": -3.999999525469093,
          "ix": 2
        },
        "o": {
          "a": 0,
          "k": 100,
          "ix": 2
        },
        "sk": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "sa": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "_render": true
      }],
      "_render": true
    }],
    "ip": 0,
    "op": 121,
    "st": 0,
    "bm": 0,
    "completed": true
  }, {
    "ddd": 0,
    "ind": 8,
    "ty": 4,
    "nm": "Pointer",
    "sr": 1,
    "ks": {
      "p": {
        "a": 0,
        "k": [0, 0],
        "ix": 2
      },
      "a": {
        "a": 0,
        "k": [0, 0],
        "ix": 2
      },
      "s": {
        "a": 0,
        "k": [100, 100],
        "ix": 2
      },
      "r": {
        "a": 0,
        "k": 0,
        "ix": 2
      },
      "o": {
        "a": 0,
        "k": 100,
        "ix": 2
      },
      "sk": {
        "a": 0,
        "k": 0,
        "ix": 2
      },
      "sa": {
        "a": 0,
        "k": 0,
        "ix": 2
      }
    },
    "ao": 0,
    "parent": 6,
    "shapes": [{
      "ty": "gr",
      "nm": "Pointer",
      "it": [{
        "ty": "sh",
        "d": 1,
        "ks": {
          "a": 0,
          "k": {
            "c": true,
            "v": [[0, 0.003765621092503116], [2.823142290115356, 0], [1.463816607853733, 3.077310085296631], [0, 0.003765621092503116]],
            "i": [[0, 0.003765621092503116], [2.823142290115356, 0], [1.463816607853733, 3.077310085296631], [0, 0.003765621092503116]],
            "o": [[0, 0.003765621092503116], [2.823142290115356, 0], [1.463816607853733, 3.077310085296631], [0, 0.003765621092503116]]
          }
        },
        "_render": true
      }, {
        "ty": "fl",
        "c": {
          "a": 0,
          "k": [1, 0.2235294117647059, 0],
          "ix": 2
        },
        "o": {
          "a": 0,
          "k": 100,
          "ix": 2
        },
        "r": 1,
        "bm": 0,
        "_render": true
      }, {
        "ty": "tr",
        "p": {
          "a": 0,
          "k": [0.1026153564453125, -6.467464447021484],
          "ix": 2
        },
        "a": {
          "a": 0,
          "k": [1.411571145057678, 1.538655042648315],
          "ix": 2
        },
        "s": {
          "a": 0,
          "k": [100.00000268335543, 100.00000268335545],
          "ix": 2
        },
        "r": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "o": {
          "a": 0,
          "k": 100,
          "ix": 2
        },
        "sk": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "sa": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "_render": true
      }],
      "_render": true
    }],
    "ip": 0,
    "op": 121,
    "st": 0,
    "bm": 0,
    "completed": true
  }, {
    "ddd": 0,
    "ind": 9,
    "ty": 3,
    "nm": "whole lock",
    "sr": 1,
    "ks": {
      "p": {
        "a": 0,
        "k": [-1.2999215126037598, 0.036954134702682495],
        "ix": 2
      },
      "a": {
        "a": 0,
        "k": [0.3954734802246094, 0.814178466796875],
        "ix": 2
      },
      "s": {
        "a": 0,
        "k": [100.00000263138283, 100.00000263138283],
        "ix": 2
      },
      "r": {
        "a": 1,
        "k": [{
          "t": 0,
          "s": [-3.9999994914369403],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          },
          "__fnct": [null]
        }, {
          "t": 25,
          "s": [-3.999999457404809],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          },
          "__fnct": [null]
        }, {
          "t": 35,
          "s": [-3.9999994233726777],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          },
          "__fnct": [null]
        }, {
          "t": 49,
          "s": [-3.999999393121894],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          },
          "__fnct": [null]
        }, {
          "t": 54,
          "s": [-3.9999993772402327],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          },
          "__fnct": [null]
        }, {
          "t": 63,
          "s": [-3.9999993477457187],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          },
          "__fnct": [null]
        }, {
          "t": 67,
          "s": [-3.9999993461430283],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          },
          "__fnct": [null]
        }, {
          "t": 73,
          "s": [-3.9999993425122757],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          },
          "__fnct": [null]
        }, {
          "t": 75,
          "s": [-3.9999993413020247],
          "i": {
            "x": [0.75],
            "y": [0.75]
          },
          "o": {
            "x": [0.25],
            "y": [0.25]
          }
        }],
        "ix": 2
      },
      "o": {
        "a": 0,
        "k": 100,
        "ix": 2
      },
      "sk": {
        "a": 0,
        "k": 0,
        "ix": 2
      },
      "sa": {
        "a": 0,
        "k": 0,
        "ix": 2
      }
    },
    "ao": 0,
    "ip": 0,
    "op": 121,
    "st": 0,
    "bm": 0,
    "parent": 6,
    "completed": true
  }, {
    "ddd": 0,
    "ind": 10,
    "ty": 4,
    "nm": "Code",
    "sr": 1,
    "ks": {
      "p": {
        "a": 0,
        "k": [0, 0],
        "ix": 2
      },
      "a": {
        "a": 0,
        "k": [0, 0],
        "ix": 2
      },
      "s": {
        "a": 0,
        "k": [100, 100],
        "ix": 2
      },
      "r": {
        "a": 0,
        "k": 0,
        "ix": 2
      },
      "o": {
        "a": 0,
        "k": 100,
        "ix": 2
      },
      "sk": {
        "a": 0,
        "k": 0,
        "ix": 2
      },
      "sa": {
        "a": 0,
        "k": 0,
        "ix": 2
      }
    },
    "ao": 0,
    "parent": 9,
    "shapes": [{
      "ty": "gr",
      "it": [{
        "ty": "gr",
        "it": [{
          "ty": "gr",
          "it": [{
            "ty": "gr",
            "nm": "Filled region",
            "it": [{
              "ty": "gr",
              "nm": "Path",
              "it": [{
                "ty": "sh",
                "d": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "c": true,
                    "v": [[8.028193473815918, 6.246461391448975], [7.862060546875, 4.69136381149292], [7.846455097198486, 4.69199275970459], [7.815189361572266, 4.811079978942871], [7.732646465301514, 4.940651893615723], [7.599154949188232, 5.05905294418335], [7.138891220092773, 5.24353551864624], [6.678439140319824, 5.155101299285889], [6.288485527038574, 4.8173508644104], [6.077907562255859, 4.3064470291137695], [6.157443046569824, 3.804280996322632], [6.508584976196289, 3.388547420501709], [7.019496440887451, 3.17797589302063], [7.519125461578369, 3.254009246826172], [7.932322025299072, 3.6016430854797363], [8.12130069732666, 3.994389772415161], [8.216922760009766, 4.487086296081543], [8.396142959594727, 5.9791364669799805], [8.028193473815918, 6.246461391448975]],
                    "i": [[8.028193473815918, 6.246461391448975], [7.862060546875, 4.69136381149292], [7.846455097198486, 4.69199275970459], [7.836653403937817, 4.766931224614382], [7.7685473673045635, 4.896722313016653], [7.650551043450832, 5.0217122957110405], [7.298553958535194, 5.2274774089455605], [6.826383501291275, 5.226082004606724], [6.400510340929031, 4.97153727710247], [6.0977812968194485, 4.481182560324669], [6.0845455303788185, 3.964322865009308], [6.347387984395027, 3.5056613832712173], [6.844758167862892, 3.1978483237326145], [7.359080389142036, 3.181111976504326], [7.8152051866054535, 3.440448224544525], [8.07678747922182, 3.844694286584854], [8.195990545675159, 4.305981248617172], [8.396142959594727, 5.9791364669799805], [8.028193473815918, 6.246461391448975]],
                    "o": [[8.028193473815918, 6.246461391448975], [7.862060546875, 4.69136381149292], [7.847075273224618, 4.7272355034947395], [7.7960615288466215, 4.8535315208137035], [7.695048309862614, 4.982245296239853], [7.451975107192993, 5.165983065962791], [6.979867413640022, 5.255560245364904], [6.530494824051857, 5.0841206684708595], [6.167974039912224, 4.651483744382858], [6.058033933863044, 4.131711646914482], [6.2303406894207, 3.6442392617464066], [6.674454241991043, 3.268038921058178], [7.192537382245064, 3.155767334625125], [7.677472963929176, 3.3245703503489494], [8.013794615864754, 3.7137786597013474], [8.164116598665714, 4.141749143600464], [8.216922760009766, 4.487086296081543], [8.396142959594727, 5.9791364669799805], [8.028193473815918, 6.246461391448975]]
                  }
                },
                "_render": true
              }, {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [7.233832359313965, 4.708329200744629],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [7.233832212784639, 4.708329152215088],
                  "ix": 2
                },
                "s": {
                  "a": 0,
                  "k": [100, 100],
                  "ix": 2
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 2
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "_render": true
              }],
              "_render": true
            }, {
              "ty": "gr",
              "nm": "Path",
              "it": [{
                "ty": "sh",
                "d": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "c": true,
                    "v": [[7.505036354064941, 4.7526535987854], [7.76350736618042, 4.334646224975586], [7.622028827667236, 3.837787628173828], [7.349219799041748, 3.6023175716400146], [7.033016681671143, 3.5429322719573975], [6.715770721435547, 3.6663403511047363], [6.500365734100342, 3.929917573928833], [6.455627918243408, 4.251535892486572], [6.59877872467041, 4.581206321716309], [6.8680830001831055, 4.819222450256348], [7.19033670425415, 4.879565715789795], [7.505036354064941, 4.7526535987854]],
                    "i": [[7.505036354064941, 4.7526535987854], [7.743045633658767, 4.502993121743202], [7.7391456216573715, 3.9989824295043945], [7.453014478087425, 3.6518343836069107], [7.142360411584377, 3.531308245845139], [6.818562984466553, 3.591659002006054], [6.543513037264347, 3.8271834701299667], [6.4406083738431334, 4.1375215500593185], [6.5207008346915245, 4.4737430810928345], [6.766624554991722, 4.768008399754763], [7.079295597970486, 4.88885354436934], [7.404580257833004, 4.82563766092062]],
                    "o": [[7.656888544559479, 4.642328880727291], [7.786305136978626, 4.164602026343346], [7.543950937688351, 3.730324387550354], [7.247761279344559, 3.551103476434946], [6.92431178689003, 3.5505228880792856], [6.6153146252036095, 3.739324413239956], [6.455521106719971, 4.030315548181534], [6.472983689978719, 4.36385290324688], [6.676856569945812, 4.688669502735138], [6.971877671778202, 4.868739169090986], [7.299680434167385, 4.8679416896775365], [7.505036354064941, 4.7526535987854]]
                  }
                },
                "_render": true
              }, {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [7.109527587890625, 4.2107367515563965],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [7.109527437944722, 4.2107365317717225],
                  "ix": 2
                },
                "s": {
                  "a": 0,
                  "k": [100, 100],
                  "ix": 2
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 2
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "_render": true
              }],
              "_render": true
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [1, 1, 1],
                "ix": 2
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 2
              },
              "r": 1,
              "bm": 0,
              "_render": true
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [0, 0],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 2
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 2
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 2
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "_render": true
            }],
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [7.233832359313965, 4.708329200744629],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [7.233832212784639, 4.708329152215088],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "gr",
          "it": [{
            "ty": "gr",
            "nm": "Filled region",
            "it": [{
              "ty": "gr",
              "nm": "Path",
              "it": [{
                "ty": "sh",
                "d": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "c": true,
                    "v": [[3.148048162460327, 13.447731018066406], [2.8735177516937256, 13.914169311523438], [2.4534549713134766, 14.155698776245117], [1.9532523155212402, 14.125252723693848], [1.6313081979751587, 13.938668251037598], [1.4387072324752808, 13.648368835449219], [1.405832290649414, 13.28699779510498], [1.393473744392395, 13.282981872558594], [1.0368534326553345, 13.581561088562012], [0.5670338273048401, 13.583758354187012], [0.19122456014156342, 13.338682174682617], [0.011489860713481903, 12.938702583312988], [0.058420613408088684, 12.44385814666748], [0.311326265335083, 12.015938758850098], [0.6918442249298096, 11.797994613647461], [1.1399354934692383, 11.820618629455566], [1.5187333822250366, 12.098546028137207], [1.6317367553710938, 12.549714088439941], [1.6440951824188232, 12.553729057312012], [1.8817691802978516, 12.284818649291992], [2.209564208984375, 12.159049987792969], [2.5796961784362793, 12.197333335876465], [3.0009241104125977, 12.470829963684082], [3.200125217437744, 12.909014701843262], [3.148048162460327, 13.447731018066406]],
                    "i": [[3.148048162460327, 13.447731018066406], [2.994964435696602, 13.79270713031292], [2.6120501905679703, 14.116141021251678], [2.1262714862823486, 14.18146963045001], [1.7196063324809074, 14.022010706365108], [1.4788097962737083, 13.758559465408325], [1.385792352259159, 13.414082333445549], [1.393473744392395, 13.282981872558594], [1.188032865524292, 13.527448695152998], [0.7263213694095612, 13.635513618588448], [0.28522294759750366, 13.451203152537346], [0.03456810675561428, 13.091942071914673], [0.002201296389102936, 12.616876482963562], [0.1998341679573059, 12.125454023480415], [0.5469113737344742, 11.83288274332881], [0.9833944141864777, 11.769755735993385], [1.4254888817667961, 11.965016186237335], [1.6468995288014412, 12.381573423743248], [1.6440951824188232, 12.553729057312012], [1.7818086221814156, 12.349500387907028], [2.089140824973583, 12.174575229175389], [2.45336477458477, 12.156286086887121], [2.8931248039007187, 12.344715937972069], [3.1732697747647762, 12.739366605877876], [3.2105140686035156, 13.25548841059208]],
                    "o": [[3.0864746160805225, 13.637227326631546], [2.7520710676908493, 14.035631492733955], [2.293005794286728, 14.191617917269468], [1.8269209116697311, 14.084205474704504], [1.5430101454257965, 13.85532584041357], [1.3967507481575012, 13.53453952819109], [1.405832290649414, 13.28699779510498], [1.306906335055828, 13.427921995520592], [0.8829277753829956, 13.634781166911125], [0.41049274802207947, 13.53289546072483], [0.09447970986366272, 13.225268840789795], [-0.01344231516122818, 12.781824454665184], [0.11553231254220009, 12.268093436956406], [0.4200720340013504, 11.905531257390976], [0.8340305835008621, 11.762214187532663], [1.2992230355739594, 11.872373893857002], [1.6092316284775734, 12.231183663010597], [1.6317367553710938, 12.549714088439941], [1.7025838159024715, 12.439137168228626], [1.9798757955431938, 12.21649830788374], [2.3299876749515533, 12.143524774350226], [2.7527153491973877, 12.253550242632627], [3.1068695038557053, 12.593305215239525], [3.2278730161488056, 13.075916513800621], [3.148048162460327, 13.447731018066406]]
                  }
                },
                "_render": true
              }, {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [1.6064635515213013, 12.976266860961914],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [1.6064635910960534, 12.976267157506904],
                  "ix": 2
                },
                "s": {
                  "a": 0,
                  "k": [100, 100],
                  "ix": 2
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 2
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "_render": true
              }],
              "_render": true
            }, {
              "ty": "gr",
              "nm": "Path",
              "it": [{
                "ty": "sh",
                "d": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "c": true,
                    "v": [[2.81436824798584, 13.339313507080078], [2.801156520843506, 12.86136245727539], [2.4509875774383545, 12.565410614013672], [1.9937338829040527, 12.599017143249512], [1.697982907295227, 12.976580619812012], [1.715314269065857, 13.455869674682617], [2.065483570098877, 13.751821517944336], [2.5227370262145996, 13.718214988708496], [2.81436824798584, 13.339313507080078]],
                    "i": [[2.81436824798584, 13.339313507080078], [2.867076136171818, 13.004231631755829], [2.61576771736145, 12.61895051971078], [2.1310431212186813, 12.522180430591106], [1.7550946064293385, 12.800815910100937], [1.646648369729519, 13.312108129262924], [1.8979570865631104, 13.697389278560877], [2.382681429386139, 13.794159322977066], [2.7572565637528896, 13.51507817208767]],
                    "o": [[2.8714799471199512, 13.163548797369003], [2.7324905693531036, 12.717600852251053], [2.283461093902588, 12.510978374630213], [1.853678360581398, 12.67496145516634], [1.6408712230622768, 13.152345284819603], [1.7812338694930077, 13.598738893866539], [2.2302637100219727, 13.805361423641443], [2.660046249628067, 13.641378313302994], [2.81436824798584, 13.339313507080078]]
                  }
                },
                "_render": true
              }, {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [2.2566096782684326, 13.15829086303711],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [2.2566097748708063, 13.15829131606122],
                  "ix": 2
                },
                "s": {
                  "a": 0,
                  "k": [100, 100],
                  "ix": 2
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 2
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "_render": true
              }],
              "_render": true
            }, {
              "ty": "gr",
              "nm": "Path",
              "it": [{
                "ty": "sh",
                "d": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "c": true,
                    "v": [[1.3684226274490356, 12.869500160217285], [1.3529490232467651, 12.45457649230957], [1.0441826581954956, 12.199402809143066], [0.6443943381309509, 12.22435474395752], [0.3879809081554413, 12.55093765258789], [0.40345439314842224, 12.965862274169922], [0.7122208476066589, 13.22103500366211], [1.1120091676712036, 13.196084022521973], [1.3684226274490356, 12.869500160217285]],
                    "i": [[1.3684226274490356, 12.869500160217285], [1.4132374785840511, 12.57739844918251], [1.1897383630275726, 12.24669636413455], [0.765363983809948, 12.160426668822765], [0.437953632324934, 12.397143572568893], [0.3440582938492298, 12.840294033288956], [0.5666649639606476, 13.173741392791271], [0.9910394474864006, 13.260012030601501], [1.3193422593176365, 13.020547956228256]],
                    "o": [[1.4183953516185284, 12.715706080198288], [1.2926604822278023, 12.331754513084888], [0.8986267745494843, 12.152109198272228], [0.5234246924519539, 12.288282819092274], [0.33890054002404213, 12.701985448598862], [0.46374286338686943, 13.088684186339378], [0.857776552438736, 13.268328558653593], [1.2338711693882942, 13.129409655928612], [1.3684226274490356, 12.869500160217285]]
                  }
                },
                "_render": true
              }, {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [0.8785334229469299, 12.710219383239746],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [0.8785333985257092, 12.710219069505115],
                  "ix": 2
                },
                "s": {
                  "a": 0,
                  "k": [100, 100],
                  "ix": 2
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 2
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "_render": true
              }],
              "_render": true
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [1, 1, 1],
                "ix": 2
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 2
              },
              "r": 1,
              "bm": 0,
              "_render": true
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [0, 0],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 2
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 2
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 2
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "_render": true
            }],
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [1.6064635515213013, 12.976266860961914],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [1.6064635910960534, 12.976267157506904],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "gr",
          "nm": "Filled region",
          "it": [{
            "ty": "sh",
            "d": 1,
            "ks": {
              "a": 0,
              "k": {
                "c": true,
                "v": [[3.518833637237549, 22.259477615356445], [0.5013845562934875, 22.055774688720703], [0.8734949231147766, 23.200992584228516], [1.3595950603485107, 23.043046951293945], [1.480062484741211, 23.413801193237305], [0.6561636328697205, 23.681507110595703], [0.03508734330534935, 21.770061492919922], [0.3811247646808624, 21.657625198364258], [3.387657880783081, 21.85576629638672], [3.518833637237549, 22.259477615356445]],
                "i": [[3.518833637237549, 22.259477615356445], [0.5013845562934875, 22.055774688720703], [0.8734949231147766, 23.200992584228516], [1.3595950603485107, 23.043046951293945], [1.480062484741211, 23.413801193237305], [0.6561636328697205, 23.681507110595703], [0.03508734330534935, 21.770061492919922], [0.3811247646808624, 21.657625198364258], [3.387657880783081, 21.85576629638672], [3.518833637237549, 22.259477615356445]],
                "o": [[3.518833637237549, 22.259477615356445], [0.5013845562934875, 22.055774688720703], [0.8734949231147766, 23.200992584228516], [1.3595950603485107, 23.043046951293945], [1.480062484741211, 23.413801193237305], [0.6561636328697205, 23.681507110595703], [0.03508734330534935, 21.770061492919922], [0.3811247646808624, 21.657625198364258], [3.387657880783081, 21.85576629638672], [3.518833637237549, 22.259477615356445]]
              }
            },
            "_render": true
          }, {
            "ty": "fl",
            "c": {
              "a": 0,
              "k": [1, 1, 1],
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "r": 1,
            "bm": 0,
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [1.7769604921340942, 22.669567108154297],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [1.776960490271449, 22.66956615447998],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "gr",
          "it": [{
            "ty": "gr",
            "nm": "Filled region",
            "it": [{
              "ty": "gr",
              "nm": "Path",
              "it": [{
                "ty": "sh",
                "d": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "c": true,
                    "v": [[8.584076881408691, 29.142776489257812], [8.94477367401123, 29.560096740722656], [9.026854515075684, 30.058759689331055], [8.821369171142578, 30.562654495239258], [8.508782386779785, 30.86024284362793], [8.067194938659668, 31.1069393157959], [6.703527450561523, 31.73845672607422], [6.353099346160889, 31.483861923217773], [7.780773639678955, 30.845306396484375], [7.775352954864502, 30.83066177368164], [7.572489261627197, 30.822479248046875], [7.349831581115723, 30.70889663696289], [7.027681827545166, 30.319581985473633], [6.959946155548096, 29.852758407592773], [7.157164096832275, 29.374980926513672], [7.577999114990234, 29.016834259033203], [8.08017349243164, 28.93729591369629], [8.584076881408691, 29.142776489257812]],
                    "i": [[8.584076881408691, 29.142776489257812], [8.867842547595501, 29.400693774223328], [9.045030841603875, 29.88636040687561], [8.938485987484455, 30.401459649205208], [8.63570100069046, 30.773986473679543], [8.232970789074898, 31.031067073345184], [6.703527450561523, 31.73845672607422], [6.353099346160889, 31.483861923217773], [7.780773639678955, 30.845306396484375], [7.775352954864502, 30.83066177368164], [7.64850626885891, 30.845583723858], [7.422253370285034, 30.761513020843267], [7.090595863759518, 30.468801096081734], [6.938155934214592, 30.015393391251564], [7.04513930529356, 29.52916730940342], [7.416256904602051, 29.092067703604698], [7.905435174703598, 28.91742355003953], [8.420543760061264, 29.023965261876583]],
                    "o": [[8.747610077261925, 29.261587768793106], [9.0176712423563, 29.720138534903526], [9.006980825215578, 30.233495146036148], [8.739896550774574, 30.674790106713772], [8.38016639649868, 30.948835402727127], [8.067194938659668, 31.1069393157959], [6.703527450561523, 31.73845672607422], [6.353099346160889, 31.483861923217773], [7.780773639678955, 30.845306396484375], [7.716127637773752, 30.84831145964563], [7.496472284197807, 30.799374792724848], [7.197979390621185, 30.59857191890478], [6.9607342928647995, 30.171001613140106], [6.97940019890666, 29.68842601776123], [7.275978289544582, 29.21144989132881], [7.738044127821922, 28.943937063217163], [8.25257559120655, 28.95547094196081], [8.584076881408691, 29.142776489257812]]
                  }
                },
                "_render": true
              }, {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [7.692697525024414, 30.334684371948242],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [7.6926976768271995, 30.33468370880862],
                  "ix": 2
                },
                "s": {
                  "a": 0,
                  "k": [100, 100],
                  "ix": 2
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 2
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "_render": true
              }],
              "_render": true
            }, {
              "ty": "gr",
              "nm": "Path",
              "it": [{
                "ty": "sh",
                "d": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "c": true,
                    "v": [[8.383899688720703, 29.425661087036133], [8.069199562072754, 29.298748016357422], [7.750450611114502, 29.36163902282715], [7.477641582489014, 29.59710693359375], [7.337995529174805, 29.929325103759766], [7.3792290687561035, 30.248395919799805], [7.594634056091309, 30.511974334716797], [7.911879539489746, 30.6353816986084], [8.231587409973145, 30.578542709350586], [8.50089168548584, 30.340526580810547], [8.644042015075684, 30.01085662841797], [8.601850509643555, 29.685733795166016], [8.383899688720703, 29.425661087036133]],
                    "i": [[8.383899688720703, 29.425661087036133], [8.176207147538662, 29.3086747424677], [7.851909101009369, 29.310424976050854], [7.555719472467899, 29.489643692970276], [7.353015061467886, 29.81531085073948], [7.334384441375732, 30.147997945547104], [7.491841793060303, 30.437292985618114], [7.800838433206081, 30.626093870028853], [8.127792738378048, 30.628059428185225], [8.422813765704632, 30.447989858686924], [8.626686291769147, 30.12317357212305], [8.644997775554657, 29.788467951118946], [8.48435578495264, 29.498645149171352]],
                    "o": [[8.281107425689697, 29.35097973793745], [7.95815847069025, 29.289460169151425], [7.646655976772308, 29.41115576773882], [7.399563662707806, 29.704570211470127], [7.320639839395881, 30.04164207726717], [7.420040164142847, 30.349432811141014], [7.695090152323246, 30.584958396852016], [8.02122326940298, 30.647005724720657], [8.333045855164528, 30.527328658849], [8.578969575464725, 30.233063340187073], [8.6590615240857, 29.8968423306942], [8.557005897164345, 29.585335798561573], [8.383899688720703, 29.425661087036133]]
                  }
                },
                "_render": true
              }, {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [7.99029541015625, 29.967653274536133],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [7.990295432587681, 29.967653020169138],
                  "ix": 2
                },
                "s": {
                  "a": 0,
                  "k": [100, 100],
                  "ix": 2
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 2
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "_render": true
              }],
              "_render": true
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [1, 1, 1],
                "ix": 2
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 2
              },
              "r": 1,
              "bm": 0,
              "_render": true
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [0, 0],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 2
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 2
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 2
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "_render": true
            }],
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [7.692697525024414, 30.334684371948242],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [7.6926976768271995, 30.33468370880862],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "gr",
          "it": [{
            "ty": "gr",
            "nm": "Filled region",
            "it": [{
              "ty": "gr",
              "nm": "Path",
              "it": [{
                "ty": "sh",
                "d": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "c": true,
                    "v": [[17.3137264251709, 3.2486236095428467], [16.80693817138672, 3.136004686355591], [16.477739334106445, 2.8111422061920166], [16.36077880859375, 2.3173515796661377], [16.360754013061523, 0.931272029876709], [16.477697372436523, 0.437481164932251], [16.806884765625, 0.11695027351379395], [17.31366729736328, 0], [17.82045555114746, 0.11695027351379395], [18.149654388427734, 0.437481164932251], [18.26661491394043, 0.931272029876709], [18.266639709472656, 2.3173515796661377], [18.14969825744629, 2.8111422061920166], [17.816177368164062, 3.136004686355591], [17.3137264251709, 3.2486236095428467]],
                    "i": [[17.3137264251709, 3.2486236095428467], [16.95132277905941, 3.2110839933156967], [16.555708773434162, 2.949750155210495], [16.360782174414453, 2.5050498694181442], [16.360754013061523, 0.931272029876709], [16.399732887744904, 0.5760892182588577], [16.665390476584435, 0.19202964007854462], [17.12019370496273, 2.0372983685509466e-17], [17.67895856499672, 0.03898344933986664], [18.071684904396534, 0.29887329041957855], [18.266611496339237, 0.7406861484050751], [18.266639709472656, 2.3173515796661377], [18.227662712335587, 2.6696466207504272], [17.960559278726578, 3.058037720620632], [17.50720001757145, 3.2486236095428467]],
                    "o": [[17.120252832770348, 3.2486236095428467], [16.665441140532494, 3.058037720620632], [16.399769820272923, 2.6696466207504272], [16.36077880859375, 2.3173515796661377], [16.36075059546033, 0.7406861484050751], [16.5556618347764, 0.29887329041957855], [16.95126663148403, 0.03898344933986664], [17.51002860069275, -2.067706189612886e-17], [17.961952477693558, 0.19202964007854462], [18.227623872458935, 0.5760892182588577], [18.26661491394043, 0.931272029876709], [18.26664307529336, 2.5050498694181442], [18.071733750402927, 2.949750155210495], [17.67468312382698, 3.2110839933156967], [17.3137264251709, 3.2486236095428467]]
                  }
                },
                "_render": true
              }, {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [17.313695907592773, 1.6243118047714233],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [17.313696861263722, 1.6243118047714233],
                  "ix": 2
                },
                "s": {
                  "a": 0,
                  "k": [100, 100],
                  "ix": 2
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 2
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "_render": true
              }],
              "_render": true
            }, {
              "ty": "gr",
              "nm": "Path",
              "it": [{
                "ty": "sh",
                "d": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "c": true,
                    "v": [[17.313720703125, 2.9150984287261963], [17.729541778564453, 2.7505013942718506], [17.889799118041992, 2.3173515796661377], [17.889774322509766, 0.931272029876709], [17.72949981689453, 0.5024538040161133], [17.31367301940918, 0.3335251808166504], [16.893522262573242, 0.5024538040161133], [16.737594604492188, 0.931272029876709], [16.737619400024414, 2.3173515796661377], [16.89356231689453, 2.7505013942718506], [17.313720703125, 2.9150984287261963]],
                    "i": [[17.313720703125, 2.9150984287261963], [17.62558775395155, 2.860232688486576], [17.889802276735054, 2.4934991896152496], [17.889774322509766, 0.931272029876709], [17.83634540438652, 0.6121850535273552], [17.486932948231697, 0.3335251808166504], [17.000363864004612, 0.3898347541689873], [16.737591445800035, 0.7551244646310806], [16.737619400024414, 2.3173515796661377], [16.78960434347391, 2.637882426381111], [17.140460774302483, 2.9150984287261963]],
                    "o": [[17.486980631947517, 2.9150984287261963], [17.836383379995823, 2.637882426381111], [17.889799118041992, 2.3173515796661377], [17.889771163817613, 0.7551244646310806], [17.62554180622101, 0.3898347541689873], [17.140413090586662, 0.3335251808166504], [16.78956827521324, 0.6121850535273552], [16.737594604492188, 0.931272029876709], [16.737622558717476, 2.4934991896152496], [17.00040790438652, 2.860232688486576], [17.313720703125, 2.9150984287261963]]
                  }
                },
                "_render": true
              }, {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [17.313695907592773, 1.6243118047714233],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [17.313696861265147, 1.6243118047714233],
                  "ix": 2
                },
                "s": {
                  "a": 0,
                  "k": [100, 100],
                  "ix": 2
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 2
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "_render": true
              }],
              "_render": true
            }, {
              "ty": "gr",
              "nm": "Path",
              "it": [{
                "ty": "sh",
                "d": 1,
                "ks": {
                  "a": 0,
                  "k": {
                    "c": true,
                    "v": [[17.313701629638672, 1.862544298171997], [17.12311363220215, 1.7975716590881348], [17.05380630493164, 1.6113171577453613], [17.12310791015625, 1.4337258338928223], [17.313692092895508, 1.368753433227539], [17.499948501586914, 1.4337258338928223], [17.57358741760254, 1.6113171577453613], [17.499954223632812, 1.7975716590881348], [17.313701629638672, 1.862544298171997]],
                    "i": [[17.313701629638672, 1.862544298171997], [17.172204691916704, 1.8408866859972477], [17.053807754824675, 1.6921718642115593], [17.076905980706215, 1.474153146147728], [17.235725097358227, 1.368753433227539], [17.4537450671196, 1.3904108069837093], [17.573586019493746, 1.5333502516150475], [17.549043726176023, 1.7542567178606987], [17.391668625175953, 1.862544298171997]],
                    "o": [[17.23573463410139, 1.862544298171997], [17.076910197734833, 1.7542567178606987], [17.053804906822847, 1.5333502516150475], [17.17219741269946, 1.3904108069837093], [17.39165908843279, 1.368753433227539], [17.549039509147406, 1.474153146147728], [17.573588867495573, 1.6921718642115593], [17.45375234633684, 1.8408866859972477], [17.313701629638672, 1.862544298171997]]
                  }
                },
                "_render": true
              }, {
                "ty": "tr",
                "p": {
                  "a": 0,
                  "k": [17.313697814941406, 1.615648865699768],
                  "ix": 2
                },
                "a": {
                  "a": 0,
                  "k": [17.313696861267477, 1.615648865699768],
                  "ix": 2
                },
                "s": {
                  "a": 0,
                  "k": [100, 100],
                  "ix": 2
                },
                "r": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "o": {
                  "a": 0,
                  "k": 100,
                  "ix": 2
                },
                "sk": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "sa": {
                  "a": 0,
                  "k": 0,
                  "ix": 2
                },
                "_render": true
              }],
              "_render": true
            }, {
              "ty": "fl",
              "c": {
                "a": 0,
                "k": [1, 1, 1],
                "ix": 2
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 2
              },
              "r": 1,
              "bm": 0,
              "_render": true
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [0, 0],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [0, 0],
                "ix": 2
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 2
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 2
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "_render": true
            }],
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [17.313695907592773, 1.6243118047714233],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [17.313696861263722, 1.6243118047714233],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "gr",
          "nm": "Filled region",
          "it": [{
            "ty": "sh",
            "d": 1,
            "ks": {
              "a": 0,
              "k": {
                "c": true,
                "v": [[17.55527114868164, 31.836397171020508], [18.248315811157227, 32.07896041870117], [18.50388526916504, 32.74601364135742], [18.114049911499023, 32.74601364135742], [17.962440490722656, 32.33451843261719], [17.550945281982422, 32.182918548583984], [17.139455795288086, 32.33451843261719], [16.98786163330078, 32.74601364135742], [16.987865447998047, 32.9409294128418], [17.135143280029297, 33.352420806884766], [17.53364372253418, 33.504024505615234], [18.395610809326172, 33.504024505615234], [18.395639419555664, 35.04170608520508], [16.71068572998047, 35.04170608520508], [16.71068000793457, 34.6865234375], [18.031787872314453, 34.6865234375], [18.023109436035156, 33.85920715332031], [17.511991500854492, 33.85920715332031], [16.836275100708008, 33.616641998291016], [16.59803009033203, 32.9409294128418], [16.598026275634766, 32.74601364135742], [16.8579044342041, 32.07896041870117], [17.55527114868164, 31.836397171020508]],
                "i": [[17.55527114868164, 31.836397171020508], [18.07794064283371, 31.917251139879227], [18.50388024632639, 32.465910106897354], [18.114049911499023, 32.74601364135742], [18.063510581851006, 32.43558671325445], [17.72420521080494, 32.182918548583984], [17.240522265434265, 32.23345012962818], [16.987858526390028, 32.572753712534904], [16.987865447998047, 32.9409294128418], [17.036960907280445, 33.2513525262475], [17.36615912616253, 33.504024505615234], [18.395610809326172, 33.504024505615234], [18.395639419555664, 35.04170608520508], [16.71068572998047, 35.04170608520508], [16.71068000793457, 34.6865234375], [18.031787872314453, 34.6865234375], [18.023109436035156, 33.85920715332031], [17.511991500854492, 33.85920715332031], [16.995099544525146, 33.77835124731064], [16.598035320299005, 33.23258364200592], [16.598026275634766, 32.74601364135742], [16.684647366404533, 32.24355736374855], [17.26072919368744, 31.836397171020508]],
                "o": [[17.84692534804344, 31.836397171020508], [18.418691024184227, 32.24355736374855], [18.50388526916504, 32.74601364135742], [18.11404680458827, 32.572753712534904], [17.861370354890823, 32.23345012962818], [17.377685353159904, 32.182918548583984], [17.038389325141907, 32.43558671325445], [16.98786163330078, 32.74601364135742], [16.9878685549088, 33.114189341664314], [17.233325742185116, 33.453489169478416], [17.53364372253418, 33.504024505615234], [18.395610809326172, 33.504024505615234], [18.395639419555664, 35.04170608520508], [16.71068572998047, 35.04170608520508], [16.71068000793457, 34.6865234375], [18.031787872314453, 34.6865234375], [18.023109436035156, 33.85920715332031], [17.22033727169037, 33.85920715332031], [16.67745055258274, 33.457820385694504], [16.59803009033203, 32.9409294128418], [16.598021252796116, 32.465910106897354], [17.02827374637127, 31.917251139879227], [17.55527114868164, 31.836397171020508]]
              }
            },
            "_render": true
          }, {
            "ty": "fl",
            "c": {
              "a": 0,
              "k": [1, 1, 1],
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "r": 1,
            "bm": 0,
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [17.550954818725586, 33.43905258178711],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [17.550955772290692, 33.43905162811279],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "gr",
          "nm": "Filled region",
          "it": [{
            "ty": "sh",
            "d": 1,
            "ks": {
              "a": 0,
              "k": {
                "c": true,
                "v": [[26.128232955932617, 29.189237594604492], [26.53559684753418, 29.749916076660156], [27.69200897216797, 28.909751892089844], [28.050996780395508, 29.40384864807129], [28.21109962463379, 31.584388732910156], [27.85366439819336, 31.84407615661621], [27.6846923828125, 29.56290054321289], [27.585397720336914, 29.42623519897461], [26.744369506835938, 30.037263870239258], [27.197561264038086, 30.66101837158203], [26.88217544555664, 30.890153884887695], [25.812847137451172, 29.41837501525879], [26.128232955932617, 29.189237594604492]],
                "i": [[26.128232955932617, 29.189237594604492], [26.53559684753418, 29.749916076660156], [27.69200897216797, 28.909751892089844], [28.050996780395508, 29.40384864807129], [28.21109962463379, 31.584388732910156], [27.85366439819336, 31.84407615661621], [27.6846923828125, 29.56290054321289], [27.585397720336914, 29.42623519897461], [26.744369506835938, 30.037263870239258], [27.197561264038086, 30.66101837158203], [26.88217544555664, 30.890153884887695], [25.812847137451172, 29.41837501525879], [26.128232955932617, 29.189237594604492]],
                "o": [[26.128232955932617, 29.189237594604492], [26.53559684753418, 29.749916076660156], [27.69200897216797, 28.909751892089844], [28.050996780395508, 29.40384864807129], [28.21109962463379, 31.584388732910156], [27.85366439819336, 31.84407615661621], [27.6846923828125, 29.56290054321289], [27.585397720336914, 29.42623519897461], [26.744369506835938, 30.037263870239258], [27.197561264038086, 30.66101837158203], [26.88217544555664, 30.890153884887695], [25.812847137451172, 29.41837501525879], [26.128232955932617, 29.189237594604492]]
              }
            },
            "_render": true
          }, {
            "ty": "fl",
            "c": {
              "a": 0,
              "k": [1, 1, 1],
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "r": 1,
            "bm": 0,
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [27.011974334716797, 30.376914978027344],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [27.01197338104248, 30.376914024353027],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "gr",
          "nm": "Filled region",
          "it": [{
            "ty": "sh",
            "d": 1,
            "ks": {
              "a": 0,
              "k": {
                "c": true,
                "v": [[31.21969223022461, 21.70640754699707], [31.664554595947266, 21.12224578857422], [32.377933502197266, 21.085325241088867], [32.25746154785156, 21.456079483032227], [31.819259643554688, 21.47310447692871], [31.547914505004883, 21.817607879638672], [31.56493377685547, 22.25580596923828], [31.90943717956543, 22.527145385742188], [32.115413665771484, 22.594070434570312], [32.55361557006836, 22.577045440673828], [32.8249626159668, 22.232542037963867], [32.93070602416992, 21.907102584838867], [33.25202941894531, 22.011505126953125], [33.79513168334961, 23.00320816040039], [34.19669723510742, 21.767362594604492], [34.53449630737305, 21.877119064331055], [33.99639892578125, 23.533151626586914], [33.650360107421875, 23.420717239379883], [33.040618896484375, 22.311721801757812], [33.1518440246582, 22.34786033630371], [32.704200744628906, 22.926565170288086], [31.994943618774414, 22.964824676513672], [31.78896713256836, 22.897899627685547], [31.23487663269043, 22.44460105895996], [31.21969223022461, 21.70640754699707]],
                "i": [[31.21969223022461, 21.70640754699707], [31.458109959959984, 21.234308272600174], [32.11153897643089, 20.99876906722784], [32.25746154785156, 21.456079483032227], [31.9466143399477, 21.408214777708054], [31.601456731557846, 21.652828440070152], [31.500044971704483, 22.12845304608345], [31.744657039642334, 22.47360548004508], [32.115413665771484, 22.594070434570312], [32.42626079916954, 22.641935110092163], [32.771420400589705, 22.397321432828903], [32.93070602416992, 21.907102584838867], [33.25202941894531, 22.011505126953125], [33.79513168334961, 23.00320816040039], [34.19669723510742, 21.767362594604492], [34.53449630737305, 21.877119064331055], [33.99639892578125, 23.533151626586914], [33.650360107421875, 23.420717239379883], [33.040618896484375, 22.311721801757812], [33.1518440246582, 22.34786033630371], [32.91249932348728, 22.818141236901283], [32.26133817434311, 23.05138085782528], [31.78896713256836, 22.897899627685547], [31.33787553012371, 22.660243451595306], [31.128670446574688, 21.986532598733902]],
                "o": [[31.309821613132954, 21.429028928279877], [31.87374557554722, 21.011075608432293], [32.377933502197266, 21.085325241088867], [32.09268140792847, 21.40253957733512], [31.691904932260513, 21.537994168698788], [31.49437228962779, 21.982387274503708], [31.629822559654713, 22.38315887749195], [31.90943717956543, 22.527145385742188], [32.28019380569458, 22.64761034026742], [32.68097026646137, 22.51215574145317], [32.8249626159668, 22.232542037963867], [32.93070602416992, 21.907102584838867], [33.25202941894531, 22.011505126953125], [33.79513168334961, 23.00320816040039], [34.19669723510742, 21.767362594604492], [34.53449630737305, 21.877119064331055], [33.99639892578125, 23.533151626586914], [33.650360107421875, 23.420717239379883], [33.040618896484375, 22.311721801757812], [33.06171464920044, 22.625238925218582], [32.49775603413582, 23.038627676665783], [31.994943618774414, 22.964824676513672], [31.522572606801987, 22.81134345382452], [31.13373166322708, 22.232597440481186], [31.21969223022461, 21.70640754699707]]
              }
            },
            "_render": true
          }, {
            "ty": "fl",
            "c": {
              "a": 0,
              "k": [1, 1, 1],
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "r": 1,
            "bm": 0,
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [32.84476089477539, 22.280820846557617],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [32.844759120432386, 22.280820385844557],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "gr",
          "nm": "Filled region",
          "it": [{
            "ty": "sh",
            "d": 1,
            "ks": {
              "a": 0,
              "k": {
                "c": true,
                "v": [[30.906309127807617, 12.298346519470215], [31.248228073120117, 12.187248229980469], [32.64455795288086, 12.840269088745117], [33.156898498535156, 13.01537799835205], [33.54062271118164, 12.990893363952637], [33.88512420654297, 12.719551086425781], [33.90894317626953, 12.288251876831055], [33.626686096191406, 11.938185691833496], [33.17612838745117, 11.925179481506348], [33.055660247802734, 11.554425239562988], [33.56543731689453, 11.52541732788086], [33.97746658325195, 11.742229461669922], [34.238502502441406, 12.181169509887695], [34.28800582885742, 12.697952270507812], [34.08488845825195, 13.110084533691406], [33.659645080566406, 13.371225357055664], [33.167686462402344, 13.398998260498047], [32.50231170654297, 13.173416137695312], [31.3900089263916, 12.637611389160156], [31.83439826965332, 14.00528335571289], [31.496599197387695, 14.115042686462402], [30.906309127807617, 12.298346519470215]],
                "i": [[30.906309127807617, 12.298346519470215], [31.248228073120117, 12.187248229980469], [32.64455795288086, 12.840269088745117], [33.0164283066988, 12.994222227483988], [33.425276808440685, 13.028372123837471], [33.820235051214695, 12.8469048589468], [33.96159189194441, 12.450285345315933], [33.76042492687702, 12.004036597907543], [33.34640075266361, 11.869853746145964], [33.055660247802734, 11.554425239562988], [33.408627569675446, 11.49135297164321], [33.86233675479889, 11.630860440433025], [34.17960734292865, 11.999911770224571], [34.3156850989908, 12.540181040763855], [34.19261872023344, 12.993100792169571], [33.83815664052963, 13.313222497701645], [33.35285171866417, 13.426885416731238], [32.76161962747574, 13.29866361618042], [31.3900089263916, 12.637611389160156], [31.83439826965332, 14.00528335571289], [31.496599197387695, 14.115042686462402], [30.906309127807617, 12.298346519470215]],
                "o": [[30.906309127807617, 12.298346519470215], [31.248228073120117, 12.187248229980469], [32.84564697742462, 12.935852907598019], [33.297368720173836, 13.036533845588565], [33.70540247857571, 12.937352307140827], [33.953652158379555, 12.594051212072372], [33.85450978204608, 12.120725810527802], [33.49658592045307, 11.87418881803751], [33.17612838745117, 11.925179481506348], [33.2387026399374, 11.50102274492383], [33.72499318420887, 11.55858937650919], [34.09259624034166, 11.85359850525856], [34.29918238148093, 12.367919966578484], [34.26032639667392, 12.855723544955254], [33.97990445792675, 13.226175859570503], [33.5168359875679, 13.417627591639757], [32.98341354727745, 13.373857397586107], [32.50231170654297, 13.173416137695312], [31.3900089263916, 12.637611389160156], [31.83439826965332, 14.00528335571289], [31.496599197387695, 14.115042686462402], [30.906309127807617, 12.298346519470215]]
              }
            },
            "_render": true
          }, {
            "ty": "fl",
            "c": {
              "a": 0,
              "k": [1, 1, 1],
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "r": 1,
            "bm": 0,
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [32.603660583496094, 12.810279846191406],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [32.603660275974406, 12.810280238859221],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "gr",
          "nm": "Filled region",
          "it": [{
            "ty": "sh",
            "d": 1,
            "ks": {
              "a": 0,
              "k": {
                "c": true,
                "v": [[25.21958351135254, 5.328159809112549], [25.428356170654297, 5.0408124923706055], [26.122203826904297, 5.5449113845825195], [27.573434829711914, 3.547496795654297], [26.502775192260742, 3.5620245933532715], [26.765016555786133, 3.2010881900787354], [27.656381607055664, 3.1901497840881348], [28.0874080657959, 3.5033023357391357], [26.437589645385742, 5.774047374725342], [27.00528335571289, 6.186491966247559], [26.7965087890625, 6.473839282989502], [25.21958351135254, 5.328159809112549]],
                "i": [[25.21958351135254, 5.328159809112549], [25.428356170654297, 5.0408124923706055], [26.122203826904297, 5.5449113845825195], [27.573434829711914, 3.547496795654297], [26.502775192260742, 3.5620245933532715], [26.765016555786133, 3.2010881900787354], [27.656381607055664, 3.1901497840881348], [28.0874080657959, 3.5033023357391357], [26.437589645385742, 5.774047374725342], [27.00528335571289, 6.186491966247559], [26.7965087890625, 6.473839282989502], [25.21958351135254, 5.328159809112549]],
                "o": [[25.21958351135254, 5.328159809112549], [25.428356170654297, 5.0408124923706055], [26.122203826904297, 5.5449113845825195], [27.573434829711914, 3.547496795654297], [26.502775192260742, 3.5620245933532715], [26.765016555786133, 3.2010881900787354], [27.656381607055664, 3.1901497840881348], [28.0874080657959, 3.5033023357391357], [26.437589645385742, 5.774047374725342], [27.00528335571289, 6.186491966247559], [26.7965087890625, 6.473839282989502], [25.21958351135254, 5.328159809112549]]
              }
            },
            "_render": true
          }, {
            "ty": "fl",
            "c": {
              "a": 0,
              "k": [1, 1, 1],
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "r": 1,
            "bm": 0,
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [26.65349578857422, 4.831994533538818],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [26.65349578857422, 4.831994533538818],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "tr",
          "p": {
            "a": 0,
            "k": [60.562744140625, 83.6688003540039],
            "ix": 2
          },
          "a": {
            "a": 0,
            "k": [17.267248153686523, 17.52085304260254],
            "ix": 2
          },
          "s": {
            "a": 0,
            "k": [109.14504528045654, 109.14504528045654],
            "ix": 2
          },
          "r": {
            "a": 0,
            "k": -2.172794366275684e-7,
            "ix": 2
          },
          "o": {
            "a": 0,
            "k": 100,
            "ix": 2
          },
          "sk": {
            "a": 0,
            "k": 0,
            "ix": 2
          },
          "sa": {
            "a": 0,
            "k": 0,
            "ix": 2
          },
          "_render": true
        }],
        "_render": true
      }, {
        "ty": "gr",
        "it": [{
          "ty": "gr",
          "nm": "Vector",
          "it": [{
            "ty": "sh",
            "d": 1,
            "ks": {
              "a": 0,
              "k": {
                "c": true,
                "v": [[0.647433311739829, 0], [1.2956955432891846, 0.647433340549469], [0.647433311739829, 1.294866681098938], [0, 0.647433340549469], [0.647433311739829, 0]],
                "i": [[0.647433311739829, 0], [1.2956955432891846, 0.290142995353382], [1.0055526349632316, 1.294866681098938], [0, 1.0055526797085497], [0.2893139885164264, 0]],
                "o": [[1.0055526349632316, 0], [1.2956955432891846, 1.0055526797085497], [0.2893139885164264, 1.294866681098938], [0, 0.290142995353382], [0.647433311739829, 0]]
              }
            },
            "_render": true
          }, {
            "ty": "fl",
            "c": {
              "a": 0,
              "k": [1, 1, 1],
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "r": 1,
            "bm": 0,
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [197.82676696777344, 178.24118041992188],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [0.6478477716445923, 0.647433340549469],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, -100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 180,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": -180,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "gr",
          "nm": "Vector",
          "it": [{
            "ty": "sh",
            "d": 1,
            "ks": {
              "a": 0,
              "k": {
                "c": true,
                "v": [[0.6482623219490051, 0], [1.2965246438980103, 0.647433340549469], [0.6482623219490051, 1.294866681098938], [0, 0.647433340549469], [0.6482623219490051, 0]],
                "i": [[0.6482623219490051, 0], [1.2965246438980103, 0.290142995353382], [1.0063816678157254, 1.294866681098938], [0, 1.0055526797085497], [0.2901429760822849, 0]],
                "o": [[1.0063816678157254, 0], [1.2965246438980103, 1.0055526797085497], [0.2901429760822849, 1.294866681098938], [0, 0.290142995353382], [0.6482623219490051, 0]]
              }
            },
            "_render": true
          }, {
            "ty": "fl",
            "c": {
              "a": 0,
              "k": [1, 1, 1],
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "r": 1,
            "bm": 0,
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [186.1193084716797, 182.03805541992188],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [0.6482623219490051, 0.647433340549469],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, -100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 180,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": -180,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "gr",
          "nm": "Vector",
          "it": [{
            "ty": "sh",
            "d": 1,
            "ks": {
              "a": 0,
              "k": {
                "c": true,
                "v": [[0.6482623219490051, 0], [1.2965246438980103, 0.6474332623287768], [0.6482623219490051, 1.2956955432891846], [0, 0.6474332623287768], [0.6482623219490051, 0]],
                "i": [[0.6482623219490051, 0], [1.2965246438980103, 0.2901429330314791], [1.0063816678157254, 1.2956955432891846], [0, 1.0055525855521794], [0.2901429760822849, 0]],
                "o": [[1.0063816678157254, 0], [1.2965246438980103, 1.0055525855521794], [0.2901429760822849, 1.2956955432891846], [0, 0.2901429330314791], [0.6482623219490051, 0]]
              }
            },
            "_render": true
          }, {
            "ty": "fl",
            "c": {
              "a": 0,
              "k": [1, 1, 1],
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "r": 1,
            "bm": 0,
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [178.8829803466797, 192.00172424316406],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [0.6482623219490051, 0.6478477716445923],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, -100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 180,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": -180,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "gr",
          "nm": "Vector",
          "it": [{
            "ty": "sh",
            "d": 1,
            "ks": {
              "a": 0,
              "k": {
                "c": true,
                "v": [[0.6482623219490051, 0], [1.2965246438980103, 0.647433340549469], [0.6482623219490051, 1.294866681098938], [0, 0.647433340549469], [0.6482623219490051, 0]],
                "i": [[0.6482623219490051, 0], [1.2965246438980103, 0.290142995353382], [1.0063816678157254, 1.294866681098938], [0, 1.0055526797085497], [0.2901429760822849, 0]],
                "o": [[1.0063816678157254, 0], [1.2965246438980103, 1.0055526797085497], [0.2901429760822849, 1.294866681098938], [0, 0.290142995353382], [0.6482623219490051, 0]]
              }
            },
            "_render": true
          }, {
            "ty": "fl",
            "c": {
              "a": 0,
              "k": [1, 1, 1],
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "r": 1,
            "bm": 0,
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [178.8829803466797, 204.31259155273438],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [0.6482623219490051, 0.647433340549469],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, -100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 180,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": -180,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "gr",
          "nm": "Vector",
          "it": [{
            "ty": "sh",
            "d": 1,
            "ks": {
              "a": 0,
              "k": {
                "c": true,
                "v": [[0.6482623219490051, 0], [1.2965246438980103, 0.6474332623287768], [0.6482623219490051, 1.2956955432891846], [0, 0.6474332623287768], [0.6482623219490051, 0]],
                "i": [[0.6482623219490051, 0], [1.2965246438980103, 0.2901429330314791], [1.0063816678157254, 1.2956955432891846], [0, 1.0055525855521794], [0.2901429760822849, 0]],
                "o": [[1.0063816678157254, 0], [1.2965246438980103, 1.0055525855521794], [0.2901429760822849, 1.2956955432891846], [0, 0.2901429330314791], [0.6482623219490051, 0]]
              }
            },
            "_render": true
          }, {
            "ty": "fl",
            "c": {
              "a": 0,
              "k": [1, 1, 1],
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "r": 1,
            "bm": 0,
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [186.1193084716797, 214.26832580566406],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [0.6482623219490051, 0.6478477716445923],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, -100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 180,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": -180,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "gr",
          "nm": "Vector",
          "it": [{
            "ty": "sh",
            "d": 1,
            "ks": {
              "a": 0,
              "k": {
                "c": true,
                "v": [[0.647433311739829, 0], [1.2956955432891846, 0.6474332623287768], [0.647433311739829, 1.2956955432891846], [0, 0.6474332623287768], [0.647433311739829, 0]],
                "i": [[0.647433311739829, 0], [1.2956955432891846, 0.2901429330314791], [1.0055526349632316, 1.2956955432891846], [0, 1.0055525855521794], [0.2893139885164264, 0]],
                "o": [[1.0055526349632316, 0], [1.2956955432891846, 1.0055525855521794], [0.2893139885164264, 1.2956955432891846], [0, 0.2901429330314791], [0.647433311739829, 0]]
              }
            },
            "_render": true
          }, {
            "ty": "fl",
            "c": {
              "a": 0,
              "k": [1, 1, 1],
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "r": 1,
            "bm": 0,
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [197.82676696777344, 218.07313537597656],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [0.6478477716445923, 0.6478477716445923],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, -100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 180,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": -180,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "gr",
          "nm": "Vector",
          "it": [{
            "ty": "sh",
            "d": 1,
            "ks": {
              "a": 0,
              "k": {
                "c": true,
                "v": [[0.6482623219490051, 0], [1.2965246438980103, 0.6474332623287768], [0.6482623219490051, 1.2956955432891846], [0, 0.6474332623287768], [0.6482623219490051, 0]],
                "i": [[0.6482623219490051, 0], [1.2965246438980103, 0.2901429330314791], [1.0063816678157254, 1.2956955432891846], [0, 1.0055525855521794], [0.2901429760822849, 0]],
                "o": [[1.0063816678157254, 0], [1.2965246438980103, 1.0055525855521794], [0.2901429760822849, 1.2956955432891846], [0, 0.2901429330314791], [0.6482623219490051, 0]]
              }
            },
            "_render": true
          }, {
            "ty": "fl",
            "c": {
              "a": 0,
              "k": [1, 1, 1],
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "r": 1,
            "bm": 0,
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [209.5333709716797, 214.26832580566406],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [0.6482623219490051, 0.6478477716445923],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, -100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 180,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": -180,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "gr",
          "nm": "Vector",
          "it": [{
            "ty": "sh",
            "d": 1,
            "ks": {
              "a": 0,
              "k": {
                "c": true,
                "v": [[0.6482623219490051, 0], [1.2965246438980103, 0.647433340549469], [0.6482623219490051, 1.294866681098938], [0, 0.647433340549469], [0.6482623219490051, 0]],
                "i": [[0.6482623219490051, 0], [1.2965246438980103, 0.290142995353382], [1.0063816678157254, 1.294866681098938], [0, 1.0055526797085497], [0.2901429760822849, 0]],
                "o": [[1.0063816678157254, 0], [1.2965246438980103, 1.0055526797085497], [0.2901429760822849, 1.294866681098938], [0, 0.290142995353382], [0.6482623219490051, 0]]
              }
            },
            "_render": true
          }, {
            "ty": "fl",
            "c": {
              "a": 0,
              "k": [1, 1, 1],
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "r": 1,
            "bm": 0,
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [216.7696990966797, 204.31259155273438],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [0.6482623219490051, 0.647433340549469],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, -100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 180,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": -180,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "gr",
          "nm": "Vector",
          "it": [{
            "ty": "sh",
            "d": 1,
            "ks": {
              "a": 0,
              "k": {
                "c": true,
                "v": [[0.6482623219490051, 0], [1.2965246438980103, 0.6474332623287768], [0.6482623219490051, 1.2956955432891846], [0, 0.6474332623287768], [0.6482623219490051, 0]],
                "i": [[0.6482623219490051, 0], [1.2965246438980103, 0.2901429330314791], [1.0063816678157254, 1.2956955432891846], [0, 1.0055525855521794], [0.2901429760822849, 0]],
                "o": [[1.0063816678157254, 0], [1.2965246438980103, 1.0055525855521794], [0.2901429760822849, 1.2956955432891846], [0, 0.2901429330314791], [0.6482623219490051, 0]]
              }
            },
            "_render": true
          }, {
            "ty": "fl",
            "c": {
              "a": 0,
              "k": [1, 1, 1],
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "r": 1,
            "bm": 0,
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [216.7696990966797, 192.00172424316406],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [0.6482623219490051, 0.6478477716445923],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, -100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 180,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": -180,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "gr",
          "nm": "Vector",
          "it": [{
            "ty": "sh",
            "d": 1,
            "ks": {
              "a": 0,
              "k": {
                "c": true,
                "v": [[0.6482623219490051, 0], [1.2965246438980103, 0.647433340549469], [0.6482623219490051, 1.294866681098938], [0, 0.647433340549469], [0.6482623219490051, 0]],
                "i": [[0.6482623219490051, 0], [1.2965246438980103, 0.290142995353382], [1.0063816678157254, 1.294866681098938], [0, 1.0055526797085497], [0.2901429760822849, 0]],
                "o": [[1.0063816678157254, 0], [1.2965246438980103, 1.0055526797085497], [0.2901429760822849, 1.294866681098938], [0, 0.290142995353382], [0.6482623219490051, 0]]
              }
            },
            "_render": true
          }, {
            "ty": "fl",
            "c": {
              "a": 0,
              "k": [1, 1, 1],
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "r": 1,
            "bm": 0,
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [209.5333709716797, 182.03805541992188],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [0.6482623219490051, 0.647433340549469],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, -100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 180,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": -180,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "gr",
          "nm": "Vector",
          "it": [{
            "ty": "sh",
            "d": 1,
            "ks": {
              "a": 0,
              "k": {
                "c": true,
                "v": [[0.647433311739829, 0], [1.2956955432891846, 0.647433340549469], [0.647433311739829, 1.294866681098938], [0, 0.647433340549469], [0.647433311739829, 0]],
                "i": [[0.647433311739829, 0], [1.2956955432891846, 0.290142995353382], [1.0055526349632316, 1.294866681098938], [0, 1.0055526797085497], [0.2893139885164264, 0]],
                "o": [[1.0055526349632316, 0], [1.2956955432891846, 1.0055526797085497], [0.2893139885164264, 1.294866681098938], [0, 0.290142995353382], [0.647433311739829, 0]]
              }
            },
            "_render": true
          }, {
            "ty": "fl",
            "c": {
              "a": 0,
              "k": [1, 1, 1],
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "r": 1,
            "bm": 0,
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [197.82676696777344, 178.24118041992188],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [0.6478477716445923, 0.647433340549469],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, -100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 180,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": -180,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "tr",
          "p": {
            "a": 0,
            "k": [60.534461975097656, 83.54061126708984],
            "ix": 2
          },
          "a": {
            "a": 0,
            "k": [197.82634735107422, 198.1573715209961],
            "ix": 2
          },
          "s": {
            "a": 0,
            "k": [109.14504528045654, 109.14504528045654],
            "ix": 2
          },
          "r": {
            "a": 0,
            "k": 0,
            "ix": 2
          },
          "o": {
            "a": 0,
            "k": 100,
            "ix": 2
          },
          "sk": {
            "a": 0,
            "k": 0,
            "ix": 2
          },
          "sa": {
            "a": 0,
            "k": 0,
            "ix": 2
          },
          "_render": true
        }],
        "_render": true
      }, {
        "ty": "tr",
        "p": {
          "a": 0,
          "k": [0.12225324660539627, 0.3143313527107239],
          "ix": 2
        },
        "a": {
          "a": 0,
          "k": [60.23484420776367, 83.24531555175781],
          "ix": 2
        },
        "s": {
          "a": 0,
          "k": [91.62120223045349, 91.62120223045349],
          "ix": 2
        },
        "r": {
          "a": 0,
          "k": 1.876219357654918e-7,
          "ix": 2
        },
        "o": {
          "a": 0,
          "k": 100,
          "ix": 2
        },
        "sk": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "sa": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "_render": true
      }],
      "_render": true
    }],
    "ip": 0,
    "op": 121,
    "st": 0,
    "bm": 0,
    "completed": true
  }, {
    "ddd": 0,
    "ind": 11,
    "ty": 3,
    "nm": "Lock A",
    "sr": 1,
    "ks": {
      "p": {
        "a": 0,
        "k": [0.39546966552734375, 0.814178466796875],
        "ix": 2
      },
      "a": {
        "a": 0,
        "k": [21.71578025817871, 21.715373992919922],
        "ix": 2
      },
      "s": {
        "a": 0,
        "k": [100, 100],
        "ix": 2
      },
      "r": {
        "a": 0,
        "k": 0,
        "ix": 2
      },
      "o": {
        "a": 0,
        "k": 100,
        "ix": 2
      },
      "sk": {
        "a": 0,
        "k": 0,
        "ix": 2
      },
      "sa": {
        "a": 0,
        "k": 0,
        "ix": 2
      }
    },
    "ao": 0,
    "ip": 0,
    "op": 121,
    "st": 0,
    "bm": 0,
    "parent": 9,
    "completed": true
  }, {
    "ddd": 0,
    "refId": "0",
    "w": 52,
    "h": 52,
    "ind": 1,
    "ty": 0,
    "nm": "Blur",
    "sr": 1,
    "ks": {
      "p": {
        "a": 0,
        "k": [-4, -4],
        "ix": 2
      },
      "a": {
        "a": 0,
        "k": [0, 0],
        "ix": 2
      },
      "s": {
        "a": 0,
        "k": [100, 100],
        "ix": 2
      },
      "r": {
        "a": 0,
        "k": 0,
        "ix": 2
      },
      "o": {
        "a": 0,
        "k": 100,
        "ix": 2
      },
      "sk": {
        "a": 0,
        "k": 0,
        "ix": 2
      },
      "sa": {
        "a": 0,
        "k": 0,
        "ix": 2
      }
    },
    "ao": 0,
    "ip": 0,
    "op": 121,
    "st": 0,
    "bm": 0,
    "parent": 11,
    "ef": [{
      "ty": 29,
      "nm": "Gaussian Blur2",
      "mn": "ADBE Gaussian Blur 2",
      "ef": [{
        "ty": 0,
        "nm": "Blurriness",
        "mn": "ADBE Gaussian Blur 2-0001",
        "v": {
          "a": 0,
          "k": 6,
          "ix": 2
        }
      }, {
        "ty": 7,
        "nm": "Blur Dimensions",
        "mn": "ADBE Gaussian Blur 2-0002",
        "v": {
          "a": 0,
          "k": 0,
          "ix": 2
        }
      }, {
        "ty": 4,
        "nm": "Repeat Edge Pixels",
        "mn": "ADBE Gaussian Blur 2-0003",
        "v": {
          "a": 0,
          "k": 0,
          "ix": 2
        }
      }],
      "np": 1,
      "ix": 0,
      "en": 1
    }],
    "completed": true,
    "layers": [{
      "ddd": 0,
      "ind": 1,
      "ty": 4,
      "nm": "Blur",
      "sr": 1,
      "ks": {
        "p": {
          "a": 0,
          "k": [4, 4],
          "ix": 2
        },
        "a": {
          "a": 0,
          "k": [0, 0],
          "ix": 2
        },
        "s": {
          "a": 0,
          "k": [100, 100],
          "ix": 2
        },
        "r": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "o": {
          "a": 0,
          "k": 100,
          "ix": 2
        },
        "sk": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "sa": {
          "a": 0,
          "k": 0,
          "ix": 2
        }
      },
      "ao": 0,
      "shapes": [{
        "ty": "gr",
        "it": [{
          "ty": "gr",
          "nm": "Blur",
          "it": [{
            "ty": "gr",
            "nm": "Path",
            "it": [{
              "ty": "sh",
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "v": [[43.43000030517578, 21.71500015258789], [21.71500015258789, 43.43000030517578], [0, 21.71500015258789], [21.71500015258789, 0], [43.43000030517578, 21.71500015258789]],
                  "i": [[43.43000030517578, 21.71500015258789], [33.7078630647702, 43.43000030517578], [0, 33.7078630647702], [9.722137240405582, 0], [43.43000030517578, 9.722137240405582]],
                  "o": [[43.43000030517578, 33.7078630647702], [9.722137240405582, 43.43000030517578], [0, 9.722137240405582], [33.7078630647702, 0], [43.43000030517578, 21.71500015258789]]
                }
              },
              "_render": true
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [21.71500015258789, 21.71500015258789],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [21.71500015258789, 21.71500015258789],
                "ix": 2
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 2
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 2
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "_render": true
            }],
            "_render": true
          }, {
            "ty": "gr",
            "nm": "Path",
            "it": [{
              "ty": "sh",
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "v": [[1.0617037320242593, 21.234059169880997], [21.234059169880997, 41.40641460773774], [41.40641460773774, 21.234059169880997], [21.234059169880997, 1.0617037320242593], [1.0617037320242593, 21.234059169880997]],
                  "i": [[1.0617037320242593, 21.234059169880997], [10.093174299672262, 41.40641460773774], [41.40641460773774, 32.37494404008973], [32.37494404008973, 1.0617037320242593], [1.0617037320242593, 10.093174299672262]],
                  "o": [[1.0617037320242593, 32.37494404008973], [32.37494404008973, 41.40641460773774], [41.40641460773774, 10.093174299672262], [10.093174299672262, 1.0617037320242593], [1.0617037320242593, 21.234059169880997]]
                }
              },
              "_render": true
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [21.714996337890625, 21.714996337890625],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [21.234059169881, 21.234059169881],
                "ix": 2
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 2
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 2
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "_render": true
            }],
            "_render": true
          }, {
            "ty": "fl",
            "c": {
              "a": 0,
              "k": [0, 0, 0],
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "r": 1,
            "bm": 0,
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [0, 0],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [0, 0],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "tr",
          "p": {
            "a": 0,
            "k": [21.715782165527344, 21.715003967285156],
            "ix": 2
          },
          "a": {
            "a": 0,
            "k": [21.71500015258789, 21.71500015258789],
            "ix": 2
          },
          "s": {
            "a": 0,
            "k": [100, 100],
            "ix": 2
          },
          "r": {
            "a": 0,
            "k": 1.8762201477034328e-7,
            "ix": 2
          },
          "o": {
            "a": 0,
            "k": 100,
            "ix": 2
          },
          "sk": {
            "a": 0,
            "k": 0,
            "ix": 2
          },
          "sa": {
            "a": 0,
            "k": 0,
            "ix": 2
          },
          "_render": true
        }],
        "_render": true
      }],
      "ip": 0,
      "op": 121,
      "st": 0,
      "bm": 0,
      "completed": true
    }, {
      "ddd": 0,
      "ind": 2,
      "ty": 4,
      "nm": "Blur Overscan",
      "sr": 1,
      "ks": {
        "p": {
          "a": 0,
          "k": [0, 0],
          "ix": 2
        },
        "a": {
          "a": 0,
          "k": [0, 0],
          "ix": 2
        },
        "s": {
          "a": 0,
          "k": [100, 100],
          "ix": 2
        },
        "r": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "o": {
          "a": 0,
          "k": 100,
          "ix": 2
        },
        "sk": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "sa": {
          "a": 0,
          "k": 0,
          "ix": 2
        }
      },
      "ao": 0,
      "shapes": [{
        "ty": "rc",
        "d": 1,
        "s": {
          "a": 0,
          "k": [52, 52],
          "ix": 2
        },
        "p": {
          "a": 0,
          "k": [26, 26],
          "ix": 2
        },
        "r": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "_render": true
      }, {
        "ty": "fl",
        "c": {
          "a": 0,
          "k": [0, 0, 0],
          "ix": 2
        },
        "o": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "r": 1,
        "bm": 0,
        "_render": true
      }],
      "ip": 0,
      "op": 121,
      "st": 0,
      "bm": 0,
      "completed": true
    }]
  }, {
    "ddd": 0,
    "ind": 12,
    "ty": 4,
    "nm": "Lock A",
    "sr": 1,
    "ks": {
      "p": {
        "a": 0,
        "k": [0, 0],
        "ix": 2
      },
      "a": {
        "a": 0,
        "k": [0, 0],
        "ix": 2
      },
      "s": {
        "a": 0,
        "k": [100, 100],
        "ix": 2
      },
      "r": {
        "a": 0,
        "k": 0,
        "ix": 2
      },
      "o": {
        "a": 0,
        "k": 100,
        "ix": 2
      },
      "sk": {
        "a": 0,
        "k": 0,
        "ix": 2
      },
      "sa": {
        "a": 0,
        "k": 0,
        "ix": 2
      }
    },
    "ao": 0,
    "parent": 11,
    "shapes": [{
      "ty": "gr",
      "nm": "Lock A",
      "it": [{
        "ty": "sh",
        "d": 1,
        "ks": {
          "a": 0,
          "k": {
            "c": true,
            "v": [[21.716184133428804, 0], [0, 21.715373992919922], [21.716184133428804, 43.430747985839844], [43.43156051635742, 21.715373992919922], [21.716184133428804, 0]],
            "i": [[21.716184133428804, 0], [0, 9.721769482491446], [9.722578302976133, 43.430747985839844], [43.43156051635742, 33.7089785033484], [33.70898144262699, 0]],
            "o": [[9.722578302976133, 0], [0, 33.7089785033484], [33.70898144262699, 43.430747985839844], [43.43156051635742, 9.721769482491446], [21.716184133428804, 0]]
          }
        },
        "_render": true
      }, {
        "ty": "gf",
        "o": {
          "a": 0,
          "k": 100,
          "ix": 2
        },
        "r": 1,
        "bm": 0,
        "g": {
          "p": 2,
          "k": {
            "a": 0,
            "k": [0, 0.0784313725490196, 0.0784313725490196, 0.0784313725490196, 1, 0.43137254901960786, 0.43137254901960786, 0.43137254901960786, 0, 1, 1, 1],
            "ix": 2
          }
        },
        "s": {
          "a": 0,
          "k": [32.21752944550053, 41.354403389068466],
          "ix": 2
        },
        "e": {
          "a": 0,
          "k": [13.604179358156102, 0.04083957302043473],
          "ix": 2
        },
        "t": 1,
        "_render": true
      }, {
        "ty": "tr",
        "p": {
          "a": 0,
          "k": [21.715782165527344, 21.715373992919922],
          "ix": 2
        },
        "a": {
          "a": 0,
          "k": [21.71578025817871, 21.715373992919922],
          "ix": 2
        },
        "s": {
          "a": 0,
          "k": [100, -100],
          "ix": 2
        },
        "r": {
          "a": 0,
          "k": -179.9999994973283,
          "ix": 2
        },
        "o": {
          "a": 0,
          "k": 100,
          "ix": 2
        },
        "sk": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "sa": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "_render": true
      }],
      "_render": true
    }],
    "ip": 0,
    "op": 121,
    "st": 0,
    "bm": 0,
    "completed": true
  }, {
    "ddd": 0,
    "ind": 13,
    "ty": 3,
    "nm": "Lcok B 1",
    "sr": 1,
    "ks": {
      "p": {
        "a": 0,
        "k": [-1.299890160560608, 0.03696342185139656],
        "ix": 2
      },
      "a": {
        "a": 0,
        "k": [197.81352996826172, 197.81504821777344],
        "ix": 2
      },
      "s": {
        "a": 0,
        "k": [100.00000268335543, 100.00000268335545],
        "ix": 2
      },
      "r": {
        "a": 0,
        "k": -3.9999995254690734,
        "ix": 2
      },
      "o": {
        "a": 0,
        "k": 100,
        "ix": 2
      },
      "sk": {
        "a": 0,
        "k": 0,
        "ix": 2
      },
      "sa": {
        "a": 0,
        "k": 0,
        "ix": 2
      }
    },
    "ao": 0,
    "ip": 0,
    "op": 121,
    "st": 0,
    "bm": 0,
    "parent": 6,
    "completed": true
  }, {
    "ddd": 0,
    "refId": "1",
    "w": 74,
    "h": 74,
    "ind": 3,
    "ty": 0,
    "nm": "Blur",
    "sr": 1,
    "ks": {
      "p": {
        "a": 0,
        "k": [161, 161],
        "ix": 2
      },
      "a": {
        "a": 0,
        "k": [0, 0],
        "ix": 2
      },
      "s": {
        "a": 0,
        "k": [100, 100],
        "ix": 2
      },
      "r": {
        "a": 0,
        "k": 0,
        "ix": 2
      },
      "o": {
        "a": 0,
        "k": 100,
        "ix": 2
      },
      "sk": {
        "a": 0,
        "k": 0,
        "ix": 2
      },
      "sa": {
        "a": 0,
        "k": 0,
        "ix": 2
      }
    },
    "ao": 0,
    "ip": 0,
    "op": 121,
    "st": 0,
    "bm": 0,
    "parent": 13,
    "ef": [{
      "ty": 29,
      "nm": "Gaussian Blur2",
      "mn": "ADBE Gaussian Blur 2",
      "ef": [{
        "ty": 0,
        "nm": "Blurriness",
        "mn": "ADBE Gaussian Blur 2-0001",
        "v": {
          "a": 0,
          "k": 8.67,
          "ix": 2
        }
      }, {
        "ty": 7,
        "nm": "Blur Dimensions",
        "mn": "ADBE Gaussian Blur 2-0002",
        "v": {
          "a": 0,
          "k": 0,
          "ix": 2
        }
      }, {
        "ty": 4,
        "nm": "Repeat Edge Pixels",
        "mn": "ADBE Gaussian Blur 2-0003",
        "v": {
          "a": 0,
          "k": 0,
          "ix": 2
        }
      }],
      "np": 1,
      "ix": 0,
      "en": 1
    }],
    "completed": true,
    "layers": [{
      "ddd": 0,
      "ind": 3,
      "ty": 4,
      "nm": "Blur",
      "sr": 1,
      "ks": {
        "p": {
          "a": 0,
          "k": [-161, -161],
          "ix": 2
        },
        "a": {
          "a": 0,
          "k": [0, 0],
          "ix": 2
        },
        "s": {
          "a": 0,
          "k": [100, 100],
          "ix": 2
        },
        "r": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "o": {
          "a": 0,
          "k": 100,
          "ix": 2
        },
        "sk": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "sa": {
          "a": 0,
          "k": 0,
          "ix": 2
        }
      },
      "ao": 0,
      "shapes": [{
        "ty": "gr",
        "it": [{
          "ty": "gr",
          "nm": "Blur",
          "it": [{
            "ty": "gr",
            "nm": "Path",
            "it": [{
              "ty": "sh",
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "v": [[62.83000183105469, 31.415000915527344], [31.415000915527344, 62.83000183105469], [0, 31.415000915527344], [31.415000915527344, 0], [62.83000183105469, 31.415000915527344]],
                  "i": [[62.83000183105469, 31.415000915527344], [48.7650260925293, 62.83000183105469], [0, 48.7650260925293], [14.06497573852539, 0], [62.83000183105469, 14.06497573852539]],
                  "o": [[62.83000183105469, 48.7650260925293], [14.06497573852539, 62.83000183105469], [0, 14.06497573852539], [48.7650260925293, 0], [62.83000183105469, 31.415000915527344]]
                }
              },
              "_render": true
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [31.415000915527344, 31.415000915527344],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [31.415000915527344, 31.415000915527344],
                "ix": 2
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 2
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 2
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "_render": true
            }],
            "_render": true
          }, {
            "ty": "gr",
            "nm": "Path",
            "it": [{
              "ty": "sh",
              "d": 1,
              "ks": {
                "a": 0,
                "k": {
                  "c": true,
                  "v": [[1.5707511901855469, 31.415000915527344], [31.415000915527344, 61.25925064086914], [61.25925064086914, 31.415000915527344], [31.415000915527344, 1.5707511901855469], [1.5707511901855469, 31.415000915527344]],
                  "i": [[1.5707511901855469, 31.415000915527344], [14.932476043701172, 61.25925064086914], [61.25925064086914, 47.897525787353516], [47.897525787353516, 1.5707511901855469], [1.5707511901855469, 14.932476043701172]],
                  "o": [[1.5707511901855469, 47.897525787353516], [47.897525787353516, 61.25925064086914], [61.25925064086914, 14.932476043701172], [14.932476043701172, 1.5707511901855469], [1.5707511901855469, 31.415000915527344]]
                }
              },
              "_render": true
            }, {
              "ty": "tr",
              "p": {
                "a": 0,
                "k": [31.415000915527344, 31.415000915527344],
                "ix": 2
              },
              "a": {
                "a": 0,
                "k": [31.415000915527344, 31.415000915527344],
                "ix": 2
              },
              "s": {
                "a": 0,
                "k": [100, 100],
                "ix": 2
              },
              "r": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "o": {
                "a": 0,
                "k": 100,
                "ix": 2
              },
              "sk": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "sa": {
                "a": 0,
                "k": 0,
                "ix": 2
              },
              "_render": true
            }],
            "_render": true
          }, {
            "ty": "fl",
            "c": {
              "a": 0,
              "k": [0.7098039215686275, 0.7019607843137254, 0.9490196078431372],
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 80,
              "ix": 2
            },
            "r": 1,
            "bm": 0,
            "_render": true
          }, {
            "ty": "tr",
            "p": {
              "a": 0,
              "k": [0, 0],
              "ix": 2
            },
            "a": {
              "a": 0,
              "k": [0, 0],
              "ix": 2
            },
            "s": {
              "a": 0,
              "k": [100, 100],
              "ix": 2
            },
            "r": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "o": {
              "a": 0,
              "k": 100,
              "ix": 2
            },
            "sk": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "sa": {
              "a": 0,
              "k": 0,
              "ix": 2
            },
            "_render": true
          }],
          "_render": true
        }, {
          "ty": "tr",
          "p": {
            "a": 0,
            "k": [197.81288146972656, 197.81520080566406],
            "ix": 2
          },
          "a": {
            "a": 0,
            "k": [31.415000915527344, 31.415000915527344],
            "ix": 2
          },
          "s": {
            "a": 0,
            "k": [100, 100],
            "ix": 2
          },
          "r": {
            "a": 0,
            "k": 1.8762198932590582e-7,
            "ix": 2
          },
          "o": {
            "a": 0,
            "k": 100,
            "ix": 2
          },
          "sk": {
            "a": 0,
            "k": 0,
            "ix": 2
          },
          "sa": {
            "a": 0,
            "k": 0,
            "ix": 2
          },
          "_render": true
        }],
        "_render": true
      }],
      "ip": 0,
      "op": 121,
      "st": 0,
      "bm": 0,
      "completed": true
    }, {
      "ddd": 0,
      "ind": 4,
      "ty": 4,
      "nm": "Blur Overscan",
      "sr": 1,
      "ks": {
        "p": {
          "a": 0,
          "k": [0, 0],
          "ix": 2
        },
        "a": {
          "a": 0,
          "k": [0, 0],
          "ix": 2
        },
        "s": {
          "a": 0,
          "k": [100, 100],
          "ix": 2
        },
        "r": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "o": {
          "a": 0,
          "k": 100,
          "ix": 2
        },
        "sk": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "sa": {
          "a": 0,
          "k": 0,
          "ix": 2
        }
      },
      "ao": 0,
      "shapes": [{
        "ty": "rc",
        "d": 1,
        "s": {
          "a": 0,
          "k": [74, 74],
          "ix": 2
        },
        "p": {
          "a": 0,
          "k": [37, 37],
          "ix": 2
        },
        "r": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "_render": true
      }, {
        "ty": "fl",
        "c": {
          "a": 0,
          "k": [0, 0, 0],
          "ix": 2
        },
        "o": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "r": 1,
        "bm": 0,
        "_render": true
      }],
      "ip": 0,
      "op": 121,
      "st": 0,
      "bm": 0,
      "completed": true
    }]
  }, {
    "ddd": 0,
    "ind": 14,
    "ty": 4,
    "nm": "Lcok B",
    "sr": 1,
    "ks": {
      "p": {
        "a": 0,
        "k": [0, 0],
        "ix": 2
      },
      "a": {
        "a": 0,
        "k": [0, 0],
        "ix": 2
      },
      "s": {
        "a": 0,
        "k": [100, 100],
        "ix": 2
      },
      "r": {
        "a": 0,
        "k": 0,
        "ix": 2
      },
      "o": {
        "a": 0,
        "k": 100,
        "ix": 2
      },
      "sk": {
        "a": 0,
        "k": 0,
        "ix": 2
      },
      "sa": {
        "a": 0,
        "k": 0,
        "ix": 2
      }
    },
    "ao": 0,
    "parent": 13,
    "shapes": [{
      "ty": "gr",
      "nm": "Lcok B",
      "it": [{
        "ty": "sh",
        "d": 1,
        "ks": {
          "a": 0,
          "k": {
            "c": true,
            "v": [[31.414165496826172, 0], [0, 31.413225173950195], [31.414165496826172, 62.82645034790039], [62.827388763427734, 31.413225173950195], [31.414165496826172, 0]],
            "i": [[31.414165496826172, 0], [0, 14.062995910644531], [14.064876556396484, 62.82645034790039], [62.827388763427734, 48.76251411437988], [48.76345443725586, 0]],
            "o": [[14.064876556396484, 0], [0, 48.76251411437988], [48.76345443725586, 62.82645034790039], [62.827388763427734, 14.062995910644531], [31.414165496826172, 0]]
          }
        },
        "_render": true
      }, {
        "ty": "fl",
        "c": {
          "a": 0,
          "k": [0.09803921568627451, 0.09411764705882353, 0.10588235294117647],
          "ix": 2
        },
        "o": {
          "a": 0,
          "k": 100,
          "ix": 2
        },
        "r": 1,
        "bm": 0,
        "_render": true
      }, {
        "ty": "tr",
        "p": {
          "a": 0,
          "k": [197.8155059814453, 197.8134307861328],
          "ix": 2
        },
        "a": {
          "a": 0,
          "k": [31.413694381713867, 31.413225173950195],
          "ix": 2
        },
        "s": {
          "a": 0,
          "k": [99.99999403953552, -99.99999403953552],
          "ix": 2
        },
        "r": {
          "a": 0,
          "k": 179.99999999999997,
          "ix": 2
        },
        "o": {
          "a": 0,
          "k": 100,
          "ix": 2
        },
        "sk": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "sa": {
          "a": 0,
          "k": 0,
          "ix": 2
        },
        "_render": true
      }],
      "_render": true
    }],
    "ip": 0,
    "op": 121,
    "st": 0,
    "bm": 0,
    "completed": true
  }, {
    "ddd": 0,
    "refId": "2",
    "ind": 15,
    "ty": 2,
    "nm": "BalaPng.png 1",
    "sr": 1,
    "ks": {
      "p": {
        "a": 0,
        "k": [-24.193233489990234, -51.10407638549805],
        "ix": 2
      },
      "a": {
        "a": 0,
        "k": [0, 0],
        "ix": 2
      },
      "s": {
        "a": 0,
        "k": [20, 20],
        "ix": 2
      },
      "r": {
        "a": 0,
        "k": 0,
        "ix": 2
      },
      "o": {
        "a": 0,
        "k": 100,
        "ix": 2
      },
      "sk": {
        "a": 0,
        "k": 0,
        "ix": 2
      },
      "sa": {
        "a": 0,
        "k": 0,
        "ix": 2
      }
    },
    "ao": 0,
    "ip": 0,
    "op": 121,
    "st": 0,
    "bm": 0,
    "parent": 5,
    "completed": true
  }],
  "markers": [],
  "__complete": true
};
let NgxPin = /*#__PURE__*/(() => {
  class NgxPin {
    constructor() {
      // Inject services
      this.ngxHybridService = inject(NgxHybridService);
      this.untilDestroy = inject(DestroyRef);
      // Inputs
      this.pinState = input(PinComponentStateEnum.NEW);
      this.hasAnimation = input(true);
      this.newPasswordType = input(false);
      this.enterPasswordState = input(EnterPasswordEnum.ENTER);
      this.title = input('');
      this.hint = input('');
      this.biometricText = input('ورود هوشمند دیجی‌پی');
      this.enterPasswordAnimation = EnterPasswordAnimationConst;
      this.correctPasswordAnimation = CorrectPasswordAnimationConst;
      this.wrongEnterPassword = WrongEnterPasswordConst;
      this.showBiometric = input(true);
      this.disableActions = input(false);
      // Outputs
      this.onPinCompleted = output();
      // Signals
      this.pinInputLength = signal(['', '', '', '']);
      this.pinDivs = signal(['-', '-', '-', '-']);
      this.hiddenInputValue = signal('');
      this.isFocus = signal(false);
      this.pin = signal(['', '', '', '']);
      this.textPin = signal('');
      this.isBiometricSupported = signal(false);
      this.initialized = signal(false);
      // Computed
      this.pinAnimation = computed(() => {
        switch (this.enterPasswordState()) {
          case EnterPasswordEnum.ENTER:
            return this.enterPasswordAnimation;
          case EnterPasswordEnum.CORRECT:
            return this.correctPasswordAnimation;
          case EnterPasswordEnum.WRONG:
            return this.wrongEnterPassword;
        }
      });
      this.pinAutocompleteAttribute = computed(() => {
        const state = this.pinState();
        return state === PinComponentStateEnum.NEW || state === PinComponentStateEnum.CONFIRM ? 'new-password' : this.hasStoredSetPassword() ? 'current-password' : 'new-password';
      });
      this.isBiometricAvailable = computed(() => {
        return this.showBiometric() && this.hasStoredBiometric() && this.ngxHybridService.isHybrid() && this.isBiometricSupported();
      });
      this.EnterPasswordEnum = EnterPasswordEnum;
      toObservable(this.isBiometricAvailable).pipe(takeUntilDestroyed(this.untilDestroy)).subscribe({
        next: res => {
          if (res && !this.initialized()) {
            this.enterPinWithBiometric();
            this.initialized.set(true);
          }
        }
      });
    }
    ngOnInit() {
      this.focusOnElementWithId('password');
      this.checkBiometric();
    }
    checkBiometric() {
      this.ngxHybridService.checkBiometricAvailability().then(available => {
        if (available) {
          this.isBiometricSupported.set(available);
        }
      });
    }
    hasStoredBiometric() {
      return localStorage.getItem(BiometricStorageKey) === 'true';
    }
    hasStoredSetPassword() {
      return localStorage.getItem(SetPasswordStorageKey) === 'true';
    }
    hiddenInputChange(value) {
      value = convertNonEnglishDigits(value).replace(/[^0-9]/g, '');
      this.hiddenInputValue.set(value);
      const updatedValue = Array(4).fill('');
      value.split('').slice(0, 4).forEach((char, index) => {
        updatedValue[index] = char;
      });
      this.pinInputLength.set(updatedValue);
      const pinDivValue = value.split('').map((char, index) => {
        return index < 4 ? char : '-';
      });
      this.pinDivs.set(pinDivValue);
      while (this.pinDivs().length < 4) {
        this.pinDivs().push('-');
      }
      const isFilled = updatedValue.every(char => char !== '');
      if (isFilled) {
        this.pinComplete();
        return;
      }
    }
    focusOnElementWithId(id) {
      const elem = document.getElementById(id);
      if (elem) {
        elem.focus();
      }
    }
    inputKeyDown(event) {
      if (event.key === 'Backspace' || event.key === 'Delete') {
        this.resetPin();
        return;
      }
    }
    pinComplete() {
      this.textPin.set(this.pinInputLength().join(''));
      this.onPinCompleted.emit(this.textPin());
    }
    resetPin() {
      this.pinInputLength.set(['', '', '', '']);
      this.pinDivs.set(['-', '-', '-', '-']);
      this.hiddenInputValue.set('');
      this.focusOnElementWithId('password');
    }
    onDivClicked() {
      this.focusOnElementWithId('password');
    }
    enterPinWithBiometric() {
      if (this.disableActions()) return;
      this.ngxHybridService.authenticateBiometric().pipe(takeUntilDestroyed(this.untilDestroy)).subscribe({
        next: result => {
          if (result) {
            this.ngxHybridService.getPin().then(pin => {
              if (pin) {
                this.hiddenInputChange(pin);
              }
            });
          }
        }
      });
    }
    static {
      this.ɵfac = function NgxPin_Factory(t) {
        return new (t || NgxPin)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NgxPin,
        selectors: [["ngx-pin"]],
        inputs: {
          pinState: [i0.ɵɵInputFlags.SignalBased, "pinState"],
          hasAnimation: [i0.ɵɵInputFlags.SignalBased, "hasAnimation"],
          newPasswordType: [i0.ɵɵInputFlags.SignalBased, "newPasswordType"],
          enterPasswordState: [i0.ɵɵInputFlags.SignalBased, "enterPasswordState"],
          title: [i0.ɵɵInputFlags.SignalBased, "title"],
          hint: [i0.ɵɵInputFlags.SignalBased, "hint"],
          biometricText: [i0.ɵɵInputFlags.SignalBased, "biometricText"],
          showBiometric: [i0.ɵɵInputFlags.SignalBased, "showBiometric"],
          disableActions: [i0.ɵɵInputFlags.SignalBased, "disableActions"]
        },
        outputs: {
          onPinCompleted: "onPinCompleted"
        },
        standalone: true,
        features: [i0.ɵɵProvidersFeature([AnimationLoader, provideLottieOptions({
          player: () => player
        })]), i0.ɵɵStandaloneFeature],
        decls: 13,
        vars: 9,
        consts: [["autocomplete", "on", 1, "w-100"], [1, "w-100", "ltr", "d-flex", "justify-content-center", "align-items-center", "flex-column"], [1, "background"], [1, "b-1", "pb-plus", "m-atom", "text-onback-medium", "rtl"], [1, "pin-container", "surface-elevated", "px-big", "border-100", "py-plus", "d-flex", "align-items-center", "radius-large", 3, "ngClass"], ["type", "password", "name", "password", "id", "password", "inputmode", "numeric", "maxlength", "4", 1, "hidden-input", "w-100", 3, "focus", "focusout", "ngModelChange", "keydown", "ngModel", "disabled", "autocomplete"], ["type", "text", "name", "username", "value", "Digipay", "aria-hidden", "true", 1, "d-none", 3, "autocomplete"], [1, "pin-divs", "px-big", "py-plus", 3, "click"], [1, "circle"], [1, "text-onback-medium", "l-3", "pt-pony", "rtl", 3, "ngClass"], [1, "d-flex", "flex-column", "align-items-center", "pt-big"], [1, "pin-background"], [1, "animation", 3, "options"], [3, "ngClass"], [1, "d-flex", "flex-column", "align-items-center", "pt-big", 3, "click"], [1, "biometric-icon"], [1, "b-2", "text-onback-high", "pt-low"]],
        template: function NgxPin_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "form", 0)(1, "div", 1);
            i0.ɵɵtemplate(2, NgxPin_Conditional_2_Template, 3, 3, "div", 2);
            i0.ɵɵelementStart(3, "p", 3);
            i0.ɵɵtext(4);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "div", 4)(6, "input", 5);
            i0.ɵɵlistener("focus", function NgxPin_Template_input_focus_6_listener() {
              return ctx.isFocus.set(true);
            })("focusout", function NgxPin_Template_input_focusout_6_listener() {
              return ctx.isFocus.set(false);
            });
            i0.ɵɵtwoWayListener("ngModelChange", function NgxPin_Template_input_ngModelChange_6_listener($event) {
              i0.ɵɵtwoWayBindingSet(ctx.hiddenInputValue, $event) || (ctx.hiddenInputValue = $event);
              return $event;
            });
            i0.ɵɵlistener("ngModelChange", function NgxPin_Template_input_ngModelChange_6_listener($event) {
              return ctx.hiddenInputChange($event);
            })("keydown", function NgxPin_Template_input_keydown_6_listener($event) {
              return ctx.inputKeyDown($event);
            });
            i0.ɵɵelementEnd();
            i0.ɵɵelement(7, "input", 6);
            i0.ɵɵelementStart(8, "div", 7);
            i0.ɵɵlistener("click", function NgxPin_Template_div_click_8_listener() {
              return ctx.onDivClicked();
            });
            i0.ɵɵrepeaterCreate(9, NgxPin_For_10_Template, 3, 5, "div", 8, i0.ɵɵrepeaterTrackByIndex);
            i0.ɵɵelementEnd()();
            i0.ɵɵtemplate(11, NgxPin_Conditional_11_Template, 2, 4, "p", 9);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(12, NgxPin_Conditional_12_Template, 4, 1, "div", 10);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(2, ctx.hasAnimation() ? 2 : -1);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.title());
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngClass", ctx.enterPasswordState() === ctx.EnterPasswordEnum.WRONG ? "border-color-error" : ctx.isFocus() ? "border-color-brand" : "border-color-light");
            i0.ɵɵadvance();
            i0.ɵɵtwoWayProperty("ngModel", ctx.hiddenInputValue);
            i0.ɵɵproperty("disabled", ctx.disableActions())("autocomplete", ctx.pinAutocompleteAttribute());
            i0.ɵɵadvance();
            i0.ɵɵproperty("autocomplete", "username");
            i0.ɵɵadvance(2);
            i0.ɵɵrepeater(ctx.pinDivs());
            i0.ɵɵadvance(2);
            i0.ɵɵconditional(11, ctx.hint() !== "" ? 11 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(12, ctx.isBiometricAvailable() ? 12 : -1);
          }
        },
        dependencies: [NgClass, FormsModule, i1.ɵNgNoValidate, i1.DefaultValueAccessor, i1.NgControlStatus, i1.NgControlStatusGroup, i1.MaxLengthValidator, i1.NgModel, i1.NgForm, LottieComponent],
        styles: ["[_ngcontent-%COMP%]:root{--shimmer-first-color: #CED2DA;--shimmer-second-color: #F1F3F7;--shimmer-third-color: #CED2DA}[_ngcontent-%COMP%]:root   .inverted[_ngcontent-%COMP%]{--shimmer-first-color: #191C23;--shimmer-second-color: #444851;--shimmer-third-color: #191C23}[_ngcontent-%COMP%]:root   .dark[_ngcontent-%COMP%]{--shimmer-first-color: #191C23;--shimmer-second-color: #444851;--shimmer-third-color: #191C23}[_ngcontent-%COMP%]:root   .dark[_ngcontent-%COMP%]   .inverted[_ngcontent-%COMP%]{--shimmer-first-color: #CED2DA;--shimmer-second-color: #F1F3F7;--shimmer-third-color: #CED2DA}[_ngcontent-%COMP%]:root{--base-font-feature-settings: \"ss01\" on, \"liga\" off, \"clig\" off}*[_ngcontent-%COMP%]{box-sizing:border-box}.pin-container[_ngcontent-%COMP%]{width:176px;height:56px;align-items:center;justify-content:center;position:relative}.pin-container[_ngcontent-%COMP%]   .hidden-input[_ngcontent-%COMP%]{letter-spacing:32px;text-align:left;padding:0;opacity:0;outline:none}.pin-divs[_ngcontent-%COMP%]{display:flex;width:100%;cursor:none;justify-content:space-between;top:0;bottom:0;position:absolute;align-items:center}.circle[_ngcontent-%COMP%]{font-size:20px;display:flex;justify-content:center;align-items:center}.circle[_ngcontent-%COMP%]   .no-content[_ngcontent-%COMP%]{color:var(--onback-shade-90)}.background[_ngcontent-%COMP%]{position:relative}.background[_ngcontent-%COMP%]   .pin-background[_ngcontent-%COMP%]{width:179px;height:179px;background:url('data:image/svg+xml,<svg width=\"179\" height=\"179\" viewBox=\"0 0 179 179\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">%0A<g opacity=\"0.52\">%0A<g filter=\"url(%23filter0_f_502_30544)\">%0A<ellipse cx=\"110.237\" cy=\"60.2583\" rx=\"16.6369\" ry=\"19.3133\" fill=\"%23FD9DB8\"/>%0A</g>%0A<g filter=\"url(%23filter1_f_502_30544)\">%0A<ellipse cx=\"67.5583\" cy=\"73.8389\" rx=\"16.6369\" ry=\"19.3133\" fill=\"%237FA6F9\"/>%0A</g>%0A<g filter=\"url(%23filter2_f_502_30544)\">%0A<ellipse cx=\"57.7423\" cy=\"118.819\" rx=\"16.6369\" ry=\"19.3133\" fill=\"%232EF3D8\"/>%0A</g>%0A<g filter=\"url(%23filter3_f_502_30544)\">%0A<ellipse cx=\"121.612\" cy=\"106.179\" rx=\"16.6369\" ry=\"19.3133\" fill=\"%23A8CEFB\"/>%0A</g>%0A</g>%0A<defs>%0A<filter id=\"filter0_f_502_30544\" x=\"53.0999\" y=\"0.445068\" width=\"114.274\" height=\"119.627\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">%0A<feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>%0A<feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"BackgroundImageFix\" result=\"shape\"/>%0A<feGaussianBlur stdDeviation=\"20.25\" result=\"effect1_foregroundBlur_502_30544\"/>%0A</filter>%0A<filter id=\"filter1_f_502_30544\" x=\"10.4214\" y=\"14.0256\" width=\"114.274\" height=\"119.627\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">%0A<feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>%0A<feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"BackgroundImageFix\" result=\"shape\"/>%0A<feGaussianBlur stdDeviation=\"20.25\" result=\"effect1_foregroundBlur_502_30544\"/>%0A</filter>%0A<filter id=\"filter2_f_502_30544\" x=\"0.605469\" y=\"59.0059\" width=\"114.274\" height=\"119.627\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">%0A<feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>%0A<feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"BackgroundImageFix\" result=\"shape\"/>%0A<feGaussianBlur stdDeviation=\"20.25\" result=\"effect1_foregroundBlur_502_30544\"/>%0A</filter>%0A<filter id=\"filter3_f_502_30544\" x=\"64.4747\" y=\"46.366\" width=\"114.274\" height=\"119.627\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">%0A<feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>%0A<feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"BackgroundImageFix\" result=\"shape\"/>%0A<feGaussianBlur stdDeviation=\"20.25\" result=\"effect1_foregroundBlur_502_30544\"/>%0A</filter>%0A</defs>%0A</svg>%0A') no-repeat center}.background[_ngcontent-%COMP%]   .animation[_ngcontent-%COMP%]{width:100%;height:100%;position:absolute;top:0}.biometric-icon[_ngcontent-%COMP%]{width:40px;height:40px;background:url('data:image/svg+xml,<svg width=\"40\" height=\"40\" viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">%0A<rect width=\"40\" height=\"40\" fill=\"url(%23pattern0_585_1431)\"/>%0A<defs>%0A<pattern id=\"pattern0_585_1431\" patternContentUnits=\"objectBoundingBox\" width=\"1\" height=\"1\">%0A<use xlink:href=\"%23image0_585_1431\" transform=\"scale(0.002)\"/>%0A</pattern>%0A<image id=\"image0_585_1431\" width=\"500\" height=\"500\" preserveAspectRatio=\"none\" xlink:href=\"data:image/png;base64,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\"/>%0A</defs>%0A</svg>%0A') no-repeat center}"],
        changeDetection: 0
      });
    }
  }
  return NgxPin;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var PinStatus = /*#__PURE__*/function (PinStatus) {
  PinStatus[PinStatus["SUCCESS"] = 0] = "SUCCESS";
  PinStatus[PinStatus["FAILED"] = 1] = "FAILED";
  PinStatus[PinStatus["BLOCKED"] = 2] = "BLOCKED";
  return PinStatus;
}(PinStatus || {});
/*
 * Public API Surface of ngx-pin
 */

/**
 * Generated bundle index. Do not edit.
 */

export { BiometricStorageKey, EnterPasswordEnum, NgxPin, PinComponentStateEnum, PinStatus, SetPasswordStorageKey };
